import * as n from "react";
import { Component as yr, useState as A, useRef as B, useEffect as G, useLayoutEffect as xe, isValidElement as cn, cloneElement as da, forwardRef as rs, useContext as Tn, createContext as qn, useMemo as we, useCallback as oe, Fragment as ss, Children as ta, createRef as os } from "react";
import { createPortal as fa } from "react-dom";
import { a as ls, t as br, b as cs, f as is } from "./format-BpCURHRA.js";
const us = "_page_1l6cf_5", ms = "_inner_1l6cf_25", ds = "_pageScroll_1l6cf_38", fs = "_innerScroll_1l6cf_39", yn = {
  page: us,
  inner: ms,
  pageScroll: ds,
  innerScroll: fs
};
function _s({
  gnbHeight: e = 64,
  minWidth: t = 1024,
  scroll: a = "grid",
  className: r = "",
  style: s,
  children: o
}) {
  const l = a === "page";
  return /* @__PURE__ */ n.createElement(
    "main",
    {
      className: [yn.page, l && yn.pageScroll, "axe-page", r].filter(Boolean).join(" "),
      style: { height: `calc(100vh - ${e}px)`, ...s }
    },
    /* @__PURE__ */ n.createElement("div", { className: [yn.inner, l && yn.innerScroll].filter(Boolean).join(" "), style: { minWidth: t } }, o)
  );
}
const ps = "_body_1wgsn_4", ys = {
  body: ps
};
function Rv({ className: e = "", style: t, children: a }) {
  return /* @__PURE__ */ n.createElement("div", { className: [ys.body, "axe-page-body", e].filter(Boolean).join(" "), style: t }, a);
}
const bs = "_orbitPortalRoot_177qv_2", Es = {
  orbitPortalRoot: bs
};
class Ut extends yr {
  constructor() {
    super(...arguments), this.getPortalRoot = () => {
      const t = this.props.portalClassName || Es.orbitPortalRoot, a = Array.from(document.body.childNodes).find((r) => r.className === t);
      if (!a) {
        const r = document.createElement("div");
        return r.className = t, document.body.appendChild(r), r;
      }
      return a;
    };
  }
  render() {
    return fa(this.props.children, this.getPortalRoot());
  }
}
const hs = "_anchor_7h2m7_2", gs = "_tip_7h2m7_5", wa = {
  anchor: hs,
  tip: gs
};
let vs = 0;
function jt({
  content: e,
  children: t,
  placement: a = "bottom",
  delay: r = 250,
  focusable: s,
  describe: o = !0,
  className: l = "",
  keepWrapper: c
}) {
  const [i, u] = A(!1), [m, f] = A({ top: 0, left: 0 }), _ = B(null), p = B(null), y = B(null), d = B("");
  d.current || (d.current = `axe-tip-${++vs}`);
  const b = () => {
    y.current && (clearTimeout(y.current), y.current = null);
  }, w = (h) => {
    b(), h <= 0 ? u(!0) : y.current = setTimeout(() => u(!0), h);
  }, N = () => {
    b(), u(!1);
  };
  G(() => b, []), xe(() => {
    if (!i) return;
    const h = () => {
      const v = _.current, E = p.current;
      if (!v || !E) return;
      const x = v.getBoundingClientRect(), C = E.offsetHeight, M = E.offsetWidth;
      let T = a === "top" ? x.top - C - 6 : x.bottom + 6;
      a === "bottom" && T + C > window.innerHeight - 4 && x.top - C - 6 > 4 && (T = x.top - C - 6), a === "top" && T < 4 && x.bottom + 6 + C < window.innerHeight - 4 && (T = x.bottom + 6);
      const I = Math.max(4, Math.min(x.left + x.width / 2 - M / 2, window.innerWidth - M - 4));
      f((q) => q.top === T && q.left === I ? q : { top: T, left: I });
    };
    return h(), window.addEventListener("resize", h), window.addEventListener("scroll", h, !0), () => {
      window.removeEventListener("resize", h), window.removeEventListener("scroll", h, !0);
    };
  }, [i, a, e]), G(() => {
    if (!i) return;
    const h = (v) => {
      v.key !== "Escape" || v.isComposing || (v.preventDefault(), v.stopPropagation(), N());
    };
    return document.addEventListener("keydown", h, !0), () => document.removeEventListener("keydown", h, !0);
  }, [i]);
  const g = e != null && e !== !1 && e !== "";
  if (!g && !c) return t;
  const $ = g && cn(t) ? da(t, i && o ? { "aria-describedby": d.current } : {}) : t;
  return /* @__PURE__ */ n.createElement(
    "span",
    {
      ref: _,
      className: [wa.anchor, l].filter(Boolean).join(" "),
      tabIndex: s ? 0 : void 0,
      onMouseEnter: () => {
        g && w(r);
      },
      onMouseLeave: N,
      onFocus: () => {
        g && w(0);
      },
      onBlur: N
    },
    $,
    g && i && /* @__PURE__ */ n.createElement(Ut, null, /* @__PURE__ */ n.createElement(
      "div",
      {
        ref: p,
        id: d.current,
        role: "tooltip",
        className: wa.tip,
        style: { top: m.top, left: m.left },
        onMouseEnter: b,
        onMouseLeave: N
      },
      e
    ))
  );
}
const ks = "_bar_gkpv7_1", ws = "_menu_gkpv7_17", Ns = "_title_gkpv7_27", $s = "_info_gkpv7_29", xs = "_badge_gkpv7_37", Ds = "_badge_muted_gkpv7_38", As = "_badge_ok_gkpv7_39", Cs = "_badge_warn_gkpv7_40", Ss = "_meta_gkpv7_42", Ms = "_actions_gkpv7_26", Ts = "_notice_gkpv7_59", qs = "_notice_info_gkpv7_65", Bs = "_notice_ok_gkpv7_66", Ls = "_notice_err_gkpv7_67", Ye = {
  bar: ks,
  menu: ws,
  title: Ns,
  info: $s,
  badge: xs,
  badge_muted: Ds,
  badge_ok: As,
  badge_warn: Cs,
  meta: Ss,
  actions: Ms,
  notice: Ts,
  notice_info: qs,
  notice_ok: Bs,
  notice_err: Ls
};
function js({
  title: e,
  onMenu: t,
  info: a,
  badge: r,
  meta: s,
  notice: o,
  children: l
}) {
  var c;
  return /* @__PURE__ */ n.createElement("header", { className: Ye.bar }, t && /* @__PURE__ */ n.createElement("button", { type: "button", className: Ye.menu, "aria-label": "메뉴", onClick: t }, "☰"), /* @__PURE__ */ n.createElement("h1", { className: Ye.title }, e), a && /* @__PURE__ */ n.createElement(jt, { content: a, focusable: !0, describe: !1 }, /* @__PURE__ */ n.createElement("span", { className: Ye.info, role: "img", "aria-label": `안내: ${typeof a == "string" ? a : "자세히"}` }, "i")), (Array.isArray(r) ? r : [r]).filter(Boolean).map((i, u) => {
    var m;
    return /* @__PURE__ */ n.createElement("span", { key: u, className: [Ye.badge, Ye[`badge_${(m = i.tone) != null ? m : "muted"}`]].join(" ") }, i.label);
  }), s && /* @__PURE__ */ n.createElement("span", { className: Ye.meta }, s), /* @__PURE__ */ n.createElement("span", { className: Ye.actions }, o && o.text && /* @__PURE__ */ n.createElement("span", { className: [Ye.notice, Ye[`notice_${(c = o.tone) != null ? c : "info"}`]].join(" "), role: o.tone === "err" ? "alert" : "status" }, o.text), l));
}
const Rs = {
  print: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("path", { d: "M7 8V4h10v4" }), /* @__PURE__ */ n.createElement("path", { d: "M7 16H5.5A2.5 2.5 0 0 1 3 13.5v-3A2.5 2.5 0 0 1 5.5 8h13A2.5 2.5 0 0 1 21 10.5v3a2.5 2.5 0 0 1-2.5 2.5H17" }), /* @__PURE__ */ n.createElement("rect", { x: "7", y: "13", width: "10", height: "7", rx: "1" })),
  download: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("path", { d: "M12 4v11" }), /* @__PURE__ */ n.createElement("path", { d: "M7.5 11l4.5 4.5 4.5-4.5" }), /* @__PURE__ */ n.createElement("path", { d: "M5 20h14" })),
  edit: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("path", { d: "M4 20h4L19 9a2.1 2.1 0 0 0-3-3L5 17v3z" }), /* @__PURE__ */ n.createElement("path", { d: "M14.5 7.5l3 3" })),
  /* 코드도움·찾기 — 돋보기. 글꼴마다 모양이 다른 문자(⌕ ▦)를 쓰지 않는다 */
  search: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("circle", { cx: "10.5", cy: "10.5", r: "6" }), /* @__PURE__ */ n.createElement("path", { d: "M15 15l5.5 5.5" })),
  /* 날짜 선택 — 달력. 윗변 고리 두 개 + 머리줄 */
  calendar: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("rect", { x: "4", y: "5.5", width: "16", height: "14.5", rx: "2" }), /* @__PURE__ */ n.createElement("path", { d: "M4 10h16" }), /* @__PURE__ */ n.createElement("path", { d: "M8.5 3.5v4M15.5 3.5v4" })),
  trash: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("path", { d: "M4 7h16" }), /* @__PURE__ */ n.createElement("path", { d: "M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" }), /* @__PURE__ */ n.createElement("path", { d: "M6.2 7l.9 12.1A2 2 0 0 0 9.1 21h5.8a2 2 0 0 0 2-1.9L17.8 7" }), /* @__PURE__ */ n.createElement("path", { d: "M10 11v6M14 11v6" }))
}, Is = {
  panel: "▣",
  "chevron-open": "∨",
  "chevron-closed": "＞",
  collapse: "◀",
  expand: "▶",
  mail: "✉",
  chat: "💬",
  save: "💾",
  close: "✕"
};
function Os({ name: e, className: t }) {
  return /* @__PURE__ */ n.createElement("span", { className: t, "aria-hidden": "true" }, Is[e]);
}
function un({ name: e, size: t = 15, className: a }) {
  return /* @__PURE__ */ n.createElement(
    "svg",
    {
      className: a,
      width: t,
      height: t,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.8",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      style: { verticalAlign: "-2px" },
      "aria-hidden": "true"
    },
    Rs[e]
  );
}
const Ps = "_btn_a0orf_1", Xs = "_sm_a0orf_18", zs = "_primary_a0orf_21", Fs = "_dark_a0orf_23", Hs = "_danger_a0orf_25", Ws = "_soon_a0orf_29", Ks = "_soonTag_a0orf_30", Us = "_blocked_a0orf_39", Gs = "_kbd_a0orf_51", Ys = "_iconBtn_a0orf_54", Vs = "_link_a0orf_70", ut = {
  btn: Ps,
  sm: Xs,
  primary: zs,
  dark: Fs,
  danger: Hs,
  soon: Ws,
  soonTag: Ks,
  blocked: Us,
  kbd: Gs,
  iconBtn: Ys,
  link: Vs
}, mt = rs(function(t, a) {
  const {
    variant: r = "default",
    size: s = "md",
    icon: o,
    kbd: l,
    soon: c,
    blockedReason: i,
    children: u,
    className: m = "",
    type: f = "button",
    onClick: _,
    title: p,
    disabled: y,
    ...d
  } = t, b = c || i || "", w = b !== "", N = "blockedReason" in t, g = /* @__PURE__ */ n.createElement(
    "button",
    {
      ref: a,
      type: f,
      className: [ut.btn, ut[r], s === "sm" ? ut.sm : "", c ? ut.soon : w ? ut.blocked : "", m].filter(Boolean).join(" "),
      "aria-disabled": w ? !0 : void 0,
      disabled: w ? void 0 : y,
      title: w ? void 0 : p,
      onClick: w ? ($) => $.preventDefault() : _,
      ...d
    },
    o && /* @__PURE__ */ n.createElement(un, { name: o, size: s === "sm" ? 12 : 14 }),
    u,
    l && /* @__PURE__ */ n.createElement("kbd", { className: ut.kbd }, l),
    c && /* @__PURE__ */ n.createElement("em", { className: ut.soonTag }, "준비 중")
  );
  return w || N ? /* @__PURE__ */ n.createElement(jt, { content: b, keepWrapper: N }, g) : g;
});
function na({ label: e, children: t, className: a = "", type: r = "button", ...s }) {
  return /* @__PURE__ */ n.createElement(jt, { content: e, describe: !1 }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: r,
      className: [ut.iconBtn, a].filter(Boolean).join(" "),
      "aria-label": e,
      ...s
    },
    t
  ));
}
function _a({ children: e, className: t = "", type: a = "button", ...r }) {
  return /* @__PURE__ */ n.createElement("button", { type: a, className: [ut.link, t].filter(Boolean).join(" "), ...r }, e);
}
const Qs = "_wrap_10shm_1", Js = "_btn_10shm_2", Zs = "_on_10shm_6", eo = "_caret_10shm_8", to = "_pop_10shm_9", no = "_sec_10shm_14", ao = "_item_10shm_17", ro = "_danger_10shm_24", yt = {
  wrap: Qs,
  btn: Js,
  on: Zs,
  caret: eo,
  pop: to,
  sec: no,
  item: ao,
  danger: ro
}, so = (e, t, a, r = {}) => ({ kind: "item", key: e, label: t, onClick: a, ...r }), Iv = (e, t, a) => ({ kind: "section", key: e, label: t, note: a });
function oo({ label: e, entries: t, disabled: a, title: r }) {
  const [s, o] = A(!1), l = B(null), c = B(null), i = B(null), u = () => {
    var f, _;
    return Array.from((_ = (f = i.current) == null ? void 0 : f.querySelectorAll("[role=menuitem]:not(:disabled)")) != null ? _ : []);
  };
  G(() => {
    var f;
    s && ((f = u()[0]) == null || f.focus());
  }, [s]), G(() => {
    if (!s) return;
    const f = (p) => {
      l.current && !l.current.contains(p.target) && o(!1);
    }, _ = (p) => {
      var y;
      p.key !== "Escape" || p.isComposing || (p.preventDefault(), p.stopPropagation(), o(!1), (y = c.current) == null || y.focus());
    };
    return document.addEventListener("mousedown", f), document.addEventListener("keydown", _, !0), () => {
      document.removeEventListener("mousedown", f), document.removeEventListener("keydown", _, !0);
    };
  }, [s]);
  const m = (f) => {
    const _ = u();
    if (_.length === 0) return;
    const p = _.indexOf(document.activeElement);
    let y = -1;
    if (f.key === "ArrowDown") y = (p + 1) % _.length;
    else if (f.key === "ArrowUp") y = (p <= 0 ? _.length : p) - 1;
    else if (f.key === "Home") y = 0;
    else if (f.key === "End") y = _.length - 1;
    else if (f.key === "Tab") {
      o(!1);
      return;
    } else return;
    f.preventDefault(), _[y].focus();
  };
  return /* @__PURE__ */ n.createElement("span", { className: yt.wrap, ref: l }, /* @__PURE__ */ n.createElement(jt, { content: s ? void 0 : r, keepWrapper: !0 }, /* @__PURE__ */ n.createElement(
    "button",
    {
      ref: c,
      type: "button",
      className: [yt.btn, s ? yt.on : ""].join(" "),
      disabled: a,
      "aria-haspopup": "menu",
      "aria-expanded": s,
      onClick: () => o((f) => !f),
      onKeyDown: (f) => {
        f.key === "ArrowDown" && !s && (f.preventDefault(), o(!0));
      }
    },
    e,
    /* @__PURE__ */ n.createElement("span", { className: yt.caret, "aria-hidden": "true" }, "▾")
  )), s && /* @__PURE__ */ n.createElement("div", { ref: i, className: yt.pop, role: "menu", onKeyDown: m }, t.map((f) => f.kind === "section" ? /* @__PURE__ */ n.createElement("div", { key: f.key, className: yt.sec }, f.label, f.note && /* @__PURE__ */ n.createElement("small", null, f.note)) : /* @__PURE__ */ n.createElement(
    "button",
    {
      key: f.key,
      type: "button",
      role: "menuitem",
      disabled: f.disabled,
      className: [yt.item, f.danger ? yt.danger : ""].join(" "),
      onClick: () => {
        var _;
        o(!1), (_ = c.current) == null || _.focus(), f.onClick();
      }
    },
    /* @__PURE__ */ n.createElement("span", null, f.label),
    f.disabled && f.reason && /* @__PURE__ */ n.createElement("small", null, f.reason)
  ))));
}
const lo = "_pop_12uut_2", co = "_auto_12uut_12", io = "_head_12uut_13", uo = "_title_12uut_18", mo = "_close_12uut_19", fo = "_body_12uut_21", _o = "_flush_12uut_22", po = "_foot_12uut_23", bt = {
  pop: lo,
  auto: co,
  head: io,
  title: uo,
  close: mo,
  body: fo,
  flush: _o,
  foot: po
}, bn = 8;
function Ov({
  x: e,
  y: t,
  title: a,
  ariaLabel: r,
  onClose: s,
  children: o,
  footer: l,
  closeLabel: c = "닫기",
  width: i,
  closeOnScroll: u = !1,
  flush: m = !1,
  initialFocus: f,
  className: _
}) {
  const p = B(null), [y, d] = A({ left: e, top: t }), b = B(s);
  b.current = s;
  const w = () => {
    const g = p.current;
    if (!g) return;
    const $ = g.offsetWidth, h = g.offsetHeight, v = Math.max(bn, Math.min(e, window.innerWidth - $ - bn)), E = t + h > window.innerHeight - bn ? Math.max(bn, t - h - 32) : t;
    d((x) => x.left === v && x.top === E ? x : { left: v, top: E });
  };
  xe(w, [e, t]), G(() => {
    const g = p.current;
    if (!g || typeof ResizeObserver == "undefined") return;
    const $ = new ResizeObserver(w);
    return $.observe(g), () => $.disconnect();
  }, [e, t]), G(() => {
    const g = (E) => {
      p.current && !p.current.contains(E.target) && b.current(!1);
    }, $ = (E) => {
      E.key === "Escape" && (E.stopPropagation(), b.current(!0));
    }, h = (E) => {
      var x;
      (!(E.target instanceof Node) || !((x = p.current) != null && x.contains(E.target))) && b.current(!1);
    }, v = window.setTimeout(() => document.addEventListener("mousedown", g), 0);
    return document.addEventListener("keydown", $, !0), u && window.addEventListener("scroll", h, !0), () => {
      window.clearTimeout(v), document.removeEventListener("mousedown", g), document.removeEventListener("keydown", $, !0), window.removeEventListener("scroll", h, !0);
    };
  }, [u]), G(() => {
    var g, $;
    f && (($ = (g = p.current) == null ? void 0 : g.querySelector(f)) == null || $.focus());
  }, [f]);
  const N = /* @__PURE__ */ n.createElement(
    "div",
    {
      ref: p,
      className: `${bt.pop}${i ? "" : ` ${bt.auto}`}${_ ? ` ${_}` : ""}`,
      style: { left: y.left, top: y.top, ...i ? { width: i } : null },
      role: "dialog",
      "aria-label": r
    },
    /* @__PURE__ */ n.createElement("div", { className: bt.head }, /* @__PURE__ */ n.createElement("span", { className: bt.title }, a), /* @__PURE__ */ n.createElement("button", { type: "button", className: bt.close, onClick: () => b.current(!0), "aria-label": c }, "✕")),
    /* @__PURE__ */ n.createElement("div", { className: `${bt.body}${m ? ` ${bt.flush}` : ""}` }, o),
    l != null && /* @__PURE__ */ n.createElement("div", { className: bt.foot }, l)
  );
  return typeof document == "undefined" ? N : fa(N, document.body);
}
const yo = "_panel_pg53c_2", bo = "_head_pg53c_3", Eo = "_kicker_pg53c_4", ho = "_actions_pg53c_5", go = "_link_pg53c_6", vo = "_menuHits_pg53c_8", ko = "_turns_pg53c_11", wo = "_turn_pg53c_11", No = "_q_pg53c_13", $o = "_a_pg53c_5", xo = "_aText_pg53c_15", Do = "_step_pg53c_16", Ao = "_caret_pg53c_17", Co = "_err_pg53c_19", Me = {
  panel: yo,
  head: bo,
  kicker: Eo,
  actions: ho,
  link: go,
  menuHits: vo,
  turns: ko,
  turn: wo,
  q: No,
  a: $o,
  aText: xo,
  step: Do,
  caret: Ao,
  err: Co
};
function Pv({ turns: e, busy: t, menuHits: a, onNavigate: r, onReset: s, onClose: o, labels: l }) {
  const c = B(null), i = e.length ? e[e.length - 1].answer.length : 0;
  return G(() => {
    var u;
    (u = c.current) == null || u.scrollIntoView({ block: "nearest" });
  }, [e.length, i]), /* @__PURE__ */ n.createElement("section", { className: Me.panel, "aria-live": "polite" }, /* @__PURE__ */ n.createElement("header", { className: Me.head }, /* @__PURE__ */ n.createElement("span", { className: Me.kicker }, l.kicker), /* @__PURE__ */ n.createElement("span", { className: Me.actions }, /* @__PURE__ */ n.createElement("button", { type: "button", className: Me.link, onClick: s, disabled: t }, l.reset), /* @__PURE__ */ n.createElement("button", { type: "button", className: Me.link, onClick: o, "aria-label": l.closePanel }, l.close))), a.length > 0 && /* @__PURE__ */ n.createElement("div", { className: Me.menuHits }, /* @__PURE__ */ n.createElement("span", null, l.relatedMenus), a.map((u) => /* @__PURE__ */ n.createElement("button", { type: "button", key: u.path, onClick: () => r(u.path) }, u.label, " ↗"))), /* @__PURE__ */ n.createElement("div", { className: Me.turns }, e.map((u) => {
    var m;
    return /* @__PURE__ */ n.createElement("article", { key: u.id, className: Me.turn }, /* @__PURE__ */ n.createElement("div", { className: Me.q }, u.question), /* @__PURE__ */ n.createElement("div", { className: Me.a }, u.answer && /* @__PURE__ */ n.createElement("div", { className: Me.aText }, u.answer), u.streaming && /* @__PURE__ */ n.createElement("div", { className: Me.step }, (m = u.step) != null ? m : u.answer ? "" : l.waiting, /* @__PURE__ */ n.createElement("span", { className: Me.caret })), u.error && /* @__PURE__ */ n.createElement("div", { className: Me.err }, u.error)));
  }), /* @__PURE__ */ n.createElement("div", { ref: c })));
}
function Xv(e, t, a = !0) {
  const r = B(t);
  r.current = t, G(() => {
    if (!a) return;
    const s = (o) => {
      if (o.key !== "Enter" || !(o.ctrlKey || o.metaKey) || o.isComposing || o.repeat || o.defaultPrevented) return;
      const l = e.current, c = document.activeElement;
      !l || !c || !l.contains(c) || (o.preventDefault(), r.current());
    };
    return document.addEventListener("keydown", s), () => document.removeEventListener("keydown", s);
  }, [e, a]);
}
function So() {
  const e = typeof navigator != "undefined" && (navigator.platform || navigator.userAgent) || "";
  return /Mac|iPhone|iPad/i.test(e) ? "⌘+Enter" : "Ctrl+Enter";
}
const Mo = "_bar_1g564_2", To = "_sticky_1g564_12", qo = "_start_1g564_19", Bo = "_end_1g564_20", Lo = "_status_1g564_22", jo = "_dirty_1g564_23", Ro = "_kbd_1g564_25", $t = {
  bar: Mo,
  sticky: To,
  start: qo,
  end: Bo,
  status: Lo,
  dirty: jo,
  kbd: Ro
};
function zv({ start: e, children: t, status: a, dirty: r, inline: s, shortcutHint: o, className: l = "" }) {
  return /* @__PURE__ */ n.createElement("div", { className: ["axe-save-bar", $t.bar, s ? "" : $t.sticky, l].filter(Boolean).join(" "), role: "group", "aria-label": "저장" }, /* @__PURE__ */ n.createElement("span", { className: $t.start }, e), /* @__PURE__ */ n.createElement("span", { className: $t.end }, a && /* @__PURE__ */ n.createElement("span", { className: [$t.status, r ? $t.dirty : ""].filter(Boolean).join(" "), "aria-live": "polite" }, a), t, o && /* @__PURE__ */ n.createElement("kbd", { className: $t.kbd }, So())));
}
const Io = "_root_j67qt_2", Oo = "_closed_j67qt_3", Po = "_tab_j67qt_6", Xo = "_collapse_j67qt_7", zo = "_body_j67qt_16", Fo = "_card_j67qt_32", Ho = "_head_j67qt_37", Wo = "_cardOpen_j67qt_44", Ko = "_headBtn_j67qt_47", Uo = "_icon_j67qt_56", Go = "_badge_j67qt_57", Yo = "_trailing_j67qt_58", Vo = "_chev_j67qt_59", Qo = "_panelWrap_j67qt_63", Jo = "_panelOpen_j67qt_67", Zo = "_panelBody_j67qt_68", el = "_panelInner_j67qt_69", tl = "_panelSettled_j67qt_70", ve = {
  root: Io,
  closed: Oo,
  tab: Po,
  collapse: Xo,
  body: zo,
  card: Fo,
  head: Ho,
  cardOpen: Wo,
  headBtn: Ko,
  icon: Uo,
  badge: Go,
  trailing: Yo,
  chev: Vo,
  panelWrap: Qo,
  panelOpen: Jo,
  panelBody: Zo,
  panelInner: el,
  panelSettled: tl
}, nl = 1280, al = 8, Er = "axe-side-bar:";
function rl(e) {
  if (!e) return null;
  try {
    const t = window.localStorage.getItem(Er + e);
    return t === "1" ? !0 : t === "0" ? !1 : null;
  } catch {
    return null;
  }
}
function sl(e, t) {
  if (e)
    try {
      window.localStorage.setItem(Er + e, t ? "1" : "0");
    } catch {
    }
}
function Fv({
  enabled: e = !0,
  defaultOpen: t = !0,
  width: a = 260,
  collapseBelow: r = nl,
  storageKey: s,
  className: o = "",
  children: l
}) {
  var _;
  const c = B(rl(s)), [i, u] = A((_ = c.current) != null ? _ : t), m = B(c.current !== null);
  if (G(() => {
    if (!e || !r || typeof window.matchMedia != "function") return;
    const p = window.matchMedia(`(max-width: ${r - 1}px)`), y = () => {
      m.current || u(!p.matches && t);
    };
    return y(), p.addEventListener ? p.addEventListener("change", y) : p.addListener(y), () => {
      p.removeEventListener ? p.removeEventListener("change", y) : p.removeListener(y);
    };
  }, [e, r, t]), !e) return null;
  const f = () => {
    m.current = !0, sl(s, !i), u(!i);
  };
  return /* @__PURE__ */ n.createElement(
    "aside",
    {
      className: ["axe-side-bar", ve.root, i ? "" : ve.closed, o].filter(Boolean).join(" "),
      style: { width: i ? a : al }
    },
    /* @__PURE__ */ n.createElement("div", { className: ve.tab }, /* @__PURE__ */ n.createElement(jt, { content: i ? "정보 패널 접기" : "정보 패널 펼치기", describe: !1 }, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: ve.collapse,
        onClick: f,
        "aria-label": i ? "정보 패널 접기" : "정보 패널 펼치기",
        "aria-expanded": i
      },
      /* @__PURE__ */ n.createElement(Os, { name: i ? "collapse" : "expand" })
    ))),
    /* @__PURE__ */ n.createElement("div", { className: ve.body }, l)
  );
}
const hr = qn(null);
function Hv({ children: e, defaultOpenId: t = null, exclusive: a = !0 }) {
  const [r, s] = A(t);
  return a ? /* @__PURE__ */ n.createElement(hr.Provider, { value: { openId: r, setOpenId: s } }, e) : /* @__PURE__ */ n.createElement(n.Fragment, null, e);
}
const gr = "axe-side-panel:";
function ol(e) {
  if (!e) return null;
  try {
    const t = window.localStorage.getItem(gr + e);
    return t === "1" ? !0 : t === "0" ? !1 : null;
  } catch {
    return null;
  }
}
function ll(e, t) {
  if (e)
    try {
      window.localStorage.setItem(gr + e, t ? "1" : "0");
    } catch {
    }
}
function Wv({
  title: e,
  enabled: t = !0,
  defaultOpen: a = !0,
  icon: r,
  badge: s,
  trailing: o,
  storageKey: l,
  panelId: c,
  className: i = "",
  children: u
}) {
  var h;
  const m = Tn(hr), f = !!m && c != null, _ = B(ol(l)), [p, y] = A((h = _.current) != null ? h : a), d = f ? m.openId === c : p, [b, w] = A(d), [N, g] = A(d);
  if (!t) return null;
  d && !b && w(!0);
  const $ = () => {
    const v = !d;
    ll(l, v), w(!0), g(!1), f ? m.setOpenId(v ? c : null) : y(v);
  };
  return /* @__PURE__ */ n.createElement("section", { className: ["axe-side-card", ve.card, d ? ve.cardOpen : "", i].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("header", { className: ve.head, onClick: $ }, /* @__PURE__ */ n.createElement("button", { type: "button", className: ve.headBtn, "aria-expanded": d }, r && /* @__PURE__ */ n.createElement("span", { className: ve.icon, "aria-hidden": "true" }, r), /* @__PURE__ */ n.createElement("strong", null, e)), s && /* @__PURE__ */ n.createElement("span", { className: ve.badge }, s), o && /* @__PURE__ */ n.createElement("span", { className: ve.trailing, onClick: (v) => v.stopPropagation() }, o), /* @__PURE__ */ n.createElement(
    "svg",
    {
      className: ve.chev,
      width: "14",
      height: "14",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2.2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      "aria-hidden": "true"
    },
    /* @__PURE__ */ n.createElement("path", { d: "M6 9l6 6 6-6" })
  )), b && /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [ve.panelWrap, d ? ve.panelOpen : ""].filter(Boolean).join(" "),
      onTransitionEnd: (v) => {
        v.target === v.currentTarget && v.propertyName === "grid-template-rows" && g(!0);
      }
    },
    /* @__PURE__ */ n.createElement("div", { className: [ve.panelBody, d && N ? ve.panelSettled : ""].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: ve.panelInner }, u))
  ));
}
const cl = "_guide_qnh7l_1", il = "_title_qnh7l_5", ul = "_desc_qnh7l_6", ml = "_act_qnh7l_7", dl = "_why_qnh7l_13", fl = "_steps_qnh7l_14", _l = "_no_qnh7l_20", pl = "_cur_qnh7l_24", yl = "_link_qnh7l_26", rt = {
  guide: cl,
  title: il,
  desc: ul,
  act: ml,
  why: dl,
  steps: fl,
  no: _l,
  cur: pl,
  link: yl
};
function Kv({ title: e, desc: t, action: a, steps: r }) {
  return /* @__PURE__ */ n.createElement("section", { className: rt.guide, "aria-label": e }, /* @__PURE__ */ n.createElement("h2", { className: rt.title }, e), t && /* @__PURE__ */ n.createElement("p", { className: rt.desc }, t), a && /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("button", { type: "button", className: rt.act, disabled: a.disabled, onClick: a.onClick }, a.label), a.disabled && a.reason && /* @__PURE__ */ n.createElement("p", { className: rt.why }, a.reason)), r && r.length > 0 && /* @__PURE__ */ n.createElement("ol", { className: rt.steps }, r.map((s, o) => /* @__PURE__ */ n.createElement("li", { key: s.label, className: s.current ? rt.cur : void 0 }, /* @__PURE__ */ n.createElement("span", { className: rt.no }, o + 1), s.onClick && !s.current ? /* @__PURE__ */ n.createElement("button", { type: "button", className: rt.link, onClick: s.onClick }, s.label) : /* @__PURE__ */ n.createElement("span", null, s.label), s.hint && /* @__PURE__ */ n.createElement("small", null, s.hint)))));
}
const bl = "_list_1w2rs_1", El = "_row_1w2rs_2", hl = "_label_1w2rs_6", gl = "_value_1w2rs_7", vl = "_emphasis_1w2rs_8", kl = "_changed_1w2rs_10", Rt = {
  list: bl,
  row: El,
  label: hl,
  value: gl,
  emphasis: vl,
  changed: kl
};
function Uv({ items: e, className: t }) {
  return /* @__PURE__ */ n.createElement("dl", { className: [Rt.list, t != null ? t : ""].join(" ") }, e.map((a, r) => /* @__PURE__ */ n.createElement("div", { key: r, className: [Rt.row, a.emphasis ? Rt.emphasis : ""].join(" ") }, /* @__PURE__ */ n.createElement("dt", { className: Rt.label }, a.label), /* @__PURE__ */ n.createElement("dd", { className: [Rt.value, a.changed ? Rt.changed : ""].join(" ") }, a.value))));
}
const wl = "_underline_xl221_2", Nl = "_active_xl221_24", $l = "_segmented_xl221_33", zn = {
  underline: wl,
  active: Nl,
  segmented: $l
};
function vr({
  items: e,
  value: t,
  onChange: a,
  variant: r = "underline",
  className: s = "",
  "aria-label": o
}) {
  return /* @__PURE__ */ n.createElement(
    "nav",
    {
      className: [r === "segmented" ? zn.segmented : zn.underline, s].filter(Boolean).join(" "),
      role: "tablist",
      "aria-label": o
    },
    e.map((l) => /* @__PURE__ */ n.createElement(
      "button",
      {
        key: l.key,
        type: "button",
        role: "tab",
        "aria-selected": l.key === t,
        className: l.key === t ? zn.active : "",
        onClick: () => a(l.key)
      },
      l.label
    ))
  );
}
const xl = "_bar_1adxf_1", Dl = "_actions_1adxf_17", Al = "_field_1adxf_24", Cl = "_fieldLabel_1adxf_25", Sl = "_readout_1adxf_33", Ml = "_search_1adxf_44", Tl = "_detail_1adxf_58", ql = "_pill_1adxf_71", Bl = "_hint_1adxf_82", Ze = {
  bar: xl,
  actions: Dl,
  field: Al,
  fieldLabel: Cl,
  readout: Sl,
  search: Ml,
  detail: Tl,
  pill: ql,
  hint: Bl
}, Ll = /* @__PURE__ */ new Set(["text", "search", "number", "tel", "email", "url", "password", ""]);
function jl(e) {
  if (e.key !== "Enter" || e.defaultPrevented || e.nativeEvent.isComposing || e.ctrlKey || e.metaKey || e.altKey || e.shiftKey) return !1;
  const t = e.target;
  return !(!(t instanceof HTMLInputElement) || !e.currentTarget.contains(t) || !Ll.has(t.type) || t.readOnly || t.disabled || t.getAttribute("role") === "combobox" || t.getAttribute("aria-expanded") === "true");
}
function Gv({
  children: e,
  onSearch: t,
  searchLabel: a = "조회",
  searchDisabled: r,
  searchTitle: s,
  detailSearch: o = !1,
  onDetailSearch: l,
  detailLabel: c = "상세검색",
  onReset: i,
  resetLabel: u = "초기화",
  resetDisabled: m,
  trailing: f,
  enterSearch: _ = !0
}) {
  const p = (y) => {
    !_ || !t || r || !jl(y) || (y.preventDefault(), t());
  };
  return /* @__PURE__ */ n.createElement("section", { className: Ze.bar, onKeyDown: p }, e, /* @__PURE__ */ n.createElement("span", { className: Ze.actions }, f, i && /* @__PURE__ */ n.createElement("button", { type: "button", className: Ze.detail, onClick: i, disabled: m }, u), o && /* @__PURE__ */ n.createElement("button", { type: "button", className: Ze.detail, onClick: l }, "⌕ ", c), t && /* @__PURE__ */ n.createElement(jt, { content: s, keepWrapper: !0 }, /* @__PURE__ */ n.createElement("button", { type: "button", className: Ze.search, onClick: t, disabled: r }, "⌕ ", a))));
}
function Rl({ label: e, children: t }) {
  return /* @__PURE__ */ n.createElement("label", { className: Ze.field }, /* @__PURE__ */ n.createElement("span", { className: Ze.fieldLabel }, e), t);
}
function Yv({ children: e }) {
  return /* @__PURE__ */ n.createElement("span", { className: Ze.readout }, e);
}
function Vv({ children: e }) {
  return /* @__PURE__ */ n.createElement("span", { className: Ze.pill, role: "status" }, e);
}
function Qv({ children: e }) {
  return /* @__PURE__ */ n.createElement("span", { className: Ze.hint }, e);
}
function Il(e) {
  return `${e.gisu}기 (${e.startDa} ~ ${e.endDa})${e.closeYn ? " · 마감" : ""}`;
}
function Jv({ rows: e, value: t, onChange: a, disabled: r, label: s = "기수" }) {
  return /* @__PURE__ */ n.createElement(Rl, { label: s }, /* @__PURE__ */ n.createElement(
    "select",
    {
      value: t != null ? t : "",
      "aria-label": s,
      disabled: r,
      style: { width: "var(--axe-field-w-lg, 240px)" },
      onChange: (o) => a(Number(o.target.value))
    },
    e.map((o) => /* @__PURE__ */ n.createElement("option", { key: o.gisu, value: o.gisu }, Il(o)))
  ));
}
class kr {
  constructor(t, a) {
    this._resizeObserver = null, this.initializeResizeObserver = () => {
      this._resizeObserver = new ResizeObserver((r) => {
        try {
          for (const s of r) {
            const o = s.borderBoxSize[0];
            this._callback({ width: o.inlineSize, height: o.blockSize }, s);
          }
        } catch (s) {
          console.error(s);
        }
      }), this._resizeObserver.observe(this._element);
    }, this.refresh = () => {
    }, this.detach = () => {
      this._resizeObserver && this._resizeObserver.disconnect();
    }, this.reset = () => {
    }, this._element = t, this._callback = a, this.initializeResizeObserver();
  }
}
function wr(e, t) {
  return !e || e.key !== t ? { key: t, dir: "asc" } : e.dir === "asc" ? { key: t, dir: "desc" } : null;
}
function Nr(e, t) {
  return !e || e.key !== t ? "none" : e.dir === "asc" ? "ascending" : "descending";
}
function $r(e, t) {
  return e ? `${t(e.key)} ${e.dir === "asc" ? "오름차순" : "내림차순"} 정렬` : "정렬을 해제했습니다";
}
function Ol(e) {
  const t = e.replace(/\s+/g, " ").trim();
  if (!t || t === "-") return null;
  const a = /^([-+]?)\(?[₩$]?\s*([\d,]*\.?\d+)\)?\s*(%|원|개|건)?$/.exec(t);
  if (a && /^\d{1,3}(,\d{3})*(\.\d+)?$|^\d*\.?\d+$/.test(a[2])) {
    const r = parseFloat(a[2].replace(/,/g, ""));
    return a[1] === "-" || /^[-+]?\(/.test(t) ? -r : r;
  }
  return t;
}
function xr(e, t, a) {
  if (e === null || t === null) return e === t ? 0 : e === null ? 1 : -1;
  let r;
  return typeof e == "number" && typeof t == "number" ? r = e - t : typeof e == "number" ? r = -1 : typeof t == "number" ? r = 1 : r = e.localeCompare(t, "ko", { numeric: !0, sensitivity: "base" }), a === "asc" ? r : -r;
}
function Pl(e, t) {
  const a = [], r = (l) => {
    l.sort((c, i) => xr(e[c.i].value, e[i.i].value, t) || c.i - i.i), l.forEach((c) => {
      a.push(c.i), r(c.kids);
    });
  };
  let s = [], o = [];
  return e.forEach((l, c) => {
    if (l.level === null) {
      r(s), s = [], o = [], a.push(c);
      return;
    }
    for (; o.length && o[o.length - 1].level >= l.level; ) o.pop();
    const i = { i: c, kids: [] };
    (o.length ? o[o.length - 1].node.kids : s).push(i), o.push({ level: l.level, node: i });
  }), r(s), a;
}
function Xl(e, t) {
  const a = new Set(t), r = e.filter((o) => a.has(o)), s = new Set(r);
  for (let o = t.length - 1; o >= 0; o -= 1) {
    const l = t[o];
    if (s.has(l)) continue;
    const c = o + 1 < t.length ? r.indexOf(t[o + 1]) : -1;
    c < 0 ? r.push(l) : r.splice(c, 0, l), s.add(l);
  }
  return r;
}
function zl(e, t) {
  const a = /* @__PURE__ */ new Map();
  t.forEach((c, i) => a.set(c, i));
  const r = e.map((c) => {
    var i;
    return (i = a.get(c)) != null ? i : -1;
  }), s = [], o = new Array(r.length).fill(-1);
  r.forEach((c, i) => {
    if (c < 0) return;
    let u = 0, m = s.length;
    for (; u < m; ) {
      const f = u + m >> 1;
      r[s[f]] < c ? u = f + 1 : m = f;
    }
    u > 0 && (o[i] = s[u - 1]), s[u] = i;
  });
  const l = /* @__PURE__ */ new Set();
  for (let c = s.length ? s[s.length - 1] : -1; c >= 0; c = o[c]) l.add(e[c]);
  return l;
}
const Fl = 'input, select, textarea, button, a[href], [role="checkbox"], [role="button"]', Hl = ".axe-group-row, .axe-input-row, .axe-total-row, [data-sort-fixed]";
function Wl(e) {
  const t = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map();
  for (const r of e) {
    a.forEach((o, l) => {
      o <= 1 ? a.delete(l) : a.set(l, o - 1);
    });
    let s = 0;
    for (const o of Array.from(r.cells)) {
      for (; a.has(s); ) s += 1;
      const l = o.colSpan || 1;
      if (t.set(o, s), o.rowSpan > 1) for (let c = s; c < s + l; c += 1) a.set(c, o.rowSpan);
      s += l;
    }
  }
  return t;
}
function Kl(e) {
  const t = e.tHead;
  if (!t) return [];
  const a = Wl(Array.from(t.rows)), r = [];
  return a.forEach((s, o) => {
    var c, i;
    if (o.tagName !== "TH" || (o.colSpan || 1) !== 1 || o.dataset.sortable === "false" || o.hasAttribute("aria-sort") && o.dataset.axeSort === void 0 || o.querySelector(Fl)) return;
    const l = ((c = o.textContent) != null ? c : "").replace(/\s+/g, " ").trim();
    l && r.push({ th: o, col: s, key: (i = o.dataset.sortKey) != null ? i : String(s), label: l });
  }), r;
}
function Na(e, t) {
  var r;
  let a = 0;
  for (const s of Array.from(e.cells)) {
    const o = s.colSpan || 1;
    if (t < a + o) {
      const l = s.dataset.sortValue;
      if (l !== void 0) {
        const i = Number(l);
        return l === "" ? null : Number.isFinite(i) ? i : l;
      }
      const c = s.querySelector('input:not([type="checkbox"]):not([type="radio"]), select');
      return Ol(c ? c.value : (r = s.textContent) != null ? r : "");
    }
    a += o;
  }
  return null;
}
function Ul(e) {
  if (e.matches(Hl) || e.cells.length === 1 && (e.cells[0].colSpan || 1) > 1) return null;
  const t = Number(e.getAttribute("aria-level"));
  return Number.isFinite(t) && t >= 1 ? t : 1;
}
function Gl() {
  return { parent: null, base: [], shown: [], sig: "" };
}
function Yl(e) {
  const t = Array.from(e.tBodies);
  if (t.length > 1) return { parent: e, items: t, bodies: !0 };
  const a = t[0];
  if (!a) return null;
  const r = Array.from(a.rows);
  return r.some((s) => Array.from(s.cells).some((o) => o.rowSpan > 1)) ? null : { parent: a, items: r, bodies: !1 };
}
const Dr = (e, t) => e.length === t.length && e.every((a, r) => a === t[r]);
function Vl(e, t, a) {
  if (Dr(t, a)) return;
  const r = zl(t, a);
  let s = a.length ? a[a.length - 1].nextElementSibling : null;
  for (let o = t.length - 1; o >= 0; o -= 1) {
    const l = t[o];
    r.has(l) || e.insertBefore(l, s), s = l;
  }
}
function Ql(e, t, a, r) {
  if (t) {
    const l = e.map((c, i) => ({ b: c, i, v: c.rows[0] ? Na(c.rows[0], a) : null }));
    return l.sort((c, i) => xr(c.v, i.v, r) || c.i - i.i), l.map((c) => c.b);
  }
  const s = e, o = s.map((l) => {
    const c = Ul(l);
    return { level: c, value: c === null ? null : Na(l, a) };
  });
  return Pl(o, r).map((l) => s[l]);
}
function Jl(e, t, a) {
  const r = Yl(e);
  if ((!r || r.parent !== a.parent) && (a.parent = r ? r.parent : null, a.base = r ? r.items : [], a.shown = a.base, a.sig = "", !r))
    return;
  const s = r.items, o = t ? `${t.col}:${t.dir}` : "";
  if (o === a.sig && Dr(s, a.shown)) return;
  a.base = a.sig ? Xl(a.base, s) : s;
  let l = t ? Ql(a.base, r.bodies, t.col, t.dir) : a.base;
  if (t && o === a.sig) {
    const c = new Set(a.shown), i = a.shown.filter((m) => m.parentElement === r.parent);
    let u = 0;
    l = l.map((m) => c.has(m) ? i[u++] : m);
  }
  Vl(r.parent, l, s), a.shown = l, a.sig = o;
}
const Zl = "input, select, textarea, button";
function ec(e) {
  const t = e == null ? void 0 : e.tHead;
  if (!t) return [];
  const a = [];
  return t.querySelectorAll("th").forEach((r) => {
    var c;
    const s = ((c = r.textContent) != null ? c : "").replace(/\s+/g, " ").trim(), o = r.dataset.axeTitle !== void 0 && r.dataset.axeTitle === r.getAttribute("title");
    s !== "" && !r.querySelector(Zl) && r.scrollWidth > r.clientWidth + 1 ? (a.push({ label: s, short: r.scrollWidth - r.clientWidth, sortMark: r.dataset.axeSort !== void 0 }), (!r.hasAttribute("title") || o) && (r.getAttribute("title") !== s && r.setAttribute("title", s), r.dataset.axeTitle !== s && (r.dataset.axeTitle = s))) : o && (r.removeAttribute("title"), delete r.dataset.axeTitle);
  }), a;
}
const Ar = qn(null), tc = "_card_1j6er_2", nc = "_grow_1j6er_24", ac = "_head_1j6er_26", rc = "_title_1j6er_35", sc = "_trailing_1j6er_36", oc = "_scroll_1j6er_6", lc = "_foot_1j6er_54", cc = "_strip_1j6er_56", ic = "_pager_1j6er_58", uc = "_spacer_1j6er_60", mc = "_table_1j6er_62", dc = "_fixed_1j6er_63", fc = "_fz_1j6er_81", _c = "_fzEdge_1j6er_93", pc = "_frozen_1j6er_100", yc = "_sr_1j6er_162", bc = "_statusCell_1j6er_43", Ec = "_status_1j6er_43", hc = "_st_error_1j6er_244", gc = "_stIcon_1j6er_245", vc = "_spin_1j6er_251", kc = "_axeSpin_1j6er_1", wc = "_busy_1j6er_261", Nc = "_statusRow_1j6er_263", $c = "_busyBar_1j6er_264", xc = "_axeBusy_1j6er_1", ue = {
  card: tc,
  grow: nc,
  head: ac,
  title: rc,
  trailing: sc,
  scroll: oc,
  foot: lc,
  strip: cc,
  pager: ic,
  spacer: uc,
  table: mc,
  fixed: dc,
  fz: fc,
  fzEdge: _c,
  frozen: pc,
  sr: yc,
  statusCell: bc,
  status: Ec,
  st_error: hc,
  stIcon: gc,
  spin: vc,
  axeSpin: kc,
  busy: wc,
  statusRow: Nc,
  busyBar: $c,
  axeBusy: xc
}, Dc = 120;
function Ac(e) {
  if (!e || !e.length) return;
  let t = 0, a = 0;
  for (const r of e)
    if (r == null) a += 1;
    else if (typeof r == "number") t += r;
    else if (/^\d+(\.\d+)?px$/.test(r)) t += parseFloat(r);
    else return;
  return a > 0 ? t + a * Dc : void 0;
}
function $a({ cols: e }) {
  return !e || !e.length ? null : /* @__PURE__ */ n.createElement("colgroup", null, e.map((t, a) => /* @__PURE__ */ n.createElement("col", { key: a, style: t == null ? void 0 : { width: t } })));
}
const Ht = /* @__PURE__ */ new Set();
function pa() {
  var e;
  return typeof process != "undefined" && ((e = process.env) != null && e.NODE_ENV) ? process.env.NODE_ENV !== "production" : typeof location != "undefined" && /^(localhost|127.0.0.1|[::1])$/.test(location.hostname);
}
function Cc(e) {
  if (!pa() || !e || e.getAttribute("aria-label") || e.getAttribute("aria-labelledby")) return;
  const t = Array.from(e.querySelectorAll("thead th")).slice(0, 4).map((r) => {
    var s;
    return (s = r.textContent) == null ? void 0 : s.trim();
  }).filter(Boolean), a = `unnamed|${t.join("|")}`;
  Ht.has(a) || (Ht.add(a), console.warn(`[AXErpGrid] 표 이름이 없습니다 — aria-label(예 「전표 목록」)을 주세요. 머리글: ${t.join(" · ")}`));
}
function Sc(e) {
  if (!pa()) return;
  const t = [];
  if (e.querySelectorAll("td.axe-money").forEach((r) => {
    var s, o;
    r.scrollWidth > r.clientWidth + 1 && t.push((o = (s = r.textContent) == null ? void 0 : s.trim()) != null ? o : "");
  }), !t.length) return;
  const a = t.slice(0, 5).join("|");
  Ht.has(a) || (Ht.add(a), console.warn(
    `[AXErpGrid] 금액 셀 ${t.length}개가 컬럼 폭을 넘어 말줄임됩니다 — cols 를 moneyColWidth() 로 계산하세요.`,
    t.slice(0, 5)
  ));
}
function Mc(e) {
  if (!pa() || !e.length) return;
  const t = `head|${e.map((r) => r.label).join("|")}`;
  if (Ht.has(t)) return;
  Ht.add(t);
  const a = e.some((r) => r.sortMark) ? " (정렬 표시 ↕ 약 15px 포함)" : "";
  console.warn(
    `[AXErpGrid] 머리글 ${e.length}개가 열 폭보다 길어 잘립니다 — cols 를 넓히세요${a}:`,
    e.map((r) => `${r.label} +${Math.ceil(r.short)}px`).join(", ")
  );
}
function xa(e, t, a) {
  if (!e) return;
  const r = /* @__PURE__ */ new Map();
  for (const s of Array.from(e.rows)) {
    r.forEach((l, c) => {
      l <= 1 ? r.delete(c) : r.set(c, l - 1);
    });
    let o = 0;
    for (const l of Array.from(s.cells)) {
      for (; r.has(o); ) o += 1;
      const c = l.colSpan || 1, i = t > 0 && o + c <= t;
      if (l.classList.toggle(ue.fz, i), l.classList.toggle(ue.fzEdge, i && o + c === t), l.style.left = i ? `${a[o]}px` : "", l.rowSpan > 1) for (let u = o; u < o + c; u += 1) r.set(u, l.rowSpan);
      o += c;
    }
  }
}
function Tc({
  cols: e,
  footer: t,
  pagination: a,
  title: r,
  trailing: s,
  grow: o,
  fixed: l,
  stickyCols: c = 0,
  busy: i,
  tableRole: u,
  "aria-label": m,
  sortable: f = !0,
  sort: _,
  onSort: p,
  manualSort: y,
  className: d = "",
  children: b
}) {
  const w = l || e !== void 0 && e.length > 0, N = w ? Ac(e) : void 0, { stick: g, offsets: $ } = we(() => {
    const R = Math.max(Math.trunc(c), 0), F = [];
    if (R === 0 || !e) return { stick: 0, offsets: F };
    let V = 0, z = 0;
    for (let W = 0; W < R; W += 1) {
      const ce = e[W];
      if (typeof ce != "number") break;
      F.push(V), V += ce, z += 1;
    }
    return { stick: z, offsets: F };
  }, [e, c]), h = [ue.table, w ? ue.fixed : "", g > 0 ? ue.frozen : ""].filter(Boolean).join(" "), v = B(null), E = B(null), x = B(null), C = B(null), M = B(0), T = B(0), I = we(() => ({
    scrollRef: v,
    colCount: e == null ? void 0 : e.length,
    registerVirtual: () => (T.current += 1, () => {
      T.current -= 1;
    })
  }), [e == null ? void 0 : e.length]), [q, X] = A(null), Y = _ !== void 0 ? _ : q, [K, j] = A(""), ne = B(Gl()), ae = () => {
    const R = v.current, F = x.current, V = C.current;
    if (!R || !F || !V) return;
    const z = R.scrollWidth;
    V.style.width = z + "px", F.style.display = z > R.clientWidth + 1 ? "" : "none";
    const W = R.offsetWidth - R.clientWidth;
    F.style.paddingRight = W + "px", E.current && (E.current.style.paddingRight = W + "px"), Sc(R), Mc(ec(R.querySelector("table")));
  };
  G(() => {
    const R = v.current;
    if (!R) return;
    const F = new kr(R, ae);
    return Cc(R.querySelector("table")), () => F.detach();
  }, []), xe(() => {
    var R, F, V, z, W;
    (g > 0 || M.current > 0) && (xa((F = (R = v.current) == null ? void 0 : R.querySelector("table")) != null ? F : null, g, $), xa((z = (V = E.current) == null ? void 0 : V.querySelector("table")) != null ? z : null, g, $)), M.current = g, (W = v.current) == null || W.querySelectorAll("thead th:not([scope])").forEach((ce) => ce.setAttribute("scope", "col")), k(), ae();
  });
  function k() {
    var z;
    const R = (z = v.current) == null ? void 0 : z.querySelector("table");
    if (!R) return;
    const F = f ? Kl(R) : [];
    R.querySelectorAll("thead th[data-axe-sort]").forEach((W) => {
      F.some((ce) => ce.th === W) || (W.removeAttribute("data-axe-sort"), W.removeAttribute("aria-sort"), W.removeAttribute("tabindex"));
    }), F.forEach(({ th: W, key: ce }) => {
      W.dataset.axeSort !== ce && (W.dataset.axeSort = ce);
      const Xe = Nr(Y, ce);
      W.getAttribute("aria-sort") !== Xe && W.setAttribute("aria-sort", Xe), W.hasAttribute("tabindex") || W.setAttribute("tabindex", "0");
    });
    const V = Y && F.find((W) => W.key === Y.key);
    Jl(R, Y && V && !y && T.current === 0 ? { col: V.col, dir: Y.dir } : null, ne.current);
  }
  const O = (R) => {
    var W;
    const F = R.dataset.axeSort;
    if (F === void 0) return;
    const V = wr(Y, F), z = ((W = R.textContent) != null ? W : "").replace(/\s+/g, " ").trim();
    j($r(V, () => z)), _ === void 0 && X(V), p == null || p(V);
  }, Q = (R) => {
    var z, W;
    const F = R, V = (z = F.closest) == null ? void 0 : z.call(F, "thead th[data-axe-sort]");
    return !V || !((W = v.current) != null && W.contains(V)) || F !== V && F.closest('input, select, textarea, button, a[href], [role="button"]') ? null : V;
  }, J = (R) => {
    const F = Q(R.target);
    F && O(F);
  }, se = (R) => {
    if (R.key !== "Enter" && R.key !== " ") return;
    const F = Q(R.target);
    !F || R.target !== F || (R.preventDefault(), O(F));
  }, L = (R) => {
    const F = R.target.scrollLeft;
    v.current && (v.current.scrollLeft = F), E.current && (E.current.scrollLeft = F);
  }, Z = (R) => {
    const F = R.target.scrollLeft;
    E.current && (E.current.scrollLeft = F), x.current && (x.current.scrollLeft = F);
  };
  return /* @__PURE__ */ n.createElement("div", { className: [ue.card, o ? ue.grow : "", i ? ue.busy : "", d].filter(Boolean).join(" ") }, i && /* @__PURE__ */ n.createElement("div", { className: ue.busyBar, "aria-hidden": "true" }), (r !== void 0 || s !== void 0) && /* @__PURE__ */ n.createElement("header", { className: ue.head }, /* @__PURE__ */ n.createElement("span", { className: ue.title }, r), s && /* @__PURE__ */ n.createElement("span", { className: ue.trailing }, s)), /* @__PURE__ */ n.createElement("div", { className: ue.scroll, ref: v, onScroll: Z }, /* @__PURE__ */ n.createElement(
    "table",
    {
      className: h,
      role: u && u !== "table" ? u : void 0,
      "aria-busy": i || void 0,
      "aria-label": m != null ? m : typeof r == "string" && r ? r : void 0,
      style: N ? { minWidth: N } : void 0,
      onClick: f ? J : void 0,
      onKeyDown: f ? se : void 0
    },
    /* @__PURE__ */ n.createElement($a, { cols: e }),
    /* @__PURE__ */ n.createElement(Ar.Provider, { value: I }, b)
  )), t && /* @__PURE__ */ n.createElement("div", { className: ue.foot, ref: E }, /* @__PURE__ */ n.createElement("table", { className: h, style: N ? { minWidth: N } : void 0 }, /* @__PURE__ */ n.createElement($a, { cols: e }), /* @__PURE__ */ n.createElement("tbody", null, t))), /* @__PURE__ */ n.createElement("div", { className: ue.strip, ref: x, onScroll: L }, /* @__PURE__ */ n.createElement("div", { ref: C, className: ue.spacer })), a && /* @__PURE__ */ n.createElement("div", { className: ue.pager }, a), f && /* @__PURE__ */ n.createElement("span", { className: ue.sr, role: "status", "aria-live": "polite" }, K));
}
const qc = 600;
function Da(e) {
  const { count: t, rowHeight: a, scrollTop: r, bodyTop: s } = e;
  if (!(t > 0) || !(a > 0)) return { start: 0, end: 0 };
  const o = e.viewport > 0 ? e.viewport : qc, l = Math.max(0, Math.trunc(e.overscan)), c = Math.min(t - 1, Math.max(0, Math.floor((r - s) / a))), i = Math.ceil(o / a) + 1;
  return {
    start: Math.max(0, c - l),
    end: Math.min(t, c + i + l)
  };
}
function Bc(e, t, a) {
  return {
    top: a.start * t,
    bottom: Math.max(0, e - a.end) * t
  };
}
function Lc(e, t) {
  return e.start === t.start && e.end === t.end;
}
const Aa = /* @__PURE__ */ new Set();
function Ca({ height: e, colSpan: t }) {
  return e <= 0 ? null : /* @__PURE__ */ n.createElement("tr", { "aria-hidden": "true", "data-sort-fixed": "", "data-virtual-spacer": "", style: { height: e } }, /* @__PURE__ */ n.createElement("td", { colSpan: t, style: { height: e, padding: 0, border: 0 } }));
}
function Zv({
  rows: e,
  rowHeight: t,
  renderRow: a,
  getKey: r,
  overscan: s = 6,
  colSpan: o,
  headerRows: l = 1,
  className: c
}) {
  var h;
  const i = Tn(Ar), u = B(null), [m, f] = A(() => Da({
    count: e.length,
    rowHeight: t,
    scrollTop: 0,
    viewport: 0,
    bodyTop: 0,
    overscan: s
  })), _ = e.length, [p, y] = A(null), d = p && p.of === t ? p.px : t;
  xe(() => i ? i.registerVirtual() : void 0, [i]), xe(() => {
    var E;
    const v = (E = u.current) == null ? void 0 : E.closest("table");
    if (v)
      return v.setAttribute("aria-rowcount", String(_ + l)), () => v.removeAttribute("aria-rowcount");
  }, [_, l]), G(() => {
    const v = i == null ? void 0 : i.scrollRef.current, E = u.current;
    if (!v || !E) return;
    const x = () => {
      const M = E.getBoundingClientRect().top - v.getBoundingClientRect().top + v.scrollTop, T = Da({ count: _, rowHeight: d, scrollTop: v.scrollTop, viewport: v.clientHeight, bodyTop: M, overscan: s });
      f((I) => Lc(I, T) ? I : T);
    };
    x(), v.addEventListener("scroll", x, { passive: !0 });
    const C = typeof ResizeObserver == "function" ? new ResizeObserver(x) : null;
    return C ? C.observe(v) : window.addEventListener("resize", x), () => {
      v.removeEventListener("scroll", x), C ? C.disconnect() : window.removeEventListener("resize", x);
    };
  }, [i, _, d, s]), xe(() => {
    var x, C, M;
    const v = (x = u.current) == null ? void 0 : x.querySelector("tr:not([data-virtual-spacer])"), E = (C = v == null ? void 0 : v.getBoundingClientRect().height) != null ? C : 0;
    !(E > 0) || Math.abs(E - d) <= 0.25 || (y({ of: t, px: E }), typeof process != "undefined" && ((M = process.env) == null ? void 0 : M.NODE_ENV) !== "production" && Math.abs(E - t) > 2 && !Aa.has(t) && (Aa.add(t), console.warn(`[AXErpVirtualBody] 실제 행 높이(${Math.round(E)}px)가 rowHeight(${t}px)와 많이 다릅니다 — 행마다 높이가 다르면 스크롤 위치가 어긋납니다. 셀 CSS 로 높이를 고정하세요.`)));
  }, [d, t, _]);
  const b = Math.min(m.end, _), w = Math.min(m.start, b), N = Bc(_, d, { start: w, end: b }), g = (h = o != null ? o : i == null ? void 0 : i.colCount) != null ? h : 1, $ = [];
  for (let v = w; v < b; v += 1) {
    const E = a(e[v], v), x = r ? r(e[v], v) : v;
    $.push(cn(E) ? da(E, { key: x, "aria-rowindex": v + 1 + l }) : E);
  }
  return /* @__PURE__ */ n.createElement("tbody", { ref: u, className: c, "data-virtual": "" }, /* @__PURE__ */ n.createElement(Ca, { height: N.top, colSpan: g }), $, /* @__PURE__ */ n.createElement(Ca, { height: N.bottom, colSpan: g }));
}
const jc = 7.09, Rc = 3.88, Ic = 4.46, Oc = 16, Pc = 2;
function Xc(e, t = {}) {
  var o;
  const a = Math.max(1, e), r = Math.floor((a - 1) / 3), s = a * jc + r * Rc + (t.negative ? Ic : 0) + Oc + Pc;
  return Math.max(Math.ceil(s), (o = t.min) != null ? o : 0);
}
function e0(e, t = {}) {
  var s, o;
  let a = 0, r = (s = t.negative) != null ? s : !1;
  for (const l of e) {
    if (l == null || l === "") continue;
    const c = typeof l == "number" ? l : Number(String(l).replace(/[^\d.-]/g, ""));
    if (!Number.isFinite(c)) continue;
    c < 0 && (r = !0);
    const i = Math.floor(Math.abs(c)).toString().length;
    i > a && (a = i);
  }
  return a === 0 ? Math.max((o = t.min) != null ? o : 96, 96) : Xc(a, { ...t, negative: r });
}
function t0(e) {
  const t = document.createElement("span");
  t.style.cssText = "position:absolute;visibility:hidden;white-space:nowrap", e.appendChild(t);
  const a = (l) => (t.textContent = l, t.getBoundingClientRect().width), r = a("000000000000"), s = a("000,000,000,000"), o = a("-000,000,000,000");
  return t.remove(), { digit: r / 12, comma: (s - r) / 3, minus: o - s };
}
const xt = 12, zc = 1.06, Fc = 16, Hc = 4;
function Wc(e) {
  var a;
  const t = (a = e.codePointAt(0)) != null ? a : 0;
  return t >= 4352 && (t <= 4607 || t >= 11904 && t <= 55295 || t >= 63744 && t <= 64255 || t >= 65280 && t <= 65519) ? xt : e === " " ? xt * 0.3 : /[0-9]/.test(e) ? xt * 0.56 : /[A-Z]/.test(e) ? xt * 0.68 : /[a-z]/.test(e) ? xt * 0.56 : /[.,:;'|!]/.test(e) ? xt * 0.3 : xt * 0.6;
}
function Kc(e, t = !1) {
  let a = 0;
  for (const r of e) a += Wc(r);
  return t ? a * zc : a;
}
function n0(e, t = {}) {
  var o, l, c;
  let a = 0;
  for (const i of e) {
    if (!i) continue;
    const u = Kc(i, t.bold);
    u > a && (a = u);
  }
  const r = (o = t.min) != null ? o : 64;
  if (a === 0) return r;
  const s = Math.ceil(a + Fc + ((l = t.extra) != null ? l : 0) + Hc);
  return Math.min(Math.max(s, r), (c = t.max) != null ? c : 1 / 0);
}
function Uc({
  colSpan: e,
  loading: t,
  error: a,
  count: r,
  empty: s = "조회 결과가 없습니다",
  idle: o = "조회조건을 정하고 조회하세요",
  loadingText: l = "조회 중…",
  className: c = ""
}) {
  const i = a != null && a !== !1 && a !== "", u = r == null || r === 0, m = a === !0 ? "조회하지 못했습니다 — 위 오류 안내를 확인한 뒤 다시 조회하세요" : a;
  let f;
  if (i) f = "error";
  else if (t && u) f = "loading";
  else if (r == null) {
    if (o === null) return null;
    f = "idle";
  } else if (r === 0) f = "empty";
  else return null;
  const _ = /* @__PURE__ */ n.createElement(n.Fragment, null, f === "loading" && /* @__PURE__ */ n.createElement("span", { className: ue.spin, "aria-hidden": "true" }), f === "error" && /* @__PURE__ */ n.createElement("span", { className: ue.stIcon, "aria-hidden": "true" }, "!"), /* @__PURE__ */ n.createElement("span", null, f === "error" ? m : f === "loading" ? l : f === "idle" ? o : s)), p = /* @__PURE__ */ n.createElement("div", { className: [ue.status, ue[`st_${f}`]].join(" "), role: "status" }, _);
  return e === void 0 ? /* @__PURE__ */ n.createElement("div", { className: c || void 0, "data-state": f }, p) : /* @__PURE__ */ n.createElement("tr", { className: [ue.statusRow, c].filter(Boolean).join(" "), "data-state": f }, /* @__PURE__ */ n.createElement("td", { colSpan: e, className: ue.statusCell }, p));
}
function Gc(e, t) {
  return {
    tabIndex: 0,
    "aria-current": t ? "true" : void 0,
    onKeyDown: (a) => {
      a.target === a.currentTarget && (a.key === "Enter" || a.key === " ") && (a.preventDefault(), e());
    }
  };
}
const Yc = "_cell_n9rrj_1", Vc = "_toggle_n9rrj_2", Qc = "_spacer_n9rrj_8", Jc = "_label_n9rrj_9", Zc = "_dim_n9rrj_10", Jt = {
  cell: Yc,
  toggle: Vc,
  spacer: Qc,
  label: Jc,
  dim: Zc
};
function a0(e, { id: t, parentId: a, defaultOpen: r = !0 }) {
  const [s, o] = A(() => /* @__PURE__ */ new Set()), [l, c] = A(() => /* @__PURE__ */ new Set()), { parents: i, kids: u } = we(() => {
    const p = /* @__PURE__ */ new Map(), y = /* @__PURE__ */ new Set(), d = new Set(e.map((b) => String(t(b))));
    for (const b of e) {
      const w = a(b), N = w == null || !d.has(String(w)) ? null : String(w);
      p.set(String(t(b)), N), N && y.add(N);
    }
    return { parents: p, kids: y };
  }, [e, t, a]), m = oe((p) => r ? !s.has(p) : l.has(p), [r, s, l]), f = we(() => e.filter((p) => {
    var b, w;
    let y = (b = i.get(String(t(p)))) != null ? b : null;
    const d = /* @__PURE__ */ new Set();
    for (; y && !d.has(y); ) {
      if (!m(y)) return !1;
      d.add(y), y = (w = i.get(y)) != null ? w : null;
    }
    return !0;
  }), [e, i, t, m]), _ = oe((p, y) => {
    const d = (b, w) => {
      const N = new Set(b);
      return w ? N.add(p) : N.delete(p), N;
    };
    r ? o((b) => d(b, !y)) : c((b) => d(b, y));
  }, [r]);
  return {
    visible: f,
    hasChildren: (p) => u.has(String(t(p))),
    isOpen: (p) => m(String(t(p))),
    toggle: (p) => {
      const y = String(t(p));
      _(y, !m(y));
    },
    expandAll: () => {
      o(/* @__PURE__ */ new Set()), c(new Set(u));
    },
    collapseAll: () => {
      o(new Set(u)), c(/* @__PURE__ */ new Set());
    },
    expandAllTemporarily: () => {
      const p = s, y = l;
      return o(/* @__PURE__ */ new Set()), c(new Set(u)), () => {
        o(p), c(y);
      };
    },
    reveal: (p) => {
      var b, w;
      let y = (b = i.get(String(p))) != null ? b : null;
      const d = /* @__PURE__ */ new Set();
      for (; y && !d.has(y); )
        _(y, !0), d.add(y), y = (w = i.get(y)) != null ? w : null;
    }
  };
}
function r0({ depth: e, hasChildren: t, open: a, onToggle: r, dim: s, toggleOutOfTabOrder: o, title: l, csvPath: c, children: i }) {
  const u = (f) => {
    f.stopPropagation(), r();
  }, m = l != null ? l : typeof i == "string" ? i : void 0;
  return /* @__PURE__ */ n.createElement(
    "span",
    {
      className: [Jt.cell, s ? Jt.dim : ""].filter(Boolean).join(" "),
      style: { paddingLeft: e * 16 },
      "data-tree-depth": e,
      "data-csv-path": c
    },
    t ? /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: Jt.toggle,
        "aria-expanded": a,
        "aria-label": `${m ? `${m} ` : ""}${a ? "하위 접기" : "하위 펼치기"}`,
        onClick: u,
        tabIndex: o ? -1 : void 0,
        "data-csv-skip": ""
      },
      a ? "▾" : "▸"
    ) : /* @__PURE__ */ n.createElement("span", { className: Jt.spacer, "aria-hidden": "true" }),
    /* @__PURE__ */ n.createElement("span", { className: Jt.label, title: m }, i)
  );
}
function ei(e, t, a, r = !1) {
  const s = e[t.r];
  if (!s || t.i < 0 || t.i >= s.length) return null;
  const o = s[t.i], l = e.findIndex((i) => i.length > 0);
  let c = -1;
  for (let i = e.length - 1; i >= 0; i--) if (e[i].length > 0) {
    c = i;
    break;
  }
  switch (a) {
    case "ArrowLeft":
      return t.i > 0 ? { r: t.r, i: t.i - 1 } : null;
    case "ArrowRight":
      return t.i < s.length - 1 ? { r: t.r, i: t.i + 1 } : null;
    case "Home":
      return r ? { r: l, i: 0 } : { r: t.r, i: 0 };
    case "End":
      return r ? { r: c, i: e[c].length - 1 } : { r: t.r, i: s.length - 1 };
    case "ArrowUp":
    case "ArrowDown": {
      const i = a === "ArrowUp" ? -1 : 1;
      for (let u = t.r + i; u >= 0 && u < e.length; u += i)
        if (e[u].length > 0) return { r: u, i: ti(e[u], o) };
      return null;
    }
    default:
      return null;
  }
}
function ti(e, t) {
  let a = 0;
  for (let r = 1; r < e.length; r++)
    Math.abs(e[r] - t) < Math.abs(e[a] - t) && (a = r);
  return a;
}
function s0(e, t = {}) {
  var c;
  const a = (c = t.cellSelector) != null ? c : "[data-roving]", r = t.initialSelector, s = B(null), [o, l] = A(null);
  G(() => {
    e.current !== o && l(e.current);
  }), G(() => {
    if (!o) return;
    const i = () => Array.from(o.querySelectorAll(a)), u = () => {
      const y = i();
      if (!y.length) {
        s.current = null;
        return;
      }
      (!s.current || !y.includes(s.current)) && (s.current = r && y.find((d) => d.matches(r)) || y[0]), y.forEach((d) => {
        const b = d === s.current ? "0" : "-1";
        d.getAttribute("tabindex") !== b && d.setAttribute("tabindex", b);
      });
    }, m = () => {
      const y = i(), d = [], b = [], w = /* @__PURE__ */ new Map(), N = [];
      return y.forEach((g) => {
        var M;
        const $ = g.tagName === "TR", h = $ ? null : g.closest("td, th"), v = h && o.contains(h) ? h.parentElement : null, E = $ ? g : (M = v != null ? v : g.parentElement) != null ? M : o;
        let x = d.indexOf(E);
        x < 0 && (x = d.length, d.push(E), b.push([]), N.push([]));
        let C;
        if ($)
          C = 0;
        else if (h && v) {
          C = 0;
          for (const T of Array.from(v.cells)) {
            if (T === h) break;
            C += Math.max(1, T.colSpan || 1);
          }
        } else
          C = b[x].length;
        w.set(g, { r: x, i: b[x].length }), b[x].push(C), N[x].push(g);
      }), { rows: b, where: w, byPos: N };
    }, f = (y) => {
      var v;
      const d = y.target;
      if (!d || !d.matches(a) || !o.contains(d) || y.altKey || y.metaKey || d.tagName === "TR" && (y.key === "ArrowLeft" || y.key === "ArrowRight")) return;
      const { rows: b, where: w, byPos: N } = m(), g = w.get(d);
      if (!g) return;
      const $ = ei(b, g, y.key, y.ctrlKey);
      if ($ === null) {
        ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "Home", "End"].includes(y.key) && y.preventDefault();
        return;
      }
      y.preventDefault();
      const h = (v = N[$.r]) == null ? void 0 : v[$.i];
      h && (s.current = h, u(), h.focus());
    }, _ = (y) => {
      const d = y.target;
      !d || !d.matches(a) || d === s.current || (s.current = d, u());
    };
    u(), o.addEventListener("keydown", f), o.addEventListener("focusin", _);
    const p = typeof MutationObserver != "undefined" ? new MutationObserver(u) : null;
    return p == null || p.observe(o, { childList: !0, subtree: !0 }), () => {
      o.removeEventListener("keydown", f), o.removeEventListener("focusin", _), p == null || p.disconnect();
    };
  }, [o, a, r]);
}
const ni = "_btn_r1trx_1", ai = "_mark_r1trx_7", ri = "_sr_r1trx_9", aa = {
  btn: ni,
  mark: ai,
  sr: ri
};
function o0({ sortKey: e, sort: t, onSort: a, children: r, className: s = "", colSpan: o, style: l, title: c }) {
  const i = Nr(t, e);
  return /* @__PURE__ */ n.createElement("th", { scope: "col", "aria-sort": i, colSpan: o, style: l, title: c, className: s }, /* @__PURE__ */ n.createElement("button", { type: "button", className: aa.btn, onClick: () => a(wr(t, e)) }, /* @__PURE__ */ n.createElement("span", null, r), /* @__PURE__ */ n.createElement("span", { className: aa.mark, "aria-hidden": "true" }, i === "ascending" ? "▲" : i === "descending" ? "▼" : "↕")));
}
function l0({ sort: e, labelOf: t }) {
  return /* @__PURE__ */ n.createElement("span", { className: aa.sr, role: "status", "aria-live": "polite" }, $r(e, t));
}
const si = "_card_14vt3_1", oi = "_accent_14vt3_8", li = "_grow_14vt3_9", ci = "_head_14vt3_11", ii = "_body_14vt3_20", ui = "_title_14vt3_28", mi = "_trailing_14vt3_29", di = "_summary_14vt3_32", fi = "_sumHead_14vt3_33", _i = "_sumTotal_14vt3_42", pi = "_tone_warn_14vt3_43", yi = "_tone_ok_14vt3_44", bi = "_sumList_14vt3_46", Ei = "_sumEm_14vt3_55", hi = "_sumFoot_14vt3_57", gi = "_sumNote_14vt3_66", $e = {
  card: si,
  accent: oi,
  grow: li,
  head: ci,
  body: ii,
  title: ui,
  trailing: mi,
  summary: di,
  sumHead: fi,
  sumTotal: _i,
  tone_warn: pi,
  tone_ok: yi,
  sumList: bi,
  sumEm: Ei,
  sumFoot: hi,
  sumNote: gi
};
function Cr({
  title: e,
  trailing: t,
  accent: a,
  grow: r,
  flush: s,
  className: o = "",
  children: l
}) {
  return /* @__PURE__ */ n.createElement(
    "section",
    {
      className: [$e.card, a ? $e.accent : "", r ? $e.grow : "", o].filter(Boolean).join(" "),
      "data-csv-title": typeof e == "string" && e ? e : void 0
    },
    e !== void 0 && /* @__PURE__ */ n.createElement("header", { className: $e.head }, /* @__PURE__ */ n.createElement("span", { className: $e.title, role: "heading", "aria-level": 2 }, e), t && /* @__PURE__ */ n.createElement("span", { className: $e.trailing }, t)),
    s ? l : /* @__PURE__ */ n.createElement("div", { className: ["axe-card-body", $e.body].join(" ") }, l)
  );
}
function c0({
  title: e,
  total: t,
  items: a,
  footerLabel: r,
  footerValue: s,
  note: o,
  tone: l = "default",
  children: c
}) {
  return /* @__PURE__ */ n.createElement("section", { className: [$e.card, $e.accent, $e.summary, $e[`tone_${l}`]].join(" ") }, /* @__PURE__ */ n.createElement("header", { className: $e.sumHead }, /* @__PURE__ */ n.createElement("span", null, e), t !== void 0 && /* @__PURE__ */ n.createElement("strong", { className: $e.sumTotal }, t)), /* @__PURE__ */ n.createElement("ul", { className: $e.sumList }, a.map((i, u) => {
    var m;
    return /* @__PURE__ */ n.createElement("li", { key: (m = i.key) != null ? m : u, className: i.em ? $e.sumEm : "" }, /* @__PURE__ */ n.createElement("span", null, i.label), /* @__PURE__ */ n.createElement("strong", null, i.value));
  })), c, r !== void 0 && /* @__PURE__ */ n.createElement("footer", { className: $e.sumFoot }, /* @__PURE__ */ n.createElement("span", null, r), /* @__PURE__ */ n.createElement("strong", null, s)), o && /* @__PURE__ */ n.createElement("div", { className: $e.sumNote }, o));
}
let vi = 0;
function Gt(e = "axe") {
  const t = B(null);
  return t.current || (t.current = `${e}-${++vi}`), t.current;
}
const ki = "_sr_1y2mv_2", wi = "_skip_1y2mv_8", Ni = "_crit_1y2mv_16", $i = "_c_danger_1y2mv_21", xi = "_c_warn_1y2mv_22", Di = "_critI_1y2mv_23", Ai = "_critBody_1y2mv_24", Ci = "_critX_1y2mv_25", Si = "_ch_1y2mv_32", Mi = "_chBtn_1y2mv_33", Ti = "_chBox_1y2mv_43", et = {
  sr: ki,
  skip: wi,
  crit: Ni,
  c_danger: $i,
  c_warn: xi,
  critI: Di,
  critBody: Ai,
  critX: Ci,
  ch: Si,
  chBtn: Mi,
  chBox: Ti
};
function Sr({ as: e = "span", children: t, id: a }) {
  return /* @__PURE__ */ n.createElement(e, { className: et.sr, id: a }, t);
}
function i0({ targets: e = [{ label: "본문 바로가기", targetId: "axe-main" }], className: t = "" }) {
  const a = (r, s) => {
    const o = document.getElementById(s);
    o && (r.preventDefault(), o.hasAttribute("tabindex") || o.setAttribute("tabindex", "-1"), o.focus(), o.scrollIntoView({ block: "start" }));
  };
  return /* @__PURE__ */ n.createElement("nav", { className: [et.skip, t].filter(Boolean).join(" "), "aria-label": "건너뛰기" }, e.slice(0, 3).map((r) => /* @__PURE__ */ n.createElement("a", { key: r.targetId, href: `#${r.targetId}`, onClick: (s) => a(s, r.targetId) }, r.label)));
}
function u0({ title: e, children: t, tone: a = "danger", onClose: r, className: s = "" }) {
  return /* @__PURE__ */ n.createElement("div", { className: [et.crit, et[`c_${a}`], s].filter(Boolean).join(" "), role: "alert" }, /* @__PURE__ */ n.createElement("span", { className: et.critI, "aria-hidden": "true" }, "▲"), /* @__PURE__ */ n.createElement("div", { className: et.critBody }, /* @__PURE__ */ n.createElement("b", null, e), t ? /* @__PURE__ */ n.createElement("span", null, " ", t) : null), r && /* @__PURE__ */ n.createElement("button", { type: "button", className: et.critX, onClick: r, "aria-label": "알림 닫기" }, "✕"));
}
function m0({ label: e, children: t, className: a = "" }) {
  const [r, s] = A(!1), o = Gt("axe-ch"), l = B(null), c = B(null);
  return G(() => {
    if (!r) return;
    const i = (m) => {
      l.current && !l.current.contains(m.target) && s(!1);
    }, u = (m) => {
      var f;
      m.key !== "Escape" || m.isComposing || (m.preventDefault(), m.stopPropagation(), s(!1), (f = c.current) == null || f.focus());
    };
    return document.addEventListener("mousedown", i), document.addEventListener("keydown", u, !0), () => {
      document.removeEventListener("mousedown", i), document.removeEventListener("keydown", u, !0);
    };
  }, [r]), /* @__PURE__ */ n.createElement("span", { className: [et.ch, a].filter(Boolean).join(" "), ref: l }, /* @__PURE__ */ n.createElement(
    "button",
    {
      ref: c,
      type: "button",
      className: et.chBtn,
      "aria-label": e,
      "aria-expanded": r,
      "aria-controls": o,
      onClick: () => s((i) => !i)
    },
    "?"
  ), r && /* @__PURE__ */ n.createElement("span", { id: o, role: "region", "aria-label": e, className: et.chBox }, t));
}
function ra(e, t, a = "codeName") {
  const r = (e != null ? e : "").trim();
  if (!r) return "";
  const s = (t != null ? t : "").trim();
  return !s || a === "code" ? r : a === "name" ? s : `${r}. ${s}`;
}
function qi(e, t = "전체", a = "codeName") {
  if (e.length === 0) return t;
  const r = ra(e[0].cd, e[0].nm, a);
  return e.length === 1 ? r : `${r} 외 ${e.length - 1}건`;
}
function Bi(e, t, a, r) {
  const s = (e != null ? e : "").trim();
  if (!s) return null;
  if (t && t.name && t.code === s) return t.name;
  if (a && a.code === s && a.name) return a.name;
  const o = r == null ? void 0 : r.find((l) => l.code === s);
  return o && o.name ? o.name : null;
}
const Li = "_root_g2b1p_1", ji = "_rootNone_g2b1p_5", Ri = "_field_g2b1p_12", Ii = "_codeInput_g2b1p_13", Oi = "_nameHint_g2b1p_16", Pi = "_pickBtn_g2b1p_25", Xi = "_suggest_g2b1p_42", zi = "_suggestList_g2b1p_48", Fi = "_suggestRow_g2b1p_49", Hi = "_suggestOn_g2b1p_50", Wi = "_suggestEmpty_g2b1p_55", Ki = "_suggestMore_g2b1p_55", Ui = "_popup_g2b1p_59", Gi = "_popupHead_g2b1p_73", Yi = "_searchRow_g2b1p_83", Vi = "_list_g2b1p_87", Qi = "_current_g2b1p_96", Ji = "_empty_g2b1p_100", Zi = "_summaryBtn_g2b1p_108", eu = "_ov_g2b1p_129", tu = "_modal_g2b1p_140", nu = "_modalWide_g2b1p_140", au = "_head_g2b1p_152", ru = "_sub_g2b1p_160", su = "_x_g2b1p_162", ou = "_body_g2b1p_179", lu = "_chips_g2b1p_187", cu = "_chip_g2b1p_187", iu = "_chipOn_g2b1p_201", uu = "_search_g2b1p_83", mu = "_tbl_g2b1p_220", du = "_row_g2b1p_250", fu = "_rowCursor_g2b1p_252", _u = "_rowPicked_g2b1p_253", pu = "_rowCurrent_g2b1p_254", yu = "_curTag_g2b1p_255", bu = "_busy_g2b1p_256", Eu = "_count_g2b1p_257", hu = "_chk_g2b1p_259", gu = "_tdLeft_g2b1p_260", vu = "_tdCenter_g2b1p_261", ku = "_emptyCell_g2b1p_263", wu = "_stop_g2b1p_265", Nu = "_more_g2b1p_276", $u = "_pager_g2b1p_288", xu = "_note_g2b1p_301", Du = "_foot_g2b1p_304", Au = "_ghost_g2b1p_313", Cu = "_primary_g2b1p_325", U = {
  root: Li,
  rootNone: ji,
  field: Ri,
  codeInput: Ii,
  nameHint: Oi,
  pickBtn: Pi,
  suggest: Xi,
  suggestList: zi,
  suggestRow: Fi,
  suggestOn: Hi,
  suggestEmpty: Wi,
  suggestMore: Ki,
  popup: Ui,
  popupHead: Gi,
  searchRow: Yi,
  list: Vi,
  current: Qi,
  empty: Ji,
  summaryBtn: Zi,
  ov: eu,
  modal: tu,
  modalWide: nu,
  head: au,
  sub: ru,
  x: su,
  body: ou,
  chips: lu,
  chip: cu,
  chipOn: iu,
  search: uu,
  tbl: mu,
  row: du,
  rowCursor: fu,
  rowPicked: _u,
  rowCurrent: pu,
  curTag: yu,
  busy: bu,
  count: Eu,
  chk: hu,
  tdLeft: gu,
  tdCenter: vu,
  emptyCell: ku,
  stop: wu,
  more: Nu,
  pager: $u,
  note: xu,
  foot: Du,
  ghost: Au,
  primary: Cu
};
function Su({
  items: e,
  value: t,
  title: a,
  popupRef: r,
  anchorRef: s,
  pos: o,
  onPick: l,
  onClose: c
}) {
  const [i, u] = A(""), m = we(() => {
    const f = i.trim().toLowerCase();
    return f ? e.filter(
      (_) => {
        var p;
        return _.code.toLowerCase().includes(f) || _.name.toLowerCase().includes(f) || ((p = _.sub) != null ? p : "").toLowerCase().includes(f);
      }
    ) : e;
  }, [e, i]);
  return G(() => {
    const f = (p) => {
      const y = p.target;
      r.current && !r.current.contains(y) && s.current && !s.current.contains(y) && c();
    }, _ = (p) => {
      p.key === "Escape" && c();
    };
    return document.addEventListener("mousedown", f), document.addEventListener("keydown", _), () => {
      document.removeEventListener("mousedown", f), document.removeEventListener("keydown", _);
    };
  }, [r, s, c]), /* @__PURE__ */ n.createElement(Ut, null, /* @__PURE__ */ n.createElement(
    "div",
    {
      ref: r,
      className: U.popup,
      style: { left: o.left, top: o.top },
      role: "dialog",
      "aria-label": "코드 선택"
    },
    /* @__PURE__ */ n.createElement("header", { className: U.popupHead }, /* @__PURE__ */ n.createElement("strong", null, a), /* @__PURE__ */ n.createElement("button", { type: "button", "aria-label": "닫기", onClick: c }, "✕")),
    /* @__PURE__ */ n.createElement("div", { className: U.searchRow }, /* @__PURE__ */ n.createElement(
      "input",
      {
        autoFocus: !0,
        value: i,
        "aria-label": "코드·명칭 검색",
        placeholder: "코드·명칭 검색",
        onChange: (f) => u(f.target.value),
        onKeyDown: (f) => {
          f.key === "Enter" && m.length && l(m[0]), f.key === "Escape" && c();
        }
      }
    )),
    /* @__PURE__ */ n.createElement("ul", { className: U.list }, m.map((f) => /* @__PURE__ */ n.createElement("li", { key: f.code }, /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => l(f), className: f.code === t ? U.current : "" }, /* @__PURE__ */ n.createElement("code", null, f.code), /* @__PURE__ */ n.createElement("span", null, f.name), f.sub && /* @__PURE__ */ n.createElement("small", null, f.sub)))), m.length === 0 && /* @__PURE__ */ n.createElement("li", { className: U.empty }, "검색 결과가 없습니다"))
  ));
}
const Mr = 250, En = 7;
function Sa(e, t) {
  const a = t.trim().toLowerCase();
  if (!a) return e;
  const r = e.toLowerCase().indexOf(a);
  return r < 0 ? e : /* @__PURE__ */ n.createElement(n.Fragment, null, e.slice(0, r), /* @__PURE__ */ n.createElement("b", null, e.slice(r, r + a.length)), e.slice(r + a.length));
}
function Mu(e, t) {
  const a = e.map((r) => ({ cd: r.code, nm: r.name, sub: r.sub }));
  return {
    key: "static",
    title: typeof t == "string" ? t : "코드 선택",
    nameLabel: "명칭",
    fetch: ({ q: r }) => {
      const s = r.trim().toLowerCase();
      return s ? Promise.resolve({
        rows: a.filter(
          (o) => {
            var l;
            return o.cd.toLowerCase().includes(s) || o.nm.toLowerCase().includes(s) || String((l = o.sub) != null ? l : "").toLowerCase().includes(s);
          }
        )
      }) : Promise.resolve({ rows: a });
    }
  };
}
function Tu({
  source: e,
  items: t,
  title: a,
  multiple: r,
  selected: s,
  current: o,
  searchRef: l,
  onConfirm: c,
  onClose: i
}) {
  var se;
  const u = we(() => Mu(t != null ? t : [], a), [t, a]), m = e != null ? e : u, [f, _] = A(""), [p, y] = A((se = e == null ? void 0 : e.defaultFilter) != null ? se : null), [d, b] = A(0), [w, N] = A([]), [g, $] = A(!1), [h, v] = A(!1), [E, x] = A(null), [C, M] = A(0), [T, I] = A(/* @__PURE__ */ new Map()), q = B(m);
  q.current = m, G(() => {
    var Z;
    _(""), y((Z = q.current.defaultFilter) != null ? Z : null), b(0), M(0), x(null), I(new Map((s != null ? s : []).map((R) => [R.cd, R])));
    const L = window.setTimeout(() => {
      l.current && l.current.focus();
    }, 30);
    return () => window.clearTimeout(L);
  }, [m.key]), G(() => {
    let L = !0;
    v(!0);
    const Z = () => {
      q.current.fetch({ q: f.trim(), ty: p, page: d }).then((F) => {
        var z, W;
        if (!L) return;
        N((z = F.rows) != null ? z : []), $(!!F.hasMore), x(null);
        const V = o ? ((W = F.rows) != null ? W : []).findIndex((ce) => ce.cd === o) : -1;
        M(V > 0 ? V : 0);
      }).catch((F) => {
        L && (N([]), $(!1), x("코드를 불러오지 못했습니다. 잠시 후 다시 조회하세요."));
      }).finally(() => {
        L && v(!1);
      });
    }, R = window.setTimeout(Z, f.trim() ? Mr : 0);
    return () => {
      L = !1, window.clearTimeout(R);
    };
  }, [m.key, f, p, d]);
  const X = B(null);
  G(() => {
    const L = X.current && X.current.children[C];
    L && "scrollIntoView" in L && L.scrollIntoView({ block: "nearest" });
  }, [C, w]);
  const Y = we(() => {
    var Z, R;
    const L = [
      { key: "cd", label: "코드", width: (Z = m.codeWidth) != null ? Z : "96px", align: "center" },
      {
        key: "nm",
        label: m.nameLabel,
        align: "left",
        render: (F) => /* @__PURE__ */ n.createElement(n.Fragment, null, F.nm, F.useYn === !1 && /* @__PURE__ */ n.createElement("span", { className: U.stop }, "사용중단"))
      }
    ];
    return m.typeLabel && L.push({
      key: "__ty",
      label: "구분",
      width: "110px",
      align: "center",
      render: (F) => m.typeLabel ? m.typeLabel(F) : ""
    }), L.concat((R = m.extraColumns) != null ? R : []);
  }, [m]), K = oe((L) => {
    I((Z) => {
      const R = new Map(Z);
      return R.has(L.cd) ? R.delete(L.cd) : R.set(L.cd, L), R;
    });
  }, []), j = oe((L) => c([L]), [c]), ne = oe(() => c(Array.from(T.values())), [T, c]), ae = w.length > 0 && w.every((L) => T.has(L.cd)), k = () => {
    I((L) => {
      const Z = new Map(L);
      return ae ? w.forEach((R) => Z.delete(R.cd)) : w.forEach((R) => Z.set(R.cd, R)), Z;
    });
  }, O = B(null);
  G(() => {
    const L = document.activeElement;
    return () => {
      window.setTimeout(() => {
        L && L.isConnected && typeof L.focus == "function" && (!document.activeElement || document.activeElement === document.body) && L.focus();
      }, 0);
    };
  }, []);
  const Q = B(i);
  Q.current = i, G(() => {
    const L = (Z) => {
      Z.key !== "Escape" || Z.isComposing || (Z.stopPropagation(), Z.preventDefault(), Q.current());
    };
    return document.addEventListener("keydown", L, !0), () => document.removeEventListener("keydown", L, !0);
  }, []);
  const J = (L) => {
    var F;
    if (L.nativeEvent.isComposing || L.keyCode === 229) return;
    if (L.key === "Tab" && O.current) {
      const V = Array.from(O.current.querySelectorAll("input:not([disabled]), button:not([disabled])"));
      if (V.length) {
        const z = V[0], W = V[V.length - 1], ce = document.activeElement;
        L.shiftKey && ce === z ? (L.preventDefault(), W.focus()) : !L.shiftKey && ce === W && (L.preventDefault(), z.focus());
      }
      return;
    }
    if (L.key === "Escape") {
      L.stopPropagation(), i();
      return;
    }
    const Z = L.target, R = Z === l.current;
    if (!(!R && Z !== O.current)) {
      if (L.key === "ArrowDown" || L.key === "ArrowUp") {
        L.preventDefault(), M((V) => Math.max(0, Math.min(w.length - 1, V + (L.key === "ArrowDown" ? 1 : -1))));
        return;
      }
      if (L.key === " " && r && w[C] && !(R && ((F = l.current) != null && F.value))) {
        L.preventDefault(), K(w[C]);
        return;
      }
      if (L.key === "Enter") {
        if (L.preventDefault(), h) return;
        r ? ne() : w[C] && j(w[C]);
      }
    }
  };
  return /* @__PURE__ */ n.createElement(Ut, null, /* @__PURE__ */ n.createElement("div", { className: U.ov, onClick: i }, /* @__PURE__ */ n.createElement(
    "div",
    {
      className: m.wide ? `${U.modal} ${U.modalWide}` : U.modal,
      role: "dialog",
      "aria-modal": "true",
      "aria-label": m.title,
      ref: O,
      onClick: (L) => L.stopPropagation(),
      onKeyDown: J
    },
    /* @__PURE__ */ n.createElement("div", { className: U.head }, /* @__PURE__ */ n.createElement("h2", null, m.title), r && /* @__PURE__ */ n.createElement("span", { className: U.sub }, "복수 선택 가능"), /* @__PURE__ */ n.createElement("button", { type: "button", className: U.x, onClick: i, "aria-label": "닫기" }, "×")),
    /* @__PURE__ */ n.createElement("div", { className: U.body }, m.filters && m.filters.length > 0 && /* @__PURE__ */ n.createElement("div", { className: U.chips }, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: p === null ? `${U.chip} ${U.chipOn}` : U.chip,
        onClick: () => {
          y(null), b(0);
        }
      },
      "전체"
    ), m.filters.map((L) => /* @__PURE__ */ n.createElement(
      "button",
      {
        key: L.value,
        type: "button",
        className: p === L.value ? `${U.chip} ${U.chipOn}` : U.chip,
        onClick: () => {
          y(L.value), b(0);
        }
      },
      L.label
    ))), /* @__PURE__ */ n.createElement(
      "input",
      {
        ref: l,
        className: U.search,
        value: f,
        placeholder: "코드, 명칭 검색",
        autoComplete: "off",
        "aria-label": "코드·명칭 검색",
        onChange: (L) => {
          _(L.target.value), b(0);
        }
      }
    ), /* @__PURE__ */ n.createElement("div", { className: U.tbl }, /* @__PURE__ */ n.createElement("table", null, /* @__PURE__ */ n.createElement("thead", null, /* @__PURE__ */ n.createElement("tr", null, r && /* @__PURE__ */ n.createElement("th", { className: U.chk }, /* @__PURE__ */ n.createElement(
      "input",
      {
        type: "checkbox",
        checked: ae,
        onChange: k,
        "aria-label": "표시된 행 전체 선택"
      }
    )), Y.map((L) => /* @__PURE__ */ n.createElement("th", { key: L.key, style: L.width ? { width: L.width } : void 0 }, L.label)))), /* @__PURE__ */ n.createElement("tbody", { ref: X, className: h && w.length > 0 ? U.busy : void 0, "aria-busy": h }, w.length === 0 ? /* @__PURE__ */ n.createElement("tr", null, /* @__PURE__ */ n.createElement("td", { className: U.emptyCell, colSpan: Y.length + (r ? 1 : 0) }, h ? "검색 중…" : E || m.emptyText || "검색 결과가 없습니다")) : w.map((L, Z) => /* @__PURE__ */ n.createElement(
      "tr",
      {
        key: L.cd,
        className: [
          U.row,
          Z === C ? U.rowCursor : "",
          T.has(L.cd) ? U.rowPicked : "",
          !r && o && L.cd === o ? U.rowCurrent : ""
        ].filter(Boolean).join(" "),
        "aria-selected": Z === C,
        onClick: () => {
          M(Z), r ? K(L) : j(L);
        }
      },
      r && /* @__PURE__ */ n.createElement("td", { className: U.chk }, /* @__PURE__ */ n.createElement(
        "input",
        {
          type: "checkbox",
          checked: T.has(L.cd),
          onChange: () => K(L),
          onClick: (R) => R.stopPropagation(),
          "aria-label": `${L.cd} 선택`
        }
      )),
      Y.map((R) => {
        var F, V;
        return /* @__PURE__ */ n.createElement(
          "td",
          {
            key: R.key,
            className: R.align === "left" ? U.tdLeft : U.tdCenter,
            title: R.render ? void 0 : String((F = L[R.key]) != null ? F : "")
          },
          R.render ? R.render(L) : String((V = L[R.key]) != null ? V : ""),
          R.key === "cd" && !r && o && L.cd === o && /* @__PURE__ */ n.createElement("em", { className: U.curTag }, "현재")
        );
      })
    ))))), /* @__PURE__ */ n.createElement("p", { className: U.count, role: "status", "aria-live": "polite" }, h ? "검색 중…" : E ? "" : `${w.length}건`, !r && !h && !E && w.length > 0 && " — ↑↓ 로 고르고 Enter, 또는 행을 누르세요"), (g || d > 0) && /* @__PURE__ */ n.createElement("div", { className: U.more }, /* @__PURE__ */ n.createElement("span", null, g ? "표시 상한까지만 보여 주고 있습니다 — 검색어를 좁히거나 다음 쪽으로 넘기세요" : "마지막 쪽입니다"), /* @__PURE__ */ n.createElement("span", { className: U.pager }, /* @__PURE__ */ n.createElement("button", { type: "button", disabled: d === 0, onClick: () => b((L) => Math.max(0, L - 1)) }, "이전"), /* @__PURE__ */ n.createElement("b", null, d + 1), g && /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => b((L) => L + 1) }, "다음"))), r && /* @__PURE__ */ n.createElement("p", { className: U.note }, "선택 ", /* @__PURE__ */ n.createElement("b", null, T.size), "건 — 선택이 없으면 ", /* @__PURE__ */ n.createElement("b", null, "전체"), "로 조회됩니다")),
    /* @__PURE__ */ n.createElement("div", { className: U.foot }, r && /* @__PURE__ */ n.createElement("button", { type: "button", className: U.ghost, onClick: () => I(/* @__PURE__ */ new Map()) }, "초기화"), /* @__PURE__ */ n.createElement("button", { type: "button", className: U.ghost, onClick: i }, "취소"), r && /* @__PURE__ */ n.createElement("button", { type: "button", className: U.primary, onClick: ne }, "확인"))
  )));
}
let qu = 0;
function Bu({ source: e, items: t, anchorRef: a }) {
  const [r, s] = A(null), [o, l] = A(-1), [c, i] = A(null), u = B(null), m = B(0), f = B(`axe-cp-${++qu}`), _ = B(e);
  _.current = e;
  const p = B(t);
  p.current = t;
  const y = oe(() => {
    u.current != null && (window.clearTimeout(u.current), u.current = null), m.current += 1, s(null), l(-1);
  }, []);
  G(() => y, [y]);
  const d = (b) => {
    u.current != null && window.clearTimeout(u.current), m.current += 1;
    const w = m.current;
    if (!b.trim()) {
      s(null), l(-1);
      return;
    }
    u.current = window.setTimeout(async () => {
      var $;
      let N = [], g = !1;
      try {
        const h = _.current;
        if (h) {
          const v = await h.fetch({ q: b, ty: null, page: 0 });
          N = v.rows, g = !!v.hasMore || N.length > En;
        } else {
          const v = b.trim().toLowerCase();
          N = (($ = p.current) != null ? $ : []).filter((E) => {
            var x;
            return E.code.toLowerCase().includes(v) || E.name.toLowerCase().includes(v) || ((x = E.sub) != null ? x : "").toLowerCase().includes(v);
          }).map((E) => ({ cd: E.code, nm: E.name, sub: E.sub })), g = N.length > En;
        }
      } catch {
        return;
      }
      w === m.current && (s({ rows: N.slice(0, En), more: g, q: b }), l(-1));
    }, Mr);
  };
  return G(() => {
    if (!r) {
      i(null);
      return;
    }
    const b = () => {
      const w = a.current;
      if (!w) return;
      const N = w.getBoundingClientRect(), g = Math.min(r.rows.length, En) * 28 + 34, $ = N.bottom + g > window.innerHeight - 8 && N.top - g - 2 > 8 ? N.top - g - 2 : N.bottom + 2, h = Math.max(N.width, 260);
      i({ left: Math.max(8, Math.min(N.left, window.innerWidth - h - 8)), top: $, width: h });
    };
    return b(), window.addEventListener("resize", b), window.addEventListener("scroll", b, !0), () => {
      window.removeEventListener("resize", b), window.removeEventListener("scroll", b, !0);
    };
  }, [r, a]), { sugg: r, active: o, setActive: l, suggPos: c, suggId: f, runSuggest: d, cancelSuggest: y };
}
function d0({
  value: e = "",
  name: t,
  show: a = "codeName",
  onChange: r,
  items: s,
  source: o,
  multiple: l = !1,
  selected: c,
  onConfirm: i,
  current: u,
  trigger: m,
  emptyLabel: f = "전체",
  open: _,
  onOpenChange: p,
  placeholder: y,
  title: d = "코드 선택",
  variant: b,
  disabled: w,
  className: N = "",
  maxLength: g,
  numeric: $ = !1,
  ariaLabel: h,
  autoFocus: v,
  onEnter: E,
  onEscape: x,
  onBlur: C,
  invalid: M,
  selectOnFocus: T = !1
}) {
  const I = o ? "source" : "static", q = h != null ? h : (o == null ? void 0 : o.title) || (typeof d == "string" && d !== "코드 선택" ? d : "") || "코드", X = b != null ? b : I === "source" ? "modal" : "anchor", Y = m != null ? m : l ? "summary" : "input", [K, j] = A(!1), ne = _ != null ? _ : K, ae = oe(
    (H) => {
      _ === void 0 && j(H), p && p(H);
    },
    [_, p]
  ), k = B(null), O = B(!1), Q = B(null), J = B(null), [se, L] = A(null), Z = () => {
    if (!w) {
      if (X === "anchor") {
        const H = k.current;
        if (!H) return;
        const D = H.getBoundingClientRect(), P = 320, te = D.bottom + P > window.innerHeight ? Math.max(8, D.top - P - 4) : D.bottom + 4;
        L({ left: Math.min(D.left, window.innerWidth - 320), top: te });
      }
      ae(!0);
    }
  }, R = oe(() => ae(!1), [ae]), [F, V] = A(!1), [z, W] = A(null), ce = B(null);
  (!ce.current || ce.current.name !== t) && (ce.current = { name: t, code: e });
  const Xe = Bi(e, ce.current, z, s), Re = ra(e, Xe, a), Ie = ra(e, Xe), _t = F && Xe && a !== "code" ? Xe : "", Yt = (H) => {
    !l && H[0] && W({ code: H[0].cd, name: H[0].nm }), i ? i(H) : H[0] && r && r(H[0].cd, { code: H[0].cd, name: H[0].nm });
  }, { sugg: Ee, active: Oe, setActive: Vt, suggPos: He, suggId: pt, runSuggest: Pn, cancelSuggest: Ge } = Bu({ source: o, items: s, anchorRef: k }), pn = (H) => {
    Ge(), Yt([H]);
  };
  return /* @__PURE__ */ n.createElement("span", { ref: k, className: [Y === "none" ? U.rootNone : U.root, N].filter(Boolean).join(" ") }, Y === "input" && /* @__PURE__ */ n.createElement("span", { className: U.field }, /* @__PURE__ */ n.createElement(
    "input",
    {
      className: U.codeInput,
      style: { paddingRight: _t ? "calc(24px + 45%)" : 24 },
      value: F ? e : Re,
      placeholder: y,
      disabled: w,
      maxLength: g,
      inputMode: $ ? "numeric" : void 0,
      autoComplete: "off",
      autoFocus: v,
      "aria-label": q,
      "aria-invalid": M ? !0 : void 0,
      onChange: (H) => {
        const D = H.target.value.trim(), P = $ ? D.replace(/[^0-9]/g, "") : D, te = g ? P.slice(0, g) : P;
        r && r(te), !w && (o || s) && Pn(te);
      },
      onKeyDown: (H) => {
        if (H.key === "F2") {
          H.preventDefault(), Ge(), Z();
          return;
        }
        if (!Ee) {
          H.key === "Enter" && E && !H.nativeEvent.isComposing ? (H.preventDefault(), E()) : H.key === "Escape" && x && (H.preventDefault(), x());
          return;
        }
        const D = Ee.rows.length;
        H.key === "ArrowDown" && D ? (H.preventDefault(), Vt((P) => (P + 1) % D)) : H.key === "ArrowUp" && D ? (H.preventDefault(), Vt((P) => (P <= 0 ? D : P) - 1)) : H.key === "Enter" && Oe >= 0 && Ee.rows[Oe] ? (H.preventDefault(), pn(Ee.rows[Oe])) : H.key === "Enter" && E && !H.nativeEvent.isComposing ? (H.preventDefault(), Ge(), E()) : H.key === "Escape" && (H.preventDefault(), H.stopPropagation(), H.nativeEvent.stopImmediatePropagation(), Ge());
      },
      onFocus: (H) => {
        if (V(!0), !T) return;
        const D = H.currentTarget;
        window.requestAnimationFrame(() => D.select());
      },
      onMouseDown: (H) => {
        T && document.activeElement !== H.currentTarget && (O.current = !0);
      },
      onMouseUp: (H) => {
        O.current && (H.preventDefault(), O.current = !1);
      },
      onBlur: () => {
        V(!1), Ge(), C && C();
      },
      title: typeof M == "string" && M ? M : Ie && Ie !== e ? `${Ie} (F2: 코드 선택)` : "F2: 코드 선택",
      role: "combobox",
      "aria-autocomplete": "list",
      "aria-expanded": !!Ee,
      "aria-controls": Ee ? pt.current : void 0,
      "aria-activedescendant": Ee && Oe >= 0 ? `${pt.current}-${Oe}` : void 0,
      "aria-describedby": typeof M == "string" && M ? `${pt.current}-inv` : void 0
    }
  ), _t && /* @__PURE__ */ n.createElement("span", { className: U.nameHint, "aria-hidden": "true" }, _t), typeof M == "string" && M && /* @__PURE__ */ n.createElement(Sr, { id: `${pt.current}-inv` }, M), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: U.pickBtn,
      "aria-label": "코드 선택 열기",
      disabled: w,
      onClick: Z,
      onMouseDown: (H) => H.preventDefault(),
      tabIndex: -1
    },
    /* @__PURE__ */ n.createElement(un, { name: "search", size: 13 })
  )), Y === "summary" && /* @__PURE__ */ n.createElement("button", { type: "button", className: U.summaryBtn, disabled: w, onClick: Z }, /* @__PURE__ */ n.createElement("span", null, qi(c != null ? c : [], f, a)), /* @__PURE__ */ n.createElement("i", { "aria-hidden": "true" }, /* @__PURE__ */ n.createElement(un, { name: "search", size: 13 }))), Ee && He && Y === "input" && !ne && /* @__PURE__ */ n.createElement(Ut, null, /* @__PURE__ */ n.createElement(
    "div",
    {
      className: U.suggest,
      style: { left: He.left, top: He.top, width: He.width },
      onMouseDown: (H) => H.preventDefault()
    },
    Ee.rows.length === 0 ? /* @__PURE__ */ n.createElement("div", { className: U.suggestEmpty }, "일치하는 코드가 없습니다 · F2 로 전체 검색") : /* @__PURE__ */ n.createElement("ul", { id: pt.current, role: "listbox", className: U.suggestList }, Ee.rows.map((H, D) => /* @__PURE__ */ n.createElement(
      "li",
      {
        key: H.cd,
        id: `${pt.current}-${D}`,
        role: "option",
        "aria-selected": D === Oe,
        className: [U.suggestRow, D === Oe ? U.suggestOn : ""].filter(Boolean).join(" "),
        onMouseEnter: () => Vt(D),
        onClick: () => pn(H)
      },
      /* @__PURE__ */ n.createElement("code", null, Sa(H.cd, Ee.q)),
      /* @__PURE__ */ n.createElement("span", null, Sa(H.nm, Ee.q)),
      H.useYn === !1 && /* @__PURE__ */ n.createElement("em", null, "사용중단")
    ))),
    Ee.more && /* @__PURE__ */ n.createElement("div", { className: U.suggestMore }, "더 있습니다 · F2 로 전체 보기")
  )), ne && I === "static" && X === "anchor" && se && /* @__PURE__ */ n.createElement(
    Su,
    {
      items: s != null ? s : [],
      value: e,
      title: d,
      popupRef: Q,
      anchorRef: k,
      pos: se,
      onPick: (H) => {
        W({ code: H.code, name: H.name }), r && r(H.code, H), R();
      },
      onClose: R
    }
  ), ne && (I === "source" || X === "modal") && /* @__PURE__ */ n.createElement(
    Tu,
    {
      source: o,
      items: s,
      title: d,
      multiple: l,
      selected: c,
      current: u,
      searchRef: J,
      onConfirm: (H) => {
        Yt(H), R();
      },
      onClose: R
    }
  ));
}
const ya = 864e5;
function Lu(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
function Le(e, t) {
  return t === 2 ? Lu(e) ? 29 : 28 : t === 4 || t === 6 || t === 9 || t === 11 ? 30 : 31;
}
function wt(e) {
  return Math.round(Date.UTC(+e.slice(0, 4), +e.slice(5, 7) - 1, +e.slice(8, 10)) / ya);
}
function ju(e) {
  const t = new Date(e * ya);
  return `${t.getUTCFullYear()}-${String(t.getUTCMonth() + 1).padStart(2, "0")}-${String(t.getUTCDate()).padStart(2, "0")}`;
}
function Bn(e, t) {
  return ju(wt(e) + t);
}
function ba(e) {
  return new Date(wt(e) * ya).getUTCDay();
}
const Ma = "1900-01-01", Ta = "2099-12-31", Fn = ["일", "월", "화", "수", "목", "금", "토"], xn = (e) => String(e).padStart(2, "0");
function at(e, t, a) {
  return `${String(e).padStart(4, "0")}-${xn(t)}-${xn(a)}`;
}
function de(e) {
  const t = /^(\d{4})-(\d{2})-(\d{2})$/.exec(e != null ? e : "");
  if (!t) return null;
  const a = +t[1], r = +t[2], s = +t[3];
  return r < 1 || r > 12 || s < 1 || s > Le(a, r) ? null : { y: a, m: r, d: s };
}
function Ru(e) {
  const t = /^(\d{4})-(\d{2})$/.exec(e != null ? e : "");
  if (!t) return null;
  const a = +t[1], r = +t[2];
  return r < 1 || r > 12 ? null : { y: a, m: r, d: 1 };
}
function Zt(e, t) {
  return t === "month" ? Ru(e) : de(e);
}
function Be(e, t) {
  return t === "month" ? `${String(e.y).padStart(4, "0")}-${xn(e.m)}` : at(e.y, e.m, e.d);
}
function je(e) {
  return new Date(Date.UTC(e.y, e.m - 1, e.d)).getUTCDay();
}
function mn(e, t) {
  const a = new Date(Date.UTC(e.y, e.m - 1, e.d + t));
  return { y: a.getUTCFullYear(), m: a.getUTCMonth() + 1, d: a.getUTCDate() };
}
function Nt(e, t) {
  const a = e.y * 12 + (e.m - 1) + t, r = Math.floor(a / 12), s = (a % 12 + 12) % 12 + 1;
  return { y: r, m: s, d: Math.min(e.d, Le(r, s)) };
}
function Iu(e, t, a) {
  return e >= t && e <= a;
}
function It(e, t) {
  return e.replace(/\D/g, "").slice(0, t === "month" ? 6 : 8);
}
function Hn(e, t) {
  const a = e.slice(0, 4), r = e.slice(4, 6), s = e.slice(6, 8);
  let o = a;
  return e.length > 4 && (o += "-" + r), t === "date" && e.length > 6 && (o += "-" + s), o;
}
function qa(e, t) {
  if (t <= 0) return 0;
  let a = 0;
  for (let r = 0; r < e.length; r++)
    if (/\d/.test(e[r]) && (a++, a === t))
      return r + 1;
  return e.length;
}
function Nn(e, t, a) {
  let r, s, o = 1;
  if (t === "month")
    if (e.length === 6)
      r = +e.slice(0, 4), s = +e.slice(4, 6);
    else if (e.length === 4)
      r = 2e3 + +e.slice(0, 2), s = +e.slice(2, 4);
    else return null;
  else if (e.length === 8)
    r = +e.slice(0, 4), s = +e.slice(4, 6), o = +e.slice(6, 8);
  else if (e.length === 6)
    r = 2e3 + +e.slice(0, 2), s = +e.slice(2, 4), o = +e.slice(4, 6);
  else if (e.length === 4)
    r = a.y, s = +e.slice(0, 2), o = +e.slice(2, 4);
  else return null;
  return s < 1 || s > 12 || o < 1 || o > Le(r, s) ? null : { y: r, m: s, d: o };
}
function Ou(e, t, a) {
  const r = e.trim(), s = t === "month" ? /^(\d{4})\D+(\d{1,2})$/.exec(r) : /^(\d{4})\D+(\d{1,2})\D+(\d{1,2})$/.exec(r);
  if (s) {
    const o = { y: +s[1], m: +s[2], d: t === "month" ? 1 : +s[3] };
    return o.m >= 1 && o.m <= 12 && o.d >= 1 && o.d <= Le(o.y, o.m) ? o : null;
  }
  return Nn(r.replace(/\D/g, ""), t, a);
}
function Pu(e, t) {
  const a = { y: e, m: t, d: 1 }, r = mn(a, -je(a));
  return Array.from({ length: 42 }, (s, o) => mn(r, o));
}
function Xu(e, t) {
  const a = e.y, r = [], s = (u, m) => `${String(u).padStart(4, "0")}-${xn(m)}`, o = (u, m, f) => at(u, m, f);
  if (t === "month") {
    r.push({ label: "이번 달", from: s(a, e.m), to: s(a, e.m) });
    const u = Nt(e, -1);
    r.push({ label: "지난달", from: s(u.y, u.m), to: s(u.y, u.m) }), r.push({ label: "올해", from: s(a, 1), to: s(a, 12) }), r.push({ label: "올해 누계", from: s(a, 1), to: s(a, e.m) }), r.push({ label: "전년도", from: s(a - 1, 1), to: s(a - 1, 12) });
    for (let m = 1; m <= 4; m++) r.push({ label: `${m}분기`, from: s(a, m * 3 - 2), to: s(a, m * 3) });
    return r.push({ label: "상반기", from: s(a, 1), to: s(a, 6) }), r.push({ label: "하반기", from: s(a, 7), to: s(a, 12) }), r;
  }
  const l = at(e.y, e.m, e.d);
  r.push({ label: "오늘", from: l, to: l });
  const c = mn(e, -je(e));
  r.push({ label: "이번 주", from: Be(c, "date"), to: Be(mn(c, 6), "date") }), r.push({ label: "이번 달", from: o(a, e.m, 1), to: o(a, e.m, Le(a, e.m)) });
  const i = Nt({ ...e, d: 1 }, -1);
  r.push({ label: "지난달", from: o(i.y, i.m, 1), to: o(i.y, i.m, Le(i.y, i.m)) }), r.push({ label: "올해", from: o(a, 1, 1), to: o(a, 12, 31) }), r.push({ label: "올해 오늘까지", from: o(a, 1, 1), to: l }), r.push({ label: "전년도", from: o(a - 1, 1, 1), to: o(a - 1, 12, 31) });
  for (let u = 1; u <= 4; u++)
    r.push({ label: `${u}분기`, from: o(a, u * 3 - 2, 1), to: o(a, u * 3, Le(a, u * 3)) });
  return r;
}
const zu = "_wrap_uxy72_1", Fu = "_disabled_uxy72_18", Hu = "_input_uxy72_22", Wu = "_month_uxy72_36", Ku = "_weekday_uxy72_39", Uu = "_sun_uxy72_40", Gu = "_sat_uxy72_41", Yu = "_icon_uxy72_43", Vu = "_readOnly_uxy72_57", Qu = "_required_uxy72_62", Ju = "_invalid_uxy72_63", Zu = "_pop_uxy72_66", em = "_calHead_uxy72_79", tm = "_calTitleStatic_uxy72_80", nm = "_calTitle_uxy72_80", am = "_grid_uxy72_90", rm = "_wd_uxy72_91", sm = "_day_uxy72_95", om = "_mon_uxy72_36", lm = "_out_uxy72_104", cm = "_sel_uxy72_105", im = "_today_uxy72_108", um = "_months_uxy72_111", mm = "_foot_uxy72_114", dm = "_clear_uxy72_127", fm = "_range_uxy72_130", _m = "_tilde_uxy72_131", pm = "_rangeErr_uxy72_132", re = {
  wrap: zu,
  disabled: Fu,
  input: Hu,
  month: Wu,
  weekday: Ku,
  sun: Uu,
  sat: Gu,
  icon: Yu,
  readOnly: Vu,
  required: Qu,
  invalid: Ju,
  pop: Zu,
  calHead: em,
  calTitleStatic: tm,
  calTitle: nm,
  grid: am,
  wd: rm,
  day: sm,
  mon: om,
  out: lm,
  sel: cm,
  today: im,
  months: um,
  foot: mm,
  clear: dm,
  range: fm,
  tilde: _m,
  rangeErr: pm
}, Et = () => {
  const e = /* @__PURE__ */ new Date();
  return { y: e.getFullYear(), m: e.getMonth() + 1, d: e.getDate() };
};
function Ba({
  value: e,
  onChange: t,
  mode: a = "date",
  min: r,
  max: s,
  disabled: o,
  readOnly: l,
  required: c,
  invalid: i,
  showWeekday: u,
  onReject: m,
  placeholder: f,
  id: _,
  name: p,
  onBlur: y,
  "aria-label": d,
  "aria-describedby": b,
  className: w = "",
  style: N
}) {
  const g = a === "month", $ = Gt("axe-dp"), h = r || (g ? Ma.slice(0, 7) : Ma), v = s || (g ? Ta.slice(0, 7) : Ta), E = (D) => Iu(D, h, v), x = !!o || !!l, [C, M] = A(e || ""), [T, I] = A(!1), [q, X] = A(!1), [Y, K] = A(g ? "month" : "day"), [j, ne] = A(() => {
    var P;
    const D = (P = Zt(e, a)) != null ? P : Et();
    return { y: D.y, m: D.m };
  }), [ae, k] = A({ top: 0, left: 0 }), O = B(null), Q = B(null), J = B(null), se = B(null);
  G(() => {
    M(e || ""), I(!1);
  }, [e]), G(() => {
    const D = Zt(e, a);
    D && ne({ y: D.y, m: D.m });
  }, [e, a]), xe(() => {
    const D = Q.current;
    se.current != null && D && document.activeElement === D && D.setSelectionRange(se.current, se.current), se.current = null;
  }, [C]), xe(() => {
    if (!q) return;
    const D = () => {
      const P = O.current, te = J.current;
      if (!P || !te) return;
      const ie = P.getBoundingClientRect(), me = te.offsetHeight, he = te.offsetWidth;
      let De = ie.bottom + 4;
      De + me > window.innerHeight - 8 && ie.top - me - 4 > 8 && (De = ie.top - me - 4);
      const Qt = Math.max(8, Math.min(ie.left, window.innerWidth - he - 8));
      k((Xn) => Xn.top === De && Xn.left === Qt ? Xn : { top: De, left: Qt });
    };
    return D(), window.addEventListener("resize", D), window.addEventListener("scroll", D, !0), () => {
      window.removeEventListener("resize", D), window.removeEventListener("scroll", D, !0);
    };
  }, [q, Y, j.y, j.m]), G(() => {
    if (!q) return;
    const D = (P) => {
      var ie, me;
      const te = P.target;
      (ie = O.current) != null && ie.contains(te) || (me = J.current) != null && me.contains(te) || X(!1);
    };
    return document.addEventListener("mousedown", D), () => document.removeEventListener("mousedown", D);
  }, [q]);
  const L = (D) => {
    D !== (e || "") && t(D);
  }, Z = (D) => {
    M(D), I(!1), L(D);
  }, R = () => {
    const D = It(C, a);
    if (!D) return;
    const P = Nn(D, a, Et()), te = P ? Be(P, a) : null;
    if (te && E(te)) {
      Z(te);
      return;
    }
    m == null || m(C, te ? "range" : "format"), M(e || ""), I(!1);
  }, F = (D, P) => {
    const te = It(D.slice(0, P), a).length, ie = It(D, a), me = Hn(ie, a);
    if (se.current = qa(me, Math.min(te, ie.length)), M(me), !ie) {
      I(!1), L("");
      return;
    }
    if (ie.length === (g ? 6 : 8)) {
      const he = Nn(ie, a, Et()), De = he ? Be(he, a) : null;
      De && E(De) ? (I(!1), L(De)) : I(!0);
    } else I(!1);
  }, V = (D, P) => {
    var Qt;
    const te = Et(), ie = It(C, a), me = (Qt = Nn(ie, a, te)) != null ? Qt : Zt(e, a);
    let he;
    me ? g ? he = Nt(me, D === "year" ? 12 * P : P) : D === "day" ? he = mn(me, P) : he = Nt(me, D === "month" ? P : 12 * P) : he = te;
    const De = Be(he, a);
    E(De) && Z(De);
  }, z = (D) => {
    var P;
    Z(D), X(!1), (P = Q.current) == null || P.focus();
  }, W = () => {
    var P;
    if (x) return;
    const D = (P = Zt(e, a)) != null ? P : Et();
    ne({ y: D.y, m: D.m }), K(g ? "month" : "day"), X(!0);
  }, ce = (D) => {
    var te, ie;
    if (x) return;
    const P = D.currentTarget;
    switch (D.key) {
      case "Escape":
        q ? (X(!1), D.preventDefault(), D.stopPropagation(), D.nativeEvent.stopImmediatePropagation()) : C !== (e || "") && (M(e || ""), I(!1), D.preventDefault(), D.stopPropagation(), D.nativeEvent.stopImmediatePropagation(), requestAnimationFrame(() => P.select()));
        break;
      case "ArrowDown":
        D.preventDefault(), D.altKey ? q ? X(!1) : W() : V("day", 1);
        break;
      case "ArrowUp":
        D.preventDefault(), V("day", -1);
        break;
      case "PageDown":
        D.preventDefault(), V("month", 1);
        break;
      case "PageUp":
        D.preventDefault(), V("month", -1);
        break;
      case "F2":
      case "F4":
        D.preventDefault(), q ? X(!1) : W();
        break;
      case "Enter":
        R(), q && X(!1);
        break;
      case "t":
      case "T":
        if (D.ctrlKey || D.metaKey || D.altKey) break;
        D.preventDefault(), Z(Be(Et(), a));
        break;
      case "Backspace": {
        const me = (te = P.selectionStart) != null ? te : 0;
        if (me === ((ie = P.selectionEnd) != null ? ie : 0) && me > 0 && C[me - 1] === "-") {
          D.preventDefault();
          const he = It(C.slice(0, me), a).length, De = It(C, a);
          F(Hn(De.slice(0, he - 1) + De.slice(he), a), 0), se.current = qa(Hn(De.slice(0, he - 1) + De.slice(he), a), he - 1);
        }
        break;
      }
    }
  }, Xe = (D) => {
    if (x) return;
    D.preventDefault();
    const P = Ou(D.clipboardData.getData("text"), a, Et()), te = P ? Be(P, a) : null;
    te && E(te) ? Z(te) : I(!0);
  }, Re = (D) => {
    var te, ie;
    const P = D.relatedTarget;
    P && ((te = O.current) != null && te.contains(P) || (ie = J.current) != null && ie.contains(P)) || (R(), X(!1), y && y());
  }, Ie = Zt(e, a), _t = Et(), Yt = T || !!i, Ee = u && !g && Ie ? je(Ie) : null, Oe = (D) => Be(D, a), Vt = (D, P) => {
    const te = Be({ y: D, m: P, d: 1 }, "date"), ie = Be({ y: D, m: P, d: Le(D, P) }, "date"), me = g ? h + "-01" : h, he = g ? v + "-31" : v;
    return ie >= me && te <= he;
  }, He = (D) => {
    const P = Nt({ y: j.y, m: j.m, d: 1 }, D);
    ne({ y: P.y, m: P.m });
  }, pt = () => /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("div", { className: re.calHead }, /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "이전 해", onClick: () => He(-12) }, "«"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "이전 달", onClick: () => He(-1) }, "‹"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, className: re.calTitle, "aria-label": "연·월 선택", onClick: () => K("month") }, j.y, "년 ", j.m, "월"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "다음 달", onClick: () => He(1) }, "›"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "다음 해", onClick: () => He(12) }, "»")), /* @__PURE__ */ n.createElement("div", { className: re.grid }, Fn.map((D, P) => /* @__PURE__ */ n.createElement("span", { key: D, className: [re.wd, P === 0 ? re.sun : "", P === 6 ? re.sat : ""].join(" ") }, D)), Pu(j.y, j.m).map((D) => {
    const P = Be(D, "date"), te = je(D), ie = [
      re.day,
      D.m !== j.m ? re.out : "",
      te === 0 ? re.sun : "",
      te === 6 ? re.sat : "",
      P === Be(_t, "date") ? re.today : "",
      Ie && P === Be(Ie, "date") ? re.sel : ""
    ].join(" "), me = !E(P);
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: P,
        type: "button",
        tabIndex: -1,
        className: ie,
        disabled: me,
        "aria-label": `${D.y}년 ${D.m}월 ${D.d}일 ${Fn[te]}요일`,
        "aria-pressed": !!Ie && P === Be(Ie, "date"),
        onClick: () => z(P)
      },
      D.d
    );
  }))), Pn = () => /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("div", { className: re.calHead }, /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "이전 해", onClick: () => He(-12) }, "«"), /* @__PURE__ */ n.createElement("span", { className: re.calTitleStatic }, j.y, "년"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "다음 해", onClick: () => He(12) }, "»")), /* @__PURE__ */ n.createElement("div", { className: re.months }, Array.from({ length: 12 }, (D, P) => P + 1).map((D) => {
    const P = !!Ie && Ie.y === j.y && Ie.m === D, te = [re.mon, P ? re.sel : "", _t.y === j.y && _t.m === D ? re.today : ""].join(" ");
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: D,
        type: "button",
        tabIndex: -1,
        className: te,
        disabled: !Vt(j.y, D),
        "aria-pressed": P,
        onClick: () => {
          g ? z(Oe({ y: j.y, m: D, d: 1 })) : (ne({ y: j.y, m: D }), K("day"));
        }
      },
      D,
      "월"
    );
  }))), Ge = Be(_t, a), pn = g ? /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, disabled: !E(Ge), onClick: () => z(Ge) }, "이번 달")) : /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, disabled: !E(Ge), onClick: () => z(Ge) }, "오늘"), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      tabIndex: -1,
      disabled: !E(Oe({ y: j.y, m: j.m, d: 1 })),
      onClick: () => z(Oe({ y: j.y, m: j.m, d: 1 }))
    },
    "월초"
  ), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      tabIndex: -1,
      disabled: !E(Oe({ y: j.y, m: j.m, d: Le(j.y, j.m) })),
      onClick: () => z(Oe({ y: j.y, m: j.m, d: Le(j.y, j.m) }))
    },
    "월말"
  )), H = [
    re.wrap,
    o ? re.disabled : "",
    l ? re.readOnly : "",
    c && !e && !C ? re.required : "",
    Yt ? re.invalid : "",
    g ? re.month : "",
    w
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ n.createElement("span", { ref: O, className: H, style: N, onBlur: Re }, /* @__PURE__ */ n.createElement(
    "input",
    {
      ref: Q,
      id: _,
      name: p,
      className: re.input,
      inputMode: "numeric",
      autoComplete: "off",
      spellCheck: !1,
      value: C,
      placeholder: f != null ? f : g ? "YYYY-MM" : "YYYY-MM-DD",
      disabled: o,
      readOnly: l,
      role: "combobox",
      "aria-haspopup": "dialog",
      "aria-expanded": q,
      "aria-controls": $,
      "aria-label": d,
      "aria-describedby": b,
      "aria-invalid": Yt || void 0,
      "aria-required": c || void 0,
      onChange: (D) => {
        var P;
        return F(D.target.value, (P = D.target.selectionStart) != null ? P : D.target.value.length);
      },
      onKeyDown: ce,
      onPaste: Xe
    }
  ), Ee != null && /* @__PURE__ */ n.createElement("span", { className: [re.weekday, Ee === 0 ? re.sun : "", Ee === 6 ? re.sat : ""].join(" "), "aria-hidden": "true" }, "(", Fn[Ee], ")"), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      tabIndex: -1,
      className: re.icon,
      disabled: x,
      "aria-label": g ? "월 선택 열기" : "달력 열기",
      onMouseDown: (D) => D.preventDefault(),
      onClick: () => {
        var D;
        (D = Q.current) == null || D.focus(), q ? X(!1) : W();
      }
    },
    /* @__PURE__ */ n.createElement(un, { name: "calendar", size: 15 })
  ), q && /* @__PURE__ */ n.createElement(Ut, null, /* @__PURE__ */ n.createElement(
    "div",
    {
      ref: J,
      id: $,
      className: re.pop,
      style: { top: ae.top, left: ae.left },
      role: "dialog",
      "aria-label": g ? "월 선택" : "날짜 선택",
      onMouseDown: (D) => D.preventDefault()
    },
    Y === "day" && !g ? pt() : Pn(),
    /* @__PURE__ */ n.createElement("div", { className: re.foot }, pn, !c && /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, className: re.clear, onClick: () => z("") }, "비우기"))
  )));
}
const Mt = (e) => String(e).padStart(2, "0");
function Tr() {
  const e = /* @__PURE__ */ new Date();
  return `${e.getFullYear()}-${Mt(e.getMonth() + 1)}-${Mt(e.getDate())}`;
}
function f0(e) {
  if (!e) return "";
  const t = new Date(e);
  return Number.isNaN(t.getTime()) ? String(e) : `${t.getFullYear()}-${Mt(t.getMonth() + 1)}-${Mt(t.getDate())} ${Mt(t.getHours())}:${Mt(t.getMinutes())}:${Mt(t.getSeconds())}`;
}
function _0(e, t) {
  return !!e && !!t && e <= t;
}
function p0({
  from: e,
  to: t,
  onChange: a,
  mode: r = "date",
  min: s,
  max: o,
  disabled: l,
  label: c = "기간",
  presets: i = !0,
  showWeekday: u,
  onReject: m
}) {
  const f = !!e && !!t && e > t, _ = /* @__PURE__ */ new Date(), p = i === !1 ? [] : Array.isArray(i) ? i : Xu({ y: _.getFullYear(), m: _.getMonth() + 1, d: _.getDate() }, r), y = (d) => (!s || d.from >= s) && (!o || d.to <= o);
  return /* @__PURE__ */ n.createElement("span", { className: re.range }, /* @__PURE__ */ n.createElement(
    Ba,
    {
      value: e,
      mode: r,
      min: s,
      max: o,
      disabled: l,
      showWeekday: u,
      "aria-label": `${c} 시작일`,
      onChange: (d) => a(d, t),
      onReject: m && ((d, b) => m(d, b, "from"))
    }
  ), /* @__PURE__ */ n.createElement("span", { className: re.tilde, "aria-hidden": "true" }, "~"), /* @__PURE__ */ n.createElement(
    Ba,
    {
      value: t,
      mode: r,
      min: s,
      max: o,
      disabled: l,
      showWeekday: u,
      "aria-label": `${c} 종료일`,
      onChange: (d) => a(e, d),
      onReject: m && ((d, b) => m(d, b, "to"))
    }
  ), p.length > 0 && /* @__PURE__ */ n.createElement(
    oo,
    {
      label: "기간",
      title: `${c} 빠른 선택`,
      disabled: l,
      entries: p.map((d) => so(
        d.label,
        d.label,
        () => a(d.from, d.to),
        y(d) ? {} : { disabled: !0, reason: "허용 범위 밖" }
      ))
    }
  ), f && /* @__PURE__ */ n.createElement("span", { className: re.rangeErr, role: "alert" }, "시작일이 종료일보다 늦습니다"));
}
const qr = [
  { name: "明治", short: "M", start: "1868-09-08" },
  { name: "大正", short: "T", start: "1912-07-30" },
  { name: "昭和", short: "S", start: "1926-12-25" },
  { name: "平成", short: "H", start: "1989-01-08" },
  { name: "令和", short: "R", start: "2019-05-01" }
];
function Br(e, t = qr) {
  const a = /^(\d{4})-\d{2}-\d{2}/.exec(e != null ? e : "");
  if (!a) return null;
  let r = null;
  for (const s of t) s.start <= e.slice(0, 10) && (!r || s.start > r.start) && (r = s);
  return r ? { era: r, year: +a[1] - +r.start.slice(0, 4) + 1 } : null;
}
function ym(e, t = {}) {
  const a = Br(e, t.eras);
  return a ? `${a.era.name}${a.year === 1 && t.gannen !== !1 ? "元" : a.year}年` : null;
}
function y0(e, t) {
  const a = Br(e, t);
  return a ? `${a.era.short}${a.year}.${e.slice(5, 7)}.${e.slice(8, 10)}` : null;
}
const Se = 1440, Dn = (e) => String(e).padStart(2, "0");
function pe(e) {
  const t = /^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2}))?/.exec(e != null ? e : "");
  return t ? Date.UTC(+t[1], +t[2] - 1, +t[3], t[4] ? +t[4] : 0, t[5] ? +t[5] : 0) / 6e4 : NaN;
}
function qt(e) {
  const t = new Date(e * 6e4);
  return at(t.getUTCFullYear(), t.getUTCMonth() + 1, t.getUTCDate());
}
function rn(e) {
  const t = new Date(e * 6e4);
  return `${qt(e)}T${Dn(t.getUTCHours())}:${Dn(t.getUTCMinutes())}`;
}
function tt(e) {
  const t = (e % Se + Se) % Se;
  return `${Dn(Math.floor(t / 60))}:${Dn(t % 60)}`;
}
function ke(e, t) {
  return de(e) ? Bn(e, t) : e;
}
function Wt(e, t) {
  return Math.round((pe(t) - pe(e)) / Se);
}
function dn(e) {
  if (!de(e)) return !1;
  const t = ba(e);
  return t === 0 || t === 6;
}
function bm(e) {
  var s;
  const t = pe(e.start);
  if (Number.isNaN(t)) return null;
  const a = (s = e.allDay) != null ? s : !/[T ]\d{2}:\d{2}/.test(e.start);
  if (a) {
    const o = qt(t), l = e.end ? qt(pe(e.end)) : o, c = l < o ? o : l;
    return { ev: e, s: pe(o), e: pe(c) + Se, allDay: a, sDay: o, eDay: c };
  }
  let r = e.end ? pe(e.end) : t + 60;
  return (Number.isNaN(r) || r <= t) && (r = t + 30), { ev: e, s: t, e: r, allDay: a, sDay: qt(t), eDay: qt(r - 1) };
}
function Ln(e, t, a, r) {
  const s = [];
  for (const o of e) {
    const l = r && o.id === r.id ? { ...o, start: r.start, end: r.end } : o, c = bm(l);
    c && c.eDay >= t && c.sDay <= a && s.push(c);
  }
  return s.sort(Em);
}
function Em(e, t) {
  if (e.sDay !== t.sDay) return e.sDay < t.sDay ? -1 : 1;
  const a = Wt(t.sDay, t.eDay) - Wt(e.sDay, e.eDay);
  return a || (e.allDay !== t.allDay ? e.allDay ? -1 : 1 : e.s !== t.s ? e.s - t.s : e.ev.title.localeCompare(t.ev.title));
}
function hm(e) {
  return e.allDay || e.sDay !== e.eDay;
}
function Lr(e) {
  return e.allDay || e.e - e.s >= Se;
}
function An(e, t) {
  const a = de(e);
  if (!a) return e;
  const r = (je(a) - t + 7) % 7;
  return ke(e, -r);
}
function jn(e, t) {
  const a = Wt(e, t);
  return Array.from({ length: Math.max(0, a + 1) }, (r, s) => ke(e, s));
}
function jr(e, t) {
  const a = de(e), r = at(a.y, a.m, 1), s = at(a.y, a.m, Le(a.y, a.m)), o = An(r, t), l = ke(An(s, t), 6), c = jn(o, l), i = [];
  for (let u = 0; u < c.length; u += 7) i.push(c.slice(u, u + 7));
  return i;
}
function Ea(e, t, a) {
  if (e === "month") {
    const r = jr(t, a);
    return { from: r[0][0], to: r[r.length - 1][6] };
  }
  if (e === "agenda") {
    const r = de(t);
    return { from: at(r.y, r.m, 1), to: at(r.y, r.m, Le(r.y, r.m)) };
  }
  if (e === "week") {
    const r = An(t, a);
    return { from: r, to: ke(r, 6) };
  }
  return { from: t, to: t };
}
function gm(e, t, a, r = !1) {
  const s = de(t);
  if (!s) return t;
  if (e === "month" || e === "agenda") {
    const l = Nt(s, a);
    return at(l.y, l.m, l.d);
  }
  if (e === "week") return ke(t, 7 * a);
  let o = ke(t, a);
  for (; r && dn(o); ) o = ke(o, a);
  return o;
}
function vm(e, t, a, r) {
  if (!de(t)) return "";
  if (e === "month" || e === "agenda") return r.ym(`${t.slice(0, 7)}-01`);
  if (e === "day") return r.dayTitle(t);
  const { from: s, to: o } = Ea("week", t, a);
  return r.year(s) !== r.year(o) ? `${r.ymd(s)} – ${r.ymd(o)}` : s.slice(5, 7) !== o.slice(5, 7) ? `${r.ymd(s)} – ${r.md(o)}` : `${r.ymd(s)} – ${r.d(o)}`;
}
function Rr(e, t) {
  const a = [], r = [];
  for (const s of e) {
    let o = -1, l = -1;
    for (let i = 0; i < t.length; i++)
      t[i] >= s.sDay && t[i] <= s.eDay && (o < 0 && (o = i), l = i);
    if (o < 0) continue;
    let c = r.findIndex((i) => i < o);
    c < 0 ? (c = r.length, r.push(l)) : r[c] = l, a.push({ item: s, col: o, span: l - o + 1, lane: c, contL: s.sDay < t[o], contR: s.eDay > t[l] });
  }
  return a;
}
function km(e, t, a) {
  const r = new Array(t).fill(0);
  for (const c of e) for (let i = c.col; i < c.col + c.span; i++) r[i]++;
  const s = Math.max(1, a), o = e.filter((c) => {
    if (c.lane < s - 1) return !0;
    if (c.lane > s - 1) return !1;
    for (let i = c.col; i < c.col + c.span; i++) if (r[i] > s) return !1;
    return !0;
  }), l = new Array(t).fill(0);
  for (const c of o) for (let i = c.col; i < c.col + c.span; i++) l[i]++;
  return { shown: o, more: r.map((c, i) => c - l[i]) };
}
const wm = 20;
function Nm(e, t) {
  const a = pe(t), r = a + Se, s = e.filter((u) => !Lr(u) && u.s < r && u.e > a).map((u) => ({
    item: u,
    top: Math.max(u.s, a) - a,
    bottom: Math.min(u.e, r) - a,
    col: 0,
    cols: 1,
    contTop: u.s < a,
    contBottom: u.e > r
  })).sort((u, m) => u.top - m.top || m.bottom - u.bottom);
  let o = [], l = [], c = -1;
  const i = () => {
    for (const u of o) u.cols = l.length;
    o = [], l = [];
  };
  for (const u of s) {
    u.top >= c && i();
    const m = Math.max(u.bottom, u.top + wm);
    let f = l.findIndex((_) => _ <= u.top);
    f < 0 ? (f = l.length, l.push(m)) : l[f] = m, u.col = f, o.push(u), c = Math.max(c, m);
  }
  return i(), s;
}
function La(e, t) {
  return Math.round(e / t) * t;
}
function sa(e, t) {
  if (e.allDay) {
    const a = Math.round(t / Se);
    return { start: ke(e.sDay, a), end: ke(e.eDay, a) };
  }
  return { start: rn(e.s + t), end: rn(e.e + t) };
}
function ha(e, t = "종일") {
  if (e.allDay) {
    if (e.sDay === e.eDay) return t;
    const l = de(e.sDay), c = de(e.eDay);
    return `${l.m}/${l.d} – ${c.m}/${c.d}`;
  }
  const a = pe(e.sDay), r = tt(e.s - a);
  if (e.sDay === e.eDay) return `${r} – ${e.e - a === Se ? "24:00" : tt(e.e - a)}`;
  const s = de(e.sDay), o = de(qt(e.e));
  return `${s.m}/${s.d} ${r} – ${o.m}/${o.d} ${tt(e.e - pe(qt(e.e)))}`;
}
const Ae = (e) => {
  const t = de(e);
  return { ...t, w: je(t) };
};
function ja(e, t, a, r, s) {
  const o = `${+e.slice(0, 4)}${a}`;
  if (t === "gregorian") return o;
  const l = ym(e, { eras: r, gannen: s });
  return l ? t === "era" ? l : `${o}(${l})` : o;
}
function $m(e = "ko", t = {}) {
  var i, u;
  const a = (i = t.year) != null ? i : e === "ja" ? "era" : "gregorian", r = (u = t.eras) != null ? u : qr, s = t.gannen !== !1;
  if (e === "ja") {
    const m = ["日", "月", "火", "水", "木", "金", "土"], f = (p) => ja(p, a, "年", r, s), _ = { month: "月", week: "週", day: "日", agenda: "月" };
    return {
      weekdays: m,
      views: { month: "月", week: "週", day: "日", agenda: "一覧" },
      today: "今日",
      prev: (p) => `前の${_[p]} (P)`,
      next: (p) => `次の${_[p]} (N)`,
      hideWeekends: "週末を隠す",
      prevMonth: "前月",
      nextMonth: "翌月",
      prevYear: "前年",
      nextYear: "翌年",
      pickMonth: "月を選択",
      viewTabs: "表示",
      region: "スケジュール",
      loading: "読み込み中",
      close: "閉じる",
      allDay: "終日",
      empty: "この期間の予定はありません。",
      more: (p) => `他${p}件`,
      eventCount: (p) => `予定${p}件`,
      dayOfSpan: (p, y) => `${p}/${y}日目`,
      openDay: (p) => {
        const y = Ae(p);
        return `${y.m}月${y.d}日を日表示`;
      },
      year: f,
      ym: (p) => `${f(p)}${Ae(p).m}月`,
      ymd: (p) => {
        const y = Ae(p);
        return `${f(p)}${y.m}月${y.d}日`;
      },
      md: (p) => {
        const y = Ae(p);
        return `${y.m}月${y.d}日`;
      },
      d: (p) => `${Ae(p).d}日`,
      m: (p) => `${Ae(p).m}月`,
      dayTitle: (p) => {
        const y = Ae(p);
        return `${f(p)}${y.m}月${y.d}日(${m[y.w]})`;
      },
      dayAria: (p) => {
        const y = Ae(p);
        return `${y.m}月${y.d}日 ${m[y.w]}曜日`;
      }
    };
  }
  const o = ["일", "월", "화", "수", "목", "금", "토"], l = (m) => ja(m, a, "년", r, s), c = { month: "달", week: "주", day: "날", agenda: "달" };
  return {
    weekdays: o,
    views: { month: "월", week: "주", day: "일", agenda: "목록" },
    today: "오늘",
    prev: (m) => `이전 ${c[m]} (P)`,
    next: (m) => `다음 ${c[m]} (N)`,
    hideWeekends: "주말 숨김",
    prevMonth: "이전 달",
    nextMonth: "다음 달",
    prevYear: "이전 해",
    nextYear: "다음 해",
    pickMonth: "월 선택",
    viewTabs: "보기",
    region: "일정 달력",
    loading: "일정 불러오는 중",
    close: "닫기",
    allDay: "종일",
    empty: "이 기간에 일정이 없습니다.",
    more: (m) => `+${m}개`,
    eventCount: (m) => `일정 ${m}건`,
    dayOfSpan: (m, f) => `${m}/${f}일째`,
    openDay: (m) => {
      const f = Ae(m);
      return `${f.m}월 ${f.d}일 일 보기`;
    },
    year: l,
    ym: (m) => `${l(m)} ${Ae(m).m}월`,
    ymd: (m) => {
      const f = Ae(m);
      return `${l(m)} ${f.m}월 ${f.d}일`;
    },
    md: (m) => {
      const f = Ae(m);
      return `${f.m}월 ${f.d}일`;
    },
    d: (m) => `${Ae(m).d}일`,
    m: (m) => `${Ae(m).m}월`,
    dayTitle: (m) => {
      const f = Ae(m);
      return `${l(m)} ${f.m}월 ${f.d}일 (${o[f.w]})`;
    },
    dayAria: (m) => {
      const f = Ae(m);
      return `${f.m}월 ${f.d}일 ${o[f.w]}요일`;
    }
  };
}
const Ir = $m("ko"), xm = "_cal_38qtm_2", Dm = "_toolbar_38qtm_20", Am = "_navBtns_38qtm_28", Cm = "_title_38qtm_29", Sm = "_toolRight_38qtm_36", Mm = "_toggle_38qtm_37", Tm = "_body_38qtm_58", qm = "_busy_38qtm_59", Bm = "_sun_38qtm_71", Lm = "_sat_38qtm_72", jm = "_tAccent_38qtm_75", Rm = "_tOk_38qtm_76", Im = "_tWarn_38qtm_77", Om = "_tDanger_38qtm_78", Pm = "_tViolet_38qtm_79", Xm = "_tGray_38qtm_80", zm = "_month_38qtm_83", Fm = "_mHead_38qtm_84", Hm = "_wdName_38qtm_85", Wm = "_mBody_38qtm_91", Km = "_mWeek_38qtm_92", Um = "_mCells_38qtm_94", Gm = "_cell_38qtm_96", Ym = "_out_38qtm_104", Vm = "_dayNum_38qtm_105", Qm = "_creatable_38qtm_106", Jm = "_selDay_38qtm_109", Zm = "_cellHead_38qtm_111", ed = "_isToday_38qtm_124", td = "_holiday_38qtm_125", nd = "_addHint_38qtm_130", ad = "_barLayer_38qtm_138", rd = "_chip_38qtm_139", sd = "_more_38qtm_139", od = "_tEv_38qtm_155", ld = "_aRow_38qtm_155", cd = "_popItem_38qtm_155", id = "_bar_38qtm_138", ud = "_contL_38qtm_165", md = "_contR_38qtm_166", dd = "_dotChip_38qtm_167", fd = "_dot_38qtm_167", _d = "_chipTime_38qtm_170", pd = "_chipTitle_38qtm_171", yd = "_movable_38qtm_173", bd = "_ghost_38qtm_176", Ed = "_time_38qtm_189", hd = "_tHead_38qtm_190", gd = "_tAllDay_38qtm_190", vd = "_gutter_38qtm_193", kd = "_tHeadDays_38qtm_197", wd = "_tAllDayCells_38qtm_197", Nd = "_tDay_38qtm_198", $d = "_tDayBtn_38qtm_202", xd = "_tWd_38qtm_206", Dd = "_tDayNum_38qtm_208", Ad = "_tAllDayRow_38qtm_216", Cd = "_allDayCell_38qtm_218", Sd = "_tBody_38qtm_222", Md = "_tGrid_38qtm_223", Td = "_tGutter_38qtm_224", qd = "_tCols_38qtm_230", Bd = "_tCol_38qtm_230", Ld = "_tSel_38qtm_238", jd = "_tEvTitle_38qtm_258", Rd = "_tEvTime_38qtm_259", Id = "_tEvShort_38qtm_261", Od = "_contTop_38qtm_263", Pd = "_contBottom_38qtm_264", Xd = "_resize_38qtm_265", zd = "_now_38qtm_268", Fd = "_agenda_38qtm_272", Hd = "_aDay_38qtm_273", Wd = "_aDate_38qtm_275", Kd = "_aDateBtn_38qtm_276", Ud = "_aDayNum_38qtm_280", Gd = "_aDayWd_38qtm_286", Yd = "_aList_38qtm_288", Vd = "_aTime_38qtm_295", Qd = "_aTitle_38qtm_296", Jd = "_aSpan_38qtm_297", Zd = "_aLoc_38qtm_298", ef = "_empty_38qtm_303", tf = "_pop_38qtm_155", nf = "_popHead_38qtm_321", af = "_popDay_38qtm_322", rf = "_popClose_38qtm_329", sf = "_popList_38qtm_334", of = "_tAllDayOnly_38qtm_348", S = {
  cal: xm,
  toolbar: Dm,
  navBtns: Am,
  title: Cm,
  toolRight: Sm,
  toggle: Mm,
  body: Tm,
  busy: qm,
  sun: Bm,
  sat: Lm,
  tAccent: jm,
  tOk: Rm,
  tWarn: Im,
  tDanger: Om,
  tViolet: Pm,
  tGray: Xm,
  month: zm,
  mHead: Fm,
  wdName: Hm,
  mBody: Wm,
  mWeek: Km,
  mCells: Um,
  cell: Gm,
  out: Ym,
  dayNum: Vm,
  creatable: Qm,
  selDay: Jm,
  cellHead: Zm,
  isToday: ed,
  holiday: td,
  addHint: nd,
  barLayer: ad,
  chip: rd,
  more: sd,
  tEv: od,
  aRow: ld,
  popItem: cd,
  bar: id,
  contL: ud,
  contR: md,
  dotChip: dd,
  dot: fd,
  chipTime: _d,
  chipTitle: pd,
  movable: yd,
  ghost: bd,
  time: Ed,
  tHead: hd,
  tAllDay: gd,
  gutter: vd,
  tHeadDays: kd,
  tAllDayCells: wd,
  tDay: Nd,
  tDayBtn: $d,
  tWd: xd,
  tDayNum: Dd,
  tAllDayRow: Ad,
  allDayCell: Cd,
  tBody: Sd,
  tGrid: Md,
  tGutter: Td,
  tCols: qd,
  tCol: Bd,
  tSel: Ld,
  tEvTitle: jd,
  tEvTime: Rd,
  tEvShort: Id,
  contTop: Od,
  contBottom: Pd,
  resize: Xd,
  now: zd,
  agenda: Fd,
  aDay: Hd,
  aDate: Wd,
  aDateBtn: Kd,
  aDayNum: Ud,
  aDayWd: Gd,
  aList: Yd,
  aTime: Vd,
  aTitle: Qd,
  aSpan: Jd,
  aLoc: Zd,
  empty: ef,
  pop: tf,
  popHead: nf,
  popDay: af,
  popClose: rf,
  popList: sf,
  tAllDayOnly: of
}, fn = 22, lf = {
  accent: S.tAccent,
  ok: S.tOk,
  warn: S.tWarn,
  danger: S.tDanger,
  violet: S.tViolet,
  gray: S.tGray
};
function Rn(e) {
  var t;
  return e.color ? "" : lf[(t = e.tone) != null ? t : "accent"];
}
function In(e) {
  if (e.color)
    return { "--ev": e.color };
}
function Or(e, t) {
  return [e.ev.title, ha(e, t.allDay), e.ev.location].filter(Boolean).join(", ");
}
const sn = (e, t) => !!e.onEventChange && !t.locked;
function $n(e, t, a) {
  var r;
  for (const s of document.elementsFromPoint(e, t)) {
    const o = (r = s.closest) == null ? void 0 : r.call(s, `[${a}]`);
    if (o) return o;
  }
  return null;
}
function Cn(e, t) {
  const a = e.clientX, r = e.clientY;
  let s = !1;
  const o = (m) => {
    !s && Math.hypot(m.clientX - a, m.clientY - r) < 4 || (s = !0, t.move(m));
  }, l = () => {
    window.removeEventListener("pointermove", o), window.removeEventListener("pointerup", c), window.removeEventListener("pointercancel", i), window.removeEventListener("keydown", u, !0);
  }, c = (m) => {
    l(), t.end(m, s);
  }, i = () => {
    l(), t.cancel();
  }, u = (m) => {
    m.key === "Escape" && (m.preventDefault(), m.stopPropagation(), i());
  };
  window.addEventListener("pointermove", o), window.addEventListener("pointerup", c), window.addEventListener("pointercancel", i), window.addEventListener("keydown", u, !0);
}
function Pr(e) {
  const [t, a] = A(null), [r, s] = A(null), o = B(!1);
  return { preview: t, items: (f, _) => Ln(e.events, f, _, t), onItemDown: (f, _) => {
    var d;
    if (f.button !== 0 || !sn(e, _.ev)) return;
    const p = (d = $n(f.clientX, f.clientY, "data-cal-day")) == null ? void 0 : d.dataset.calDay;
    if (!p) return;
    o.current = !1;
    let y = 0;
    Cn(f, {
      move: (b) => {
        var N;
        o.current = !0;
        const w = (N = $n(b.clientX, b.clientY, "data-cal-day")) == null ? void 0 : N.dataset.calDay;
        w && (y = Wt(p, w), a({ id: _.ev.id, ...sa(_, y * Se) }));
      },
      end: (b, w) => {
        var N;
        a(null), w && y && ((N = e.onEventChange) == null || N.call(e, _.ev, sa(_, y * Se)));
      },
      cancel: () => a(null)
    });
  }, onCellDown: (f, _) => {
    if (f.button !== 0 || !e.onCreate) return;
    f.preventDefault();
    let p = _;
    s({ a: _, b: _ }), Cn(f, {
      move: (y) => {
        var b;
        const d = (b = $n(y.clientX, y.clientY, "data-cal-day")) == null ? void 0 : b.dataset.calDay;
        d && (p = d, s({ a: _, b: d }));
      },
      end: () => {
        var b;
        s(null);
        const [y, d] = _ <= p ? [_, p] : [p, _];
        (b = e.onCreate) == null || b.call(e, { start: y, end: d, allDay: !0 });
      },
      cancel: () => s(null)
    });
  }, clickItem: (f, _) => {
    var p;
    if (o.current) {
      o.current = !1;
      return;
    }
    (p = e.onEventClick) == null || p.call(e, _, f);
  }, inSel: (f) => !!r && f >= (r.a < r.b ? r.a : r.b) && f <= (r.a < r.b ? r.b : r.a) };
}
function Xr({
  segs: e,
  cols: t,
  top: a,
  ctx: r,
  drag: s
}) {
  return /* @__PURE__ */ n.createElement("div", { className: S.barLayer }, e.map((o) => {
    var f;
    const l = o.item, c = l.ev, i = hm(l), u = tt(l.s - pe(l.sDay)), m = [
      S.chip,
      i ? S.bar : S.dotChip,
      Rn(c),
      o.contL ? S.contL : "",
      o.contR ? S.contR : "",
      ((f = s.preview) == null ? void 0 : f.id) === c.id ? S.ghost : "",
      sn(r, c) ? S.movable : ""
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: `${c.id}:${o.col}`,
        type: "button",
        className: m,
        style: {
          left: `calc(${o.col / t * 100}% + 2px)`,
          width: `calc(${o.span / t * 100}% - 4px)`,
          top: a + o.lane * fn,
          ...In(c)
        },
        "aria-label": Or(l, r.L),
        onPointerDown: (_) => s.onItemDown(_, l),
        onClick: (_) => s.clickItem(_.currentTarget, c)
      },
      i ? /* @__PURE__ */ n.createElement("span", { className: S.chipTitle }, !l.allDay && !o.contL && /* @__PURE__ */ n.createElement("span", { className: S.chipTime }, u), c.title) : /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("i", { className: S.dot, "aria-hidden": !0 }), /* @__PURE__ */ n.createElement("span", { className: S.chipTime }, u), /* @__PURE__ */ n.createElement("span", { className: S.chipTitle }, c.title))
    );
  }));
}
const Wn = 26;
function cf({ ctx: e }) {
  const { L: t, cursor: a, today: r, weekStartsOn: s, showWeekends: o, holidays: l } = e, c = a.slice(0, 7), i = we(
    () => jr(a, s).map(($) => o ? $ : $.filter((h) => !dn(h))),
    [a, s, o]
  ), u = i[0].length, m = Pr(e), f = m.items(i[0][0], i[i.length - 1][u - 1]), _ = B(null), [p, y] = A(0);
  xe(() => {
    const $ = _.current;
    if (!$) return;
    const h = () => y($.clientHeight / i.length);
    if (h(), typeof ResizeObserver == "undefined") return;
    const v = new ResizeObserver(h);
    return v.observe($), () => v.disconnect();
  }, [i.length]);
  const d = p ? Math.max(1, Math.floor((p - Wn - 4) / fn)) : 3, b = B(!1), w = B(null);
  G(() => {
    var $, h;
    b.current && (b.current = !1, (h = ($ = w.current) == null ? void 0 : $.querySelector(`[data-cal-day="${a}"]`)) == null || h.focus());
  }, [a, c]);
  const N = ($, h) => {
    let v = ke($, h);
    for (; !o && dn(v); ) v = ke(v, h > 0 ? 1 : -1);
    return v;
  }, g = ($, h, v) => {
    let E = null;
    if ($.key === "ArrowLeft") E = N(h, -1);
    else if ($.key === "ArrowRight") E = N(h, 1);
    else if ($.key === "ArrowUp") E = N(h, -7);
    else if ($.key === "ArrowDown") E = N(h, 7);
    else if ($.key === "Home") E = v[0];
    else if ($.key === "End") E = v[v.length - 1];
    else if ($.key === "Enter" || $.key === " ") {
      $.preventDefault(), e.goto("day", h);
      return;
    }
    E && ($.preventDefault(), b.current = !0, e.setCursor(E));
  };
  return /* @__PURE__ */ n.createElement("div", { className: S.month, role: "grid", "aria-label": t.ym(`${c}-01`), ref: w }, /* @__PURE__ */ n.createElement("div", { className: S.mHead, role: "row" }, i[0].map(($) => {
    const h = je(de($));
    return /* @__PURE__ */ n.createElement("div", { key: $, role: "columnheader", className: [S.wdName, h === 0 ? S.sun : "", h === 6 ? S.sat : ""].join(" ") }, t.weekdays[h]);
  })), /* @__PURE__ */ n.createElement("div", { className: S.mBody, ref: _ }, i.map(($) => {
    const { shown: h, more: v } = km(Rr(f, $), u, d);
    return /* @__PURE__ */ n.createElement("div", { key: $[0], className: S.mWeek, role: "row" }, /* @__PURE__ */ n.createElement("div", { className: S.mCells, style: { gridTemplateColumns: `repeat(${u}, minmax(0, 1fr))` } }, $.map((E) => {
      const x = de(E), C = je(x), M = l[E], T = f.filter((q) => q.sDay <= E && q.eDay >= E).length, I = [
        S.cell,
        E.slice(0, 7) !== c ? S.out : "",
        C === 0 || M ? S.sun : C === 6 ? S.sat : "",
        E === r ? S.isToday : "",
        m.inSel(E) ? S.selDay : "",
        e.onCreate ? S.creatable : ""
      ].filter(Boolean).join(" ");
      return /* @__PURE__ */ n.createElement(
        "div",
        {
          key: E,
          role: "gridcell",
          "data-cal-day": E,
          tabIndex: E === a ? 0 : -1,
          "aria-selected": E === a,
          "aria-current": E === r ? "date" : void 0,
          "aria-label": `${t.dayAria(E)}${M ? ` ${M}` : ""}, ${t.eventCount(T)}`,
          className: I,
          onPointerDown: (q) => m.onCellDown(q, E),
          onKeyDown: (q) => g(q, E, $)
        },
        /* @__PURE__ */ n.createElement("div", { className: S.cellHead }, /* @__PURE__ */ n.createElement(
          "button",
          {
            type: "button",
            tabIndex: -1,
            className: S.dayNum,
            "aria-label": t.openDay(E),
            onPointerDown: (q) => q.stopPropagation(),
            onClick: () => e.goto("day", E)
          },
          x.d === 1 ? t.md(E) : x.d
        ), M && /* @__PURE__ */ n.createElement("span", { className: S.holiday, title: M }, M), e.onCreate && /* @__PURE__ */ n.createElement("span", { className: S.addHint, "aria-hidden": !0 }, "+"))
      );
    })), /* @__PURE__ */ n.createElement(Xr, { segs: h, cols: u, top: Wn, ctx: e, drag: m }), v.map((E, x) => E > 0 ? /* @__PURE__ */ n.createElement(
      "button",
      {
        key: $[x],
        type: "button",
        className: S.more,
        style: {
          left: `calc(${x / u * 100}% + 2px)`,
          width: `calc(${100 / u}% - 4px)`,
          top: Wn + (d - 1) * fn
        },
        onClick: (C) => e.openMore($[x], C.currentTarget)
      },
      t.more(E)
    ) : null));
  })));
}
const Je = 44, uf = Array.from({ length: 23 }, (e, t) => t + 1);
function Ra() {
  const e = /* @__PURE__ */ new Date();
  return Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes()) / 6e4;
}
function Kn(e, t) {
  const a = t.getBoundingClientRect();
  return Math.max(0, Math.min(Se, (e - a.top) / Je * 60));
}
function Ia({ ctx: e, days: t }) {
  const a = t.length, r = e.slotMinutes, s = Pr(e), [o, l] = A(null), [c, i] = A(null), u = B(!1), m = Ln(e.events, t[0], t[a - 1], o != null ? o : s.preview), f = Rr(e.timeGrid ? m.filter(Lr) : m, t), _ = f.reduce((h, v) => Math.max(h, v.lane + 1), 0), p = { gridTemplateColumns: `repeat(${a}, minmax(0, 1fr))` }, [y, d] = A(Ra);
  G(() => {
    const h = window.setInterval(() => d(Ra()), 6e4);
    return () => window.clearInterval(h);
  }, []);
  const b = B(null), w = t.includes(e.today);
  xe(() => {
    const h = b.current;
    if (!h) return;
    const v = w ? Math.max(0, Math.floor((y - pe(e.today)) / 60) - 1) : e.scrollToHour;
    h.scrollTop = v * Je;
  }, [t[0], a]);
  const N = (h, v) => {
    if (h.button !== 0 || !e.onCreate) return;
    h.preventDefault();
    const E = h.currentTarget, x = Math.min(Se - r, Math.floor(Kn(h.clientY, E) / r) * r);
    let C = x;
    i({ day: v, a: x, b: x + r }), Cn(h, {
      move: (M) => {
        C = Math.min(Se - r, Math.floor(Kn(M.clientY, E) / r) * r), i({ day: v, a: Math.min(x, C), b: Math.max(x, C) + r });
      },
      end: (M, T) => {
        var Y;
        i(null);
        const I = pe(v), q = T ? Math.min(x, C) : x, X = T ? Math.max(x, C) + r : Math.min(x + 60, Se);
        (Y = e.onCreate) == null || Y.call(e, { start: rn(I + q), end: rn(I + X), allDay: !1 });
      },
      cancel: () => i(null)
    });
  }, g = (h, v, E) => {
    if (h.stopPropagation(), h.button !== 0 || !sn(e, v.ev)) return;
    const x = (T, I) => {
      const q = $n(T, I, "data-cal-col");
      return q ? pe(q.dataset.calCol) + Kn(I, q) : null;
    }, C = x(h.clientX, h.clientY);
    if (C == null) return;
    u.current = !1;
    let M = null;
    Cn(h, {
      move: (T) => {
        u.current = !0;
        const I = x(T.clientX, T.clientY);
        if (I != null) {
          if (E === "move") {
            const q = La(I - C, r);
            M = q ? sa(v, q) : null;
          } else {
            const q = Math.max(v.s + r, La(I, r));
            M = q !== v.e ? { start: v.ev.start, end: rn(q) } : null;
          }
          l(M ? { id: v.ev.id, ...M } : null);
        }
      },
      end: (T, I) => {
        var q;
        l(null), I && M && ((q = e.onEventChange) == null || q.call(e, v.ev, M));
      },
      cancel: () => l(null)
    });
  }, $ = (h, v) => {
    var E;
    if (u.current) {
      u.current = !1;
      return;
    }
    (E = e.onEventClick) == null || E.call(e, v, h);
  };
  return /* @__PURE__ */ n.createElement("div", { className: S.time }, /* @__PURE__ */ n.createElement("div", { className: S.tHead }, /* @__PURE__ */ n.createElement("div", { className: S.gutter }), /* @__PURE__ */ n.createElement("div", { className: S.tHeadDays, style: p }, t.map((h) => {
    const v = de(h), E = je(v), x = e.holidays[h];
    return /* @__PURE__ */ n.createElement(
      "div",
      {
        key: h,
        className: [S.tDay, h === e.today ? S.isToday : "", E === 0 || x ? S.sun : E === 6 ? S.sat : ""].join(" ")
      },
      /* @__PURE__ */ n.createElement("button", { type: "button", className: S.tDayBtn, onClick: () => e.goto("day", h), "aria-label": e.L.openDay(h) }, /* @__PURE__ */ n.createElement("span", { className: S.tWd }, e.L.weekdays[E]), /* @__PURE__ */ n.createElement("span", { className: S.tDayNum }, v.d)),
      x && /* @__PURE__ */ n.createElement("span", { className: S.holiday, title: x }, x)
    );
  }))), /* @__PURE__ */ n.createElement("div", { className: [S.tAllDay, e.timeGrid ? "" : S.tAllDayOnly].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: S.gutter }, e.timeGrid ? e.L.allDay : ""), /* @__PURE__ */ n.createElement(
    "div",
    {
      className: S.tAllDayRow,
      style: e.timeGrid ? { height: Math.max(1, _) * fn + 6 } : { minHeight: Math.max(1, _) * fn + 6 }
    },
    /* @__PURE__ */ n.createElement("div", { className: S.tAllDayCells, style: p }, t.map((h) => /* @__PURE__ */ n.createElement(
      "div",
      {
        key: h,
        "data-cal-day": h,
        className: [S.allDayCell, s.inSel(h) ? S.selDay : "", e.onCreate ? S.creatable : ""].join(" "),
        onPointerDown: (v) => s.onCellDown(v, h)
      }
    ))),
    /* @__PURE__ */ n.createElement(Xr, { segs: f, cols: a, top: 3, ctx: e, drag: s })
  )), e.timeGrid && /* @__PURE__ */ n.createElement("div", { className: S.tBody, ref: b }, /* @__PURE__ */ n.createElement("div", { className: S.tGrid, style: { height: 24 * Je } }, /* @__PURE__ */ n.createElement("div", { className: S.tGutter, "aria-hidden": !0 }, uf.map((h) => /* @__PURE__ */ n.createElement("span", { key: h, style: { top: h * Je } }, tt(h * 60)))), /* @__PURE__ */ n.createElement("div", { className: S.tCols, style: { ...p, backgroundSize: `100% ${Je}px` } }, t.map((h) => {
    const v = Nm(m, h);
    return /* @__PURE__ */ n.createElement(
      "div",
      {
        key: h,
        "data-cal-col": h,
        className: [S.tCol, h === e.today ? S.isToday : "", e.onCreate ? S.creatable : ""].join(" "),
        onPointerDown: (E) => N(E, h)
      },
      (c == null ? void 0 : c.day) === h && /* @__PURE__ */ n.createElement("div", { className: S.tSel, style: { top: c.a / 60 * Je, height: (c.b - c.a) / 60 * Je } }, tt(c.a), " – ", c.b === Se ? "24:00" : tt(c.b)),
      v.map((E) => {
        const x = E.item.ev, C = (E.bottom - E.top) / 60 * Je, M = [
          S.tEv,
          Rn(x),
          C < 34 ? S.tEvShort : "",
          E.contTop ? S.contTop : "",
          E.contBottom ? S.contBottom : "",
          (o == null ? void 0 : o.id) === x.id ? S.ghost : "",
          sn(e, x) ? S.movable : ""
        ].filter(Boolean).join(" ");
        return /* @__PURE__ */ n.createElement(
          "button",
          {
            key: x.id,
            type: "button",
            className: M,
            style: {
              top: E.top / 60 * Je,
              height: Math.max(18, C - 1),
              left: `calc(${E.col / E.cols * 100}% + 1px)`,
              width: `calc(${100 / E.cols}% - 4px)`,
              ...In(x)
            },
            "aria-label": Or(E.item, e.L),
            onPointerDown: (T) => g(T, E.item, "move"),
            onClick: (T) => $(T.currentTarget, x)
          },
          /* @__PURE__ */ n.createElement("span", { className: S.tEvTitle }, x.title),
          /* @__PURE__ */ n.createElement("span", { className: S.tEvTime }, ha(E.item, e.L.allDay)),
          sn(e, x) && !E.contBottom && /* @__PURE__ */ n.createElement("span", { className: S.resize, "aria-hidden": !0, onPointerDown: (T) => g(T, E.item, "resize") })
        );
      }),
      h === e.today && /* @__PURE__ */ n.createElement("div", { className: S.now, style: { top: (y - pe(h)) / 60 * Je }, "aria-hidden": !0 })
    );
  })))));
}
function Oa(e, t, a) {
  return e.sDay === e.eDay ? ha(e, a) : e.allDay ? a : t === e.sDay ? `${tt(e.s - pe(t))} ~` : t === e.eDay ? `~ ${tt(e.e - pe(t))}` : a;
}
function mf({ ctx: e }) {
  const { L: t } = e, { from: a, to: r } = Ea("agenda", e.cursor, e.weekStartsOn), s = Ln(e.events, a, r), o = jn(a, r).filter((l) => e.showWeekends || !dn(l)).map((l) => {
    const c = pe(l), i = (m) => Oa(m, l, "") === "" ? -1 : Math.max(m.s, c), u = s.filter((m) => m.sDay <= l && m.eDay >= l);
    return { day: l, list: u.sort((m, f) => i(m) - i(f)) };
  }).filter((l) => l.list.length > 0);
  return o.length ? /* @__PURE__ */ n.createElement("div", { className: S.agenda }, o.map(({ day: l, list: c }) => {
    const i = de(l), u = e.holidays[l], m = je(i), f = t.weekdays[m];
    return /* @__PURE__ */ n.createElement("section", { key: l, className: [S.aDay, l === e.today ? S.isToday : ""].join(" "), "aria-label": t.dayAria(l) }, /* @__PURE__ */ n.createElement("div", { className: [S.aDate, m === 0 || u ? S.sun : m === 6 ? S.sat : ""].join(" ") }, /* @__PURE__ */ n.createElement("button", { type: "button", className: S.aDateBtn, onClick: () => e.goto("day", l) }, /* @__PURE__ */ n.createElement("span", { className: S.aDayNum }, i.d), /* @__PURE__ */ n.createElement("span", { className: S.aDayWd }, t.m(l), " · ", f)), u && /* @__PURE__ */ n.createElement("span", { className: S.holiday }, u)), /* @__PURE__ */ n.createElement("ul", { className: S.aList }, c.map((_) => {
      const p = _.ev, y = Wt(_.sDay, _.eDay) + 1;
      return /* @__PURE__ */ n.createElement("li", { key: p.id }, /* @__PURE__ */ n.createElement(
        "button",
        {
          type: "button",
          className: [S.aRow, Rn(p)].join(" "),
          style: In(p),
          onClick: (d) => {
            var b;
            return (b = e.onEventClick) == null ? void 0 : b.call(e, p, d.currentTarget);
          }
        },
        /* @__PURE__ */ n.createElement("i", { className: S.dot, "aria-hidden": !0 }),
        /* @__PURE__ */ n.createElement("span", { className: S.aTime }, Oa(_, l, t.allDay)),
        /* @__PURE__ */ n.createElement("span", { className: S.aTitle }, p.title, y > 1 && /* @__PURE__ */ n.createElement("em", { className: S.aSpan }, t.dayOfSpan(Wt(_.sDay, l) + 1, y))),
        p.location && /* @__PURE__ */ n.createElement("span", { className: S.aLoc }, p.location)
      ));
    })));
  })) : /* @__PURE__ */ n.createElement("div", { className: S.empty }, t.empty);
}
const Un = { KeyM: "month", KeyW: "week", KeyD: "day", KeyA: "agenda" };
function Pa(e, t, a) {
  const [r, s] = A(t), o = e !== void 0 ? e : r;
  return [o, (c) => {
    e === void 0 && s(c), c !== o && (a == null || a(c));
  }];
}
const Xa = ({ dir: e }) => /* @__PURE__ */ n.createElement("svg", { width: "15", height: "15", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": !0 }, /* @__PURE__ */ n.createElement("path", { d: e === "l" ? "M15 5l-7 7 7 7" : "M9 5l7 7-7 7" }));
function b0({
  events: e,
  view: t,
  defaultView: a,
  onViewChange: r,
  date: s,
  defaultDate: o,
  onDateChange: l,
  views: c = ["month", "week", "day", "agenda"],
  weekStartsOn: i = 0,
  defaultShowWeekends: u = !0,
  weekendToggle: m = !0,
  holidays: f,
  slotMinutes: _ = 30,
  scrollToHour: p = 8,
  timeGrid: y = !0,
  onRangeChange: d,
  onEventClick: b,
  onCreate: w,
  onEventChange: N,
  locale: g = Ir,
  loading: $,
  headerExtra: h,
  className: v = "",
  style: E,
  "aria-label": x
}) {
  var V;
  const C = Tr(), [M, T] = Pa(t, (V = a != null ? a : c[0]) != null ? V : "month", r), [I, q] = Pa(s, o != null ? o : C, l), X = de(I) ? I : C, [Y, K] = A(u), [j, ne] = A(null), ae = B(null), k = B(!1);
  G(() => {
    var W;
    if (!k.current) return;
    k.current = !1;
    const z = ae.current;
    !z || z.contains(document.activeElement) || ((W = z.querySelector('[data-cal-day][tabindex="0"]')) != null ? W : z).focus();
  });
  const { from: O, to: Q } = Ea(M, X, i), J = B(d);
  J.current = d, G(() => {
    var z;
    (z = J.current) == null || z.call(J, { from: O, to: Q, view: M });
  }, [O, Q, M]);
  const se = (z, W) => {
    q(W), c.includes(z) && T(z);
  }, L = {
    events: e,
    L: g,
    cursor: X,
    today: C,
    weekStartsOn: i,
    showWeekends: Y,
    holidays: f != null ? f : {},
    slotMinutes: _,
    scrollToHour: p,
    timeGrid: y,
    setCursor: q,
    goto: se,
    openMore: (z, W) => ne({ day: z, anchor: W }),
    onEventClick: b,
    onCreate: w,
    onEventChange: N
  }, Z = (z) => q(gm(M, X, z, M === "day" && !Y)), R = (z) => {
    if (z.defaultPrevented || z.ctrlKey || z.metaKey || z.altKey || z.target.closest('input, textarea, select, [contenteditable="true"]')) return;
    const W = z.nativeEvent.code;
    if (W === "KeyT") q(C);
    else if (W === "KeyN" || W === "KeyJ" || z.key === "PageDown") Z(1);
    else if (W === "KeyP" || W === "KeyK" || z.key === "PageUp") Z(-1);
    else if (Un[W] && c.includes(Un[W])) T(Un[W]);
    else if (W === "KeyC" && w)
      w(M === "month" || M === "agenda" ? { start: X, end: X, allDay: !0 } : { start: `${X}T09:00`, end: `${X}T10:00`, allDay: !1 });
    else return;
    z.preventDefault(), k.current = !0;
  }, F = we(
    () => jn(O, Q).filter((z) => Y || !dn(z)),
    [O, Q, Y]
  );
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [S.cal, v].filter(Boolean).join(" "),
      style: E,
      role: "region",
      "aria-label": x != null ? x : g.region,
      "aria-busy": $ || void 0,
      "aria-keyshortcuts": "T N P M W D A C",
      onKeyDown: R,
      ref: ae,
      tabIndex: -1
    },
    /* @__PURE__ */ n.createElement("div", { className: S.toolbar }, /* @__PURE__ */ n.createElement(mt, { onClick: () => q(C), title: `${g.today} (T)` }, g.today), /* @__PURE__ */ n.createElement("span", { className: S.navBtns }, /* @__PURE__ */ n.createElement(na, { label: g.prev(M), onClick: () => Z(-1) }, /* @__PURE__ */ n.createElement(Xa, { dir: "l" })), /* @__PURE__ */ n.createElement(na, { label: g.next(M), onClick: () => Z(1) }, /* @__PURE__ */ n.createElement(Xa, { dir: "r" }))), /* @__PURE__ */ n.createElement("h2", { className: S.title, "aria-live": "polite" }, vm(M, X, i, g)), /* @__PURE__ */ n.createElement("span", { className: S.toolRight }, h, m && M !== "day" && /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: S.toggle,
        "aria-pressed": !Y,
        onClick: () => K((z) => !z)
      },
      g.hideWeekends
    ), c.length > 1 && /* @__PURE__ */ n.createElement(
      vr,
      {
        variant: "segmented",
        "aria-label": g.viewTabs,
        items: c.map((z) => ({ key: z, label: g.views[z] })),
        value: M,
        onChange: (z) => T(z)
      }
    ))),
    /* @__PURE__ */ n.createElement("div", { className: S.body }, $ && /* @__PURE__ */ n.createElement("div", { className: S.busy, role: "progressbar", "aria-label": g.loading }), M === "month" && /* @__PURE__ */ n.createElement(cf, { ctx: L }), M === "week" && /* @__PURE__ */ n.createElement(Ia, { ctx: L, days: F }), M === "day" && /* @__PURE__ */ n.createElement(Ia, { ctx: L, days: [X] }), M === "agenda" && /* @__PURE__ */ n.createElement(mf, { ctx: L })),
    j && /* @__PURE__ */ n.createElement(df, { ctx: L, day: j.day, anchor: j.anchor, onClose: () => ne(null) })
  );
}
function df({ ctx: e, day: t, anchor: a, onClose: r }) {
  const s = B(null), [o, l] = A({ top: -9999, left: -9999 }), c = de(t), i = Ln(e.events, t, t);
  return xe(() => {
    var p;
    const u = s.current;
    if (!u) return;
    const m = a.getBoundingClientRect(), f = u.offsetWidth, _ = u.offsetHeight;
    l({
      left: Math.max(8, Math.min(m.left + m.width / 2 - f / 2, window.innerWidth - f - 8)),
      top: Math.max(8, Math.min(m.top - 60, window.innerHeight - _ - 8))
    }), (p = u.querySelector("[data-cal-pop-item]")) == null || p.focus();
  }, [a]), G(() => {
    const u = () => {
      r(), a.isConnected && a.focus();
    }, m = (_) => {
      var p;
      (p = s.current) != null && p.contains(_.target) || r();
    }, f = (_) => {
      _.key !== "Escape" || _.isComposing || (_.preventDefault(), _.stopPropagation(), u());
    };
    return document.addEventListener("mousedown", m), document.addEventListener("keydown", f, !0), () => {
      document.removeEventListener("mousedown", m), document.removeEventListener("keydown", f, !0);
    };
  }, [a, r]), /* @__PURE__ */ n.createElement(Ut, null, /* @__PURE__ */ n.createElement("div", { ref: s, className: S.pop, style: o, role: "dialog", "aria-label": `${e.L.md(t)} ${e.L.eventCount(i.length)}` }, /* @__PURE__ */ n.createElement("div", { className: S.popHead }, /* @__PURE__ */ n.createElement("button", { type: "button", className: S.popDay, onClick: () => {
    r(), e.goto("day", t);
  } }, /* @__PURE__ */ n.createElement("span", null, e.L.weekdays[je(c)]), /* @__PURE__ */ n.createElement("b", null, c.d)), /* @__PURE__ */ n.createElement("button", { type: "button", className: S.popClose, "aria-label": e.L.close, onClick: r }, "✕")), /* @__PURE__ */ n.createElement("ul", { className: S.popList }, i.map((u) => {
    const m = u.ev, f = u.allDay || u.sDay !== u.eDay;
    return /* @__PURE__ */ n.createElement("li", { key: m.id }, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        "data-cal-pop-item": !0,
        className: [S.popItem, f ? S.bar : S.dotChip, Rn(m)].join(" "),
        style: In(m),
        onClick: () => {
          var _;
          r(), (_ = e.onEventClick) == null || _.call(e, m, a);
        }
      },
      !f && /* @__PURE__ */ n.createElement("i", { className: S.dot, "aria-hidden": !0 }),
      !u.allDay && /* @__PURE__ */ n.createElement("span", { className: S.chipTime }, tt(Math.max(u.s, pe(t)) - pe(t))),
      /* @__PURE__ */ n.createElement("span", { className: S.chipTitle }, m.title)
    ));
  }))));
}
const ff = "_mini_q7p5n_3", _f = "_nav_q7p5n_5", pf = "_navBtn_q7p5n_6", yf = "_todayBtn_q7p5n_6", bf = "_title_q7p5n_6", Ef = "_day_q7p5n_25", hf = "_mon_q7p5n_25", gf = "_grid_q7p5n_29", vf = "_wdRow_q7p5n_30", kf = "_row_q7p5n_30", wf = "_sun_q7p5n_35", Nf = "_sat_q7p5n_36", $f = "_num_q7p5n_45", xf = "_sel_q7p5n_46", Df = "_out_q7p5n_50", Af = "_isToday_q7p5n_52", Cf = "_dots_q7p5n_55", Sf = "_months_q7p5n_59", le = {
  mini: ff,
  nav: _f,
  navBtn: pf,
  todayBtn: yf,
  title: bf,
  day: Ef,
  mon: hf,
  grid: gf,
  wdRow: vf,
  row: kf,
  sun: wf,
  sat: Nf,
  num: $f,
  sel: xf,
  out: Df,
  isToday: Af,
  dots: Cf,
  months: Sf
}, za = (e, t) => `${String(e).padStart(4, "0")}-${String(t).padStart(2, "0")}`;
function E0({
  month: e,
  onMonthChange: t,
  value: a,
  onPick: r,
  marks: s = {},
  markLabel: o,
  holidays: l = {},
  weekStartsOn: c = 0,
  locale: i = Ir,
  today: u,
  children: m,
  className: f = "",
  "aria-label": _
}) {
  const p = u != null ? u : Tr(), y = /^\d{4}-\d{2}$/.test(e) ? `${e}-01` : `${p.slice(0, 7)}-01`, d = de(y), b = An(y, c), w = jn(b, ke(b, 41)), N = o != null ? o : i.eventCount, [g, $] = A("day"), [h, v] = A(d.y), E = (K) => !!K && K.slice(0, 7) === y.slice(0, 7), [x, C] = A(() => E(a) ? a : E(p) ? p : y);
  G(() => {
    E(x) || C(E(a) ? a : E(p) ? p : y);
  }, [y]);
  const M = B(!1), T = B(null);
  G(() => {
    var K, j;
    M.current && (M.current = !1, (j = (K = T.current) == null ? void 0 : K.querySelector(`[data-day="${x}"]`)) == null || j.focus());
  }, [x, y]);
  const I = (K) => {
    M.current = !0, C(K), E(K) || t(K.slice(0, 7));
  }, q = (K) => {
    const j = Nt(d, K);
    t(za(j.y, j.m));
  }, X = (K, j) => {
    const ne = de(j), ae = (je(ne) - c + 7) % 7;
    let k = null;
    if (K.key === "ArrowLeft") k = ke(j, -1);
    else if (K.key === "ArrowRight") k = ke(j, 1);
    else if (K.key === "ArrowUp") k = ke(j, -7);
    else if (K.key === "ArrowDown") k = ke(j, 7);
    else if (K.key === "Home") k = ke(j, -ae);
    else if (K.key === "End") k = ke(j, 6 - ae);
    else if (K.key === "PageUp" || K.key === "PageDown") {
      const O = Nt(ne, K.key === "PageUp" ? -1 : 1);
      k = at(O.y, O.m, O.d);
    }
    k && (K.preventDefault(), I(k));
  }, Y = () => {
    v(d.y), $("month");
  };
  return /* @__PURE__ */ n.createElement("div", { className: [le.mini, f].filter(Boolean).join(" "), role: _ ? "group" : void 0, "aria-label": _ }, g === "day" ? /* @__PURE__ */ n.createElement("div", { className: le.nav }, /* @__PURE__ */ n.createElement("button", { type: "button", className: le.navBtn, "aria-label": i.prevMonth, onClick: () => q(-1) }, "‹"), /* @__PURE__ */ n.createElement("button", { type: "button", className: le.title, "aria-label": `${i.ym(y)}, ${i.pickMonth}`, "aria-live": "polite", onClick: Y }, i.ym(y)), /* @__PURE__ */ n.createElement("button", { type: "button", className: le.navBtn, "aria-label": i.nextMonth, onClick: () => q(1) }, "›"), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: le.todayBtn,
      disabled: E(p),
      onClick: () => {
        t(p.slice(0, 7)), I(p);
      }
    },
    i.today
  )) : /* @__PURE__ */ n.createElement("div", { className: le.nav }, /* @__PURE__ */ n.createElement("button", { type: "button", className: le.navBtn, "aria-label": i.prevYear, onClick: () => v((K) => K - 1) }, "‹"), /* @__PURE__ */ n.createElement("span", { className: le.title, "aria-live": "polite" }, i.year(`${h}-12-31`)), /* @__PURE__ */ n.createElement("button", { type: "button", className: le.navBtn, "aria-label": i.nextYear, onClick: () => v((K) => K + 1) }, "›"), /* @__PURE__ */ n.createElement("button", { type: "button", className: le.todayBtn, onClick: () => $("day"), "aria-label": i.close }, "✕")), g === "month" ? /* @__PURE__ */ n.createElement("div", { className: le.months, onKeyDown: (K) => {
    K.key === "Escape" && (K.preventDefault(), $("day"));
  } }, Array.from({ length: 12 }, (K, j) => {
    const ne = za(h, j + 1), ae = ne === y.slice(0, 7);
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: ne,
        type: "button",
        className: [le.mon, ae ? le.sel : "", ne === p.slice(0, 7) ? le.isToday : ""].filter(Boolean).join(" "),
        "aria-pressed": ae,
        autoFocus: ae,
        onClick: () => {
          t(ne), $("day");
        }
      },
      i.m(`${ne}-01`)
    );
  })) : /* @__PURE__ */ n.createElement("div", { className: le.grid, role: "grid", "aria-label": i.ym(y), ref: T }, /* @__PURE__ */ n.createElement("div", { className: le.wdRow, role: "row" }, w.slice(0, 7).map((K) => {
    const j = je(de(K));
    return /* @__PURE__ */ n.createElement("span", { key: K, role: "columnheader", className: j === 0 ? le.sun : j === 6 ? le.sat : "" }, i.weekdays[j]);
  })), [0, 1, 2, 3, 4, 5].map((K) => /* @__PURE__ */ n.createElement("div", { key: K, className: le.row, role: "row" }, w.slice(K * 7, K * 7 + 7).map((j) => {
    var Q;
    const ne = je(de(j)), ae = l[j], k = (Q = s[j]) != null ? Q : 0, O = [
      le.day,
      E(j) ? "" : le.out,
      ne === 0 || ae ? le.sun : ne === 6 ? le.sat : "",
      j === p ? le.isToday : "",
      j === a ? le.sel : ""
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: j,
        type: "button",
        role: "gridcell",
        "data-day": j,
        className: O,
        tabIndex: j === x ? 0 : -1,
        "aria-selected": j === a,
        "aria-current": j === p ? "date" : void 0,
        "aria-label": [i.dayAria(j), ae, k ? N(k) : ""].filter(Boolean).join(", "),
        onKeyDown: (J) => X(J, j),
        onFocus: () => C(j),
        onClick: () => r(j)
      },
      /* @__PURE__ */ n.createElement("span", { className: le.num }, +j.slice(8)),
      /* @__PURE__ */ n.createElement("span", { className: le.dots, "aria-hidden": !0 }, Array.from({ length: Math.min(k, 3) }, (J, se) => /* @__PURE__ */ n.createElement("i", { key: se })))
    );
  })))), m);
}
function Mf(e) {
  const t = e.match(/\d/g);
  return t ? t.length : 0;
}
function h0({
  value: e,
  onChangeAm: t,
  allowNegative: a = !0,
  onReject: r,
  unit: s,
  className: o,
  ...l
}) {
  const c = B(null), i = B(null), [u, m] = A(!1), f = e == null || e === "";
  xe(() => {
    const p = c.current, y = i.current;
    if (i.current = null, !p || y === null) return;
    let d = 0, b = 0;
    for (; d < p.value.length && b < y; )
      /\d/.test(p.value[d]) && (b += 1), d += 1;
    d === 0 && p.value[0] === "-" && (d = 1), p.setSelectionRange(d, d);
  });
  const _ = /* @__PURE__ */ n.createElement(
    "input",
    {
      ...l,
      ref: c,
      type: "text",
      inputMode: "numeric",
      className: o,
      value: u && f ? "-" : is(e),
      onChange: (p) => {
        var b;
        const y = p.target;
        i.current = Mf(y.value.slice(0, (b = y.selectionStart) != null ? b : y.value.length));
        const d = ls(y.value, a);
        if (r) {
          const w = br(y.value);
          !a && /^\s*-/.test(w) ? r("sign") : (/\.\d/.test(w.replace(/^\s*-/, "")) || /\.$/.test(w)) && r("decimal");
        }
        m(d === "-"), t({ text: d, num: cs(d) });
      }
    }
  );
  return s ? /* @__PURE__ */ n.createElement(n.Fragment, null, _, /* @__PURE__ */ n.createElement("span", { className: "axe-money-unit", style: { marginLeft: 6, fontSize: 12, color: "#334155", whiteSpace: "nowrap" } }, s)) : _;
}
function oa(e) {
  const t = br(e).replace(/,/g, "").trim();
  if (t === "") return null;
  const a = Number(t);
  return Number.isFinite(a) ? a : null;
}
function Fa(e, t) {
  const a = oa(e), r = oa(t);
  return a == null || r == null ? null : Math.round(a * r);
}
function g0(e, t) {
  var o, l;
  const a = Fa(e.qty, e.unitAm), r = Fa((o = t.qty) != null ? o : e.qty, (l = t.unitAm) != null ? l : e.unitAm);
  if (r == null) return t;
  const s = oa(e.lineAm);
  return s == null || s === a ? { ...t, lineAm: String(r) } : t;
}
const Tf = "_box_qzg36_3", qf = "_banner_qzg36_9", Bf = "_verify_qzg36_10", Lf = "_t_info_qzg36_15", jf = "_t_warn_qzg36_16", Rf = "_t_danger_qzg36_17", If = "_error_qzg36_22", Of = "_note_qzg36_30", Pf = "_noteI_qzg36_42", Xf = "_noteBody_qzg36_43", zf = "_badge_qzg36_49", Ff = "_b_muted_qzg36_53", Hf = "_b_ok_qzg36_54", Wf = "_b_warn_qzg36_55", Kf = "_b_info_qzg36_56", Uf = "_b_off_qzg36_57", Fe = {
  box: Tf,
  banner: qf,
  verify: Bf,
  t_info: Lf,
  t_warn: jf,
  t_danger: Rf,
  error: If,
  note: Of,
  noteI: Pf,
  noteBody: Xf,
  badge: zf,
  b_muted: Ff,
  b_ok: Hf,
  b_warn: Wf,
  b_info: Kf,
  b_off: Uf
};
function Gf({ tone: e = "warn", className: t = "", children: a }) {
  return /* @__PURE__ */ n.createElement("div", { className: [Fe.box, Fe.banner, Fe[`t_${e}`], t].filter(Boolean).join(" ") }, a);
}
function v0({ tone: e = "ok", className: t = "", children: a }) {
  const r = e === "ok" ? "info" : e === "bad" ? "danger" : "warn";
  return /* @__PURE__ */ n.createElement("div", { className: [Fe.box, Fe.verify, Fe[`t_${r}`], t].filter(Boolean).join(" ") }, a);
}
function zr({ className: e = "", children: t }) {
  return t == null || t === !1 || t === "" ? null : /* @__PURE__ */ n.createElement("p", { className: [Fe.error, e].filter(Boolean).join(" "), role: "alert" }, typeof t == "string" ? /* @__PURE__ */ n.createElement(Yf, { text: t }) : t);
}
function k0({ label: e = "안내", className: t = "", children: a }) {
  return /* @__PURE__ */ n.createElement("details", { className: [Fe.note, t].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("summary", null, /* @__PURE__ */ n.createElement("span", { className: Fe.noteI, "aria-hidden": "true" }, "ⓘ"), e), /* @__PURE__ */ n.createElement("div", { className: Fe.noteBody }, a));
}
function Ha({ tone: e = "muted", className: t = "", children: a }) {
  return /* @__PURE__ */ n.createElement("span", { className: ["axe-badge", Fe.badge, Fe[`b_${e}`], t].filter(Boolean).join(" ") }, a);
}
function Yf({ text: e }) {
  return e ? /* @__PURE__ */ n.createElement(n.Fragment, null, e.split(/\*\*(.+?)\*\*/g).map((t, a) => a % 2 ? /* @__PURE__ */ n.createElement("b", { key: a }, t) : /* @__PURE__ */ n.createElement(ss, { key: a }, t))) : null;
}
const Vf = "저장하지 않은 변경이 있습니다. 버리고 이동할까요?";
function Qf(e, t = Vf) {
  const a = B(e);
  return a.current = e, G(() => {
    if (!e) return;
    const r = (s) => {
      s.preventDefault(), s.returnValue = "";
    };
    return window.addEventListener("beforeunload", r), () => window.removeEventListener("beforeunload", r);
  }, [e]), oe(() => !a.current || window.confirm(t), [t]);
}
const Jf = "_overlay_1qt6w_2", Zf = "_modal_1qt6w_8", e_ = "_wide_1qt6w_15", t_ = "_head_1qt6w_16", n_ = "_title_1qt6w_20", a_ = "_close_1qt6w_21", r_ = "_body_1qt6w_25", s_ = "_flush_1qt6w_26", o_ = "_error_1qt6w_27", l_ = "_foot_1qt6w_29", Ve = {
  overlay: Jf,
  modal: Zf,
  wide: e_,
  head: t_,
  title: n_,
  close: a_,
  body: r_,
  flush: s_,
  error: o_,
  foot: l_
}, Tt = [];
function Wa(e) {
  const t = Tt[Tt.length - 1];
  e.key !== "Escape" || e.defaultPrevented || e.isComposing || !t || !t.esc || (e.preventDefault(), t.close());
}
const c_ = 'a[href],button:not(:disabled),input:not(:disabled):not([type=hidden]),select:not(:disabled),textarea:not(:disabled),[tabindex]:not([tabindex="-1"])';
function Ka(e) {
  return Array.from(e.querySelectorAll(c_)).filter((t) => t.getClientRects().length > 0 && getComputedStyle(t).visibility !== "hidden");
}
let Ua = 0, Ga = "";
function On({
  title: e,
  onClose: t,
  children: a,
  wide: r,
  footer: s,
  headerExtra: o,
  flush: l,
  closeOnBackdrop: c = !0,
  closeOnEsc: i = !1,
  error: u,
  confirmDiscard: m = !0
}) {
  const [f, _] = A(!1), p = m ? () => {
    f || _(!0);
  } : void 0, y = Qf(m && f, "입력한 내용을 저장하지 않고 닫을까요?"), d = () => {
    y() && t();
  }, b = B(d);
  b.current = d;
  const w = B({ close: () => b.current(), esc: i });
  w.current.esc = i, G(() => {
    const v = w.current;
    return Tt.push(v), Tt.length === 1 && window.addEventListener("keydown", Wa), () => {
      const E = Tt.lastIndexOf(v);
      E >= 0 && Tt.splice(E, 1), Tt.length === 0 && window.removeEventListener("keydown", Wa);
    };
  }, []);
  const N = B(null), g = B(null), $ = B(void 0);
  $.current === void 0 && ($.current = typeof document == "undefined" ? null : document.activeElement), G(() => {
    var x;
    const v = N.current, E = (x = $.current) != null ? x : null;
    return v && !v.contains(document.activeElement) && (g.current && Ka(g.current)[0] || null || v).focus(), Ua++ === 0 && (Ga = document.body.style.overflow, document.body.style.overflow = "hidden"), () => {
      --Ua === 0 && (document.body.style.overflow = Ga), E && E.isConnected && typeof E.focus == "function" && E.focus();
    };
  }, []);
  const h = (v) => {
    const E = N.current;
    if (v.key !== "Tab" || !E || !E.contains(v.target)) return;
    const x = Ka(E);
    if (x.length === 0) {
      v.preventDefault(), E.focus();
      return;
    }
    const C = x[0], M = x[x.length - 1], T = document.activeElement;
    v.shiftKey && (T === C || T === E) ? (v.preventDefault(), M.focus()) : !v.shiftKey && T === M && (v.preventDefault(), C.focus());
  };
  return /* @__PURE__ */ n.createElement("div", { className: Ve.overlay, onClick: c ? d : void 0 }, /* @__PURE__ */ n.createElement(
    "div",
    {
      ref: N,
      tabIndex: -1,
      className: [Ve.modal, r ? Ve.wide : ""].filter(Boolean).join(" "),
      role: "dialog",
      "aria-modal": "true",
      "aria-label": e,
      onClick: (v) => v.stopPropagation(),
      onKeyDown: h
    },
    /* @__PURE__ */ n.createElement("header", { className: Ve.head }, /* @__PURE__ */ n.createElement("strong", { className: Ve.title }, e), o, /* @__PURE__ */ n.createElement("button", { type: "button", className: Ve.close, onClick: d, "aria-label": "닫기" }, "✕")),
    /* @__PURE__ */ n.createElement(
      "div",
      {
        ref: g,
        className: [Ve.body, l ? Ve.flush : ""].filter(Boolean).join(" "),
        onInputCapture: p,
        onChangeCapture: p
      },
      a
    ),
    u != null && u !== !1 && u !== "" && /* @__PURE__ */ n.createElement("div", { className: Ve.error }, /* @__PURE__ */ n.createElement(zr, null, u)),
    s && /* @__PURE__ */ n.createElement("footer", { className: Ve.foot }, s)
  ));
}
function w0(e = 4e3) {
  const [t, a] = A(""), [r, s] = A(!1), o = B(void 0), l = oe((u) => {
    window.clearTimeout(o.current), s(!1), a(u), o.current = window.setTimeout(() => a(""), e);
  }, [e]), c = oe((u) => {
    window.clearTimeout(o.current), s(!0), a(u);
  }, []), i = oe(() => {
    window.clearTimeout(o.current), s(!1), a("");
  }, []);
  return [t, l, c, r, i];
}
const i_ = "_message_psco6_1", u_ = "_details_psco6_2", m_ = "_warn_psco6_7", d_ = "_field_psco6_8", hn = {
  message: i_,
  details: u_,
  warn: m_,
  field: d_
};
function N0() {
  var p, y;
  const [e, t] = A(null), [a, r] = A(""), s = B(null), o = B(null), l = B(null), c = oe((d) => new Promise((b) => {
    t({ kind: "confirm", opts: d, resolve: b });
  }), []), i = oe((d) => new Promise((b) => {
    var w, N, g, $;
    r(($ = (g = d.defaultValue) != null ? g : (N = (w = d.choices) == null ? void 0 : w[0]) == null ? void 0 : N.value) != null ? $ : ""), t({ kind: "prompt", opts: d, resolve: b });
  }), []);
  G(() => {
    var d, b, w;
    e && (e.kind === "prompt" ? (d = l.current) == null || d.focus() : e.opts.danger || e.opts.focusCancel ? (b = o.current) == null || b.focus() : (w = s.current) == null || w.focus());
  }, [e]);
  const u = (d) => {
    e && (e.kind === "confirm" ? e.resolve(d) : e.resolve(d ? a : null), t(null));
  }, m = e == null ? void 0 : e.opts, f = (e == null ? void 0 : e.kind) === "prompt" && !!e.opts.required && !a.trim(), _ = e && m ? /* @__PURE__ */ n.createElement(
    On,
    {
      title: m.title,
      onClose: () => u(!1),
      closeOnBackdrop: !1,
      closeOnEsc: !0,
      confirmDiscard: !1,
      footer: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(mt, { ref: o, onClick: () => u(!1) }, (p = m.cancelLabel) != null ? p : "취소"), /* @__PURE__ */ n.createElement(
        mt,
        {
          ref: s,
          variant: m.danger ? "danger" : "primary",
          disabled: f,
          onClick: () => u(!0)
        },
        (y = m.confirmLabel) != null ? y : "확인"
      ))
    },
    m.message && /* @__PURE__ */ n.createElement("div", { className: hn.message }, m.message),
    m.details && m.details.length > 0 && /* @__PURE__ */ n.createElement("ul", { className: hn.details }, m.details.map((d, b) => /* @__PURE__ */ n.createElement("li", { key: b }, d))),
    m.irreversible && /* @__PURE__ */ n.createElement("p", { className: hn.warn }, "이 작업은 되돌릴 수 없습니다."),
    e.kind === "prompt" && /* @__PURE__ */ n.createElement("label", { className: hn.field }, /* @__PURE__ */ n.createElement("span", null, e.opts.label), e.opts.choices ? /* @__PURE__ */ n.createElement("select", { ref: l, value: a, onChange: (d) => r(d.target.value) }, e.opts.choices.map((d) => /* @__PURE__ */ n.createElement("option", { key: d.value, value: d.value }, d.label))) : /* @__PURE__ */ n.createElement(
      "input",
      {
        ref: l,
        value: a,
        placeholder: e.opts.placeholder,
        maxLength: e.opts.maxLength,
        onChange: (d) => r(d.target.value),
        onKeyDown: (d) => {
          d.key === "Enter" && !f && (d.preventDefault(), u(!0));
        }
      }
    ))
  ) : null;
  return { confirm: c, prompt: i, dialog: _ };
}
function $0(e, t) {
  return (t ? `${t}에 실패했습니다 — ` : "") + f_(e);
}
function f_(e) {
  return e === 0 ? "일시적인 문제로 처리하지 못했습니다. 잠시 후 다시 시도하세요" : e === 400 || e === 422 ? "입력 내용을 처리할 수 없습니다. 입력값을 확인한 뒤 다시 시도하세요" : e === 401 ? "로그인이 만료되었습니다. 다시 로그인하세요" : e === 403 ? "이 작업을 할 권한이 없습니다" : e === 404 ? "대상을 찾을 수 없습니다" : e === 409 ? "다른 사용자가 먼저 수정했습니다. 다시 조회한 뒤 수정하세요" : e === 413 ? "보낸 자료가 너무 큽니다. 크기를 줄여 다시 시도하세요" : e === 429 ? "요청이 너무 많습니다. 잠시 후 다시 시도하세요" : e >= 500 ? "일시적인 문제로 처리하지 못했습니다. 잠시 후 다시 시도하세요" : "요청을 처리하지 못했습니다. 다시 시도하세요";
}
function x0() {
  const [e, t] = A(!1), a = B(!1), r = oe(async (s) => {
    if (!a.current) {
      a.current = !0, t(!0);
      try {
        return await s();
      } finally {
        a.current = !1, t(!1);
      }
    }
  }, []);
  return [e, r];
}
function D0(e, t, a, r) {
  const [s, o] = A(null), [l, c] = A(a), [i, u] = A(null), [m, f] = A(!1), [_, p] = A(0), y = B(0), d = B(r);
  d.current = r;
  const b = oe(() => p((w) => w + 1), []);
  return G(() => {
    if (!a) return;
    const w = ++y.current;
    return c(!0), e().then((N) => {
      w === y.current && (o(N), u(null), f(!1));
    }).catch((N) => {
      var g, $, h;
      w === y.current && (u(d.current.errorText(N)), f((h = ($ = (g = d.current).isUnavailable) == null ? void 0 : $.call(g, N)) != null ? h : !1));
    }).finally(() => {
      w === y.current && c(!1);
    }), () => {
      y.current++;
    };
  }, [a, _, ...t]), { data: s, loading: l, error: i, unavailable: m, reload: b };
}
function A0(e) {
  const [t, a] = A(null), [r, s] = A(null), [o, l] = A(!1), [c, i] = A(1), u = B(0), m = B(e);
  m.current = e;
  const f = oe(async (p, y) => {
    const d = ++u.current;
    l(!0), s(null);
    try {
      const b = await y(p);
      if (d !== u.current) return;
      a(b), i(p);
    } catch (b) {
      if (d !== u.current) return;
      a(null), s(m.current.errorText(b));
    } finally {
      d === u.current && l(!1);
    }
  }, []), _ = oe(() => {
    u.current++, a(null), s(null), l(!1);
  }, []);
  return { data: t, err: r, loading: o, page: c, load: f, clear: _ };
}
const __ = "_section_dyrr7_3", p_ = "_row_dyrr7_10", y_ = "_label_dyrr7_15", b_ = "_value_dyrr7_21", E_ = "_invalid_dyrr7_43", h_ = "_help_dyrr7_45", g_ = "_err_dyrr7_45", v_ = "_req_dyrr7_49", k_ = "_opt_dyrr7_50", w_ = "_sr_dyrr7_51", N_ = "_ro_dyrr7_10", $_ = "_readonly_dyrr7_58", x_ = "_hint_dyrr7_65", D_ = "_toggle_dyrr7_73", A_ = "_table_dyrr7_80", C_ = "_isReq_dyrr7_95", Ce = {
  section: __,
  row: p_,
  label: y_,
  value: b_,
  invalid: E_,
  help: h_,
  err: g_,
  req: v_,
  opt: k_,
  sr: w_,
  ro: N_,
  readonly: $_,
  hint: x_,
  toggle: D_,
  table: A_,
  isReq: C_
};
let S_ = 0;
const M_ = /* @__PURE__ */ new Set(["input", "select", "textarea"]);
function C0({
  label: e,
  children: t,
  hint: a,
  ro: r,
  htmlFor: s,
  required: o,
  optional: l,
  help: c,
  error: i,
  className: u = ""
}) {
  var h, v, E, x;
  const m = B(`axe-fr${++S_}`).current, f = `${m}-lbl`, _ = B(null), p = c ? `${m}-help` : void 0, y = i ? `${m}-err` : void 0, d = [p, y].filter(Boolean).join(" ") || void 0, b = a && a.replace(/\*\*(.+?)\*\*/g, "$1");
  let w = t;
  const N = ta.count(t) === 1 ? ta.toArray(t)[0] : null, g = cn(N) && typeof N.type != "string" && !!N.type.axeFormControl;
  if (cn(N) && (typeof N.type == "string" && M_.has(N.type) || g)) {
    const C = N, M = C.props;
    w = da(C, {
      id: (h = M.id) != null ? h : s,
      "aria-describedby": (v = M["aria-describedby"]) != null ? v : d,
      "aria-invalid": (E = M["aria-invalid"]) != null ? E : i ? !0 : void 0,
      "aria-required": (x = M["aria-required"]) != null ? x : o ? !0 : void 0
    });
  }
  xe(() => {
    var I;
    const C = (I = _.current) == null ? void 0 : I.querySelector("input:not([type=hidden]):not([type=checkbox]):not([type=radio]), select, textarea");
    if (!C) return;
    const M = (q, X) => {
      const Y = `data-fr-${q}`;
      if (X == null) {
        C.hasAttribute(Y) && (C.removeAttribute(q), C.removeAttribute(Y));
        return;
      }
      C.hasAttribute(q) && !C.hasAttribute(Y) || (C.getAttribute(q) !== X && C.setAttribute(q, X), C.setAttribute(Y, ""));
    }, T = !!(C.id && document.querySelector(`label[for="${CSS.escape(C.id)}"]`));
    M("aria-labelledby", T ? null : f), M("aria-invalid", i ? "true" : null), M("aria-required", o ? "true" : null), M("aria-describedby", d != null ? d : null);
  });
  const $ = /* @__PURE__ */ n.createElement(n.Fragment, null, e, o && /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: Ce.req, "aria-hidden": "true" }, "*"), /* @__PURE__ */ n.createElement("span", { className: Ce.sr }, "필수")), l && /* @__PURE__ */ n.createElement("span", { className: Ce.opt }, "(선택)"));
  return /* @__PURE__ */ n.createElement("div", { className: ["axe-form-row", Ce.row, r ? Ce.ro : "", i ? Ce.invalid : "", o ? Ce.isReq : "", u].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("span", { className: `axe-form-label ${Ce.label}` }, s ? /* @__PURE__ */ n.createElement("label", { htmlFor: s, id: f }, $) : /* @__PURE__ */ n.createElement("span", { id: f }, $), a && /* @__PURE__ */ n.createElement(jt, { content: b, describe: !1 }, /* @__PURE__ */ n.createElement("span", { className: `axe-form-hint ${Ce.hint}`, role: "img", "aria-label": `도움말: ${b}`, tabIndex: 0 }, "?"))), /* @__PURE__ */ n.createElement("span", { ref: _, className: `axe-form-value ${Ce.value}` }, w, c && /* @__PURE__ */ n.createElement("span", { id: p, className: Ce.help }, c), i && /* @__PURE__ */ n.createElement("span", { id: y, className: Ce.err }, i)));
}
function S0({ title: e, children: t, className: a = "", variant: r = "stack" }) {
  return /* @__PURE__ */ n.createElement("section", { className: ["axe-form-section", r === "table" ? `axe-form-table ${Ce.table}` : "", Ce.section, a].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("h3", null, e), t);
}
function M0({ children: e }) {
  return /* @__PURE__ */ n.createElement("span", { className: Ce.readonly }, e);
}
function T0({ checked: e, onChange: t, disabled: a, label: r, className: s = "" }) {
  return /* @__PURE__ */ n.createElement("label", { className: [Ce.toggle, s].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("input", { type: "checkbox", checked: e, disabled: a, onChange: (o) => t(o.target.checked) }), /* @__PURE__ */ n.createElement("span", null, r));
}
const T_ = "_mono_6omzf_2", q_ = "_invalid_6omzf_3", B_ = "_qty_6omzf_6", L_ = "_qtyInput_6omzf_7", j_ = "_unit_6omzf_8", R_ = "_note_6omzf_9", I_ = "_qtyErr_6omzf_10", kt = {
  mono: T_,
  invalid: q_,
  qty: B_,
  qtyInput: L_,
  unit: j_,
  note: R_,
  qtyErr: I_
};
function O_({
  value: e,
  onChange: t,
  disabled: a,
  maxLength: r,
  placeholder: s,
  mono: o,
  invalid: l,
  multiline: c,
  rows: i = 4,
  label: u,
  id: m,
  "aria-describedby": f,
  "aria-invalid": _,
  "aria-required": p,
  className: y = ""
}) {
  const d = [o ? kt.mono : "", l ? kt.invalid : "", y].filter(Boolean).join(" ") || void 0, b = {
    id: m,
    className: d,
    value: e != null ? e : "",
    maxLength: r,
    placeholder: s,
    disabled: a,
    "aria-label": u,
    "aria-describedby": f,
    "aria-invalid": _ != null ? _ : l || void 0,
    "aria-required": p,
    onChange: (w) => t(w.target.value === "" ? null : w.target.value)
  };
  return c ? /* @__PURE__ */ n.createElement("textarea", { ...b, rows: i }) : /* @__PURE__ */ n.createElement("input", { type: "text", ...b });
}
O_.axeFormControl = !0;
function P_(e) {
  const {
    value: t,
    options: a,
    allLabel: r,
    disabled: s,
    label: o,
    id: l,
    "aria-describedby": c,
    "aria-invalid": i,
    "aria-required": u,
    className: m,
    title: f,
    style: _
  } = e, p = (d) => {
    e.codeType === "string" ? e.onChange(d === "" ? null : d) : e.onChange(d === "" ? null : Number(d));
  }, y = Array.isArray(a) ? a : Object.entries(a);
  return /* @__PURE__ */ n.createElement(
    "select",
    {
      id: l,
      className: m,
      title: f,
      style: _,
      value: t == null ? "" : String(t),
      disabled: s,
      "aria-label": o,
      "aria-describedby": c,
      "aria-invalid": i,
      "aria-required": u,
      onChange: (d) => p(d.target.value)
    },
    r != null && /* @__PURE__ */ n.createElement("option", { value: "" }, r),
    y.map(([d, b]) => /* @__PURE__ */ n.createElement("option", { key: d, value: String(d) }, b))
  );
}
P_.axeFormControl = !0;
function X_(e) {
  return e.replace(/[０-９]/g, (t) => String.fromCharCode(t.charCodeAt(0) - 65248)).replace(/[．。]/g, ".").replace(/[－−ー]/g, "-").replace(/[，、]/g, ",");
}
const z_ = /^-?(\d+\.?\d*|\.\d+)$/;
function en(e) {
  const t = X_(e).trim().replace(/,/g, "");
  if (t === "") return { kind: "empty" };
  if (t === "-" || t === "." || t === "-.") return { kind: "partial" };
  if (!z_.test(t)) return { kind: "bad" };
  const a = Number(t);
  return Number.isFinite(a) ? { kind: "num", value: a === 0 ? 0 : a } : { kind: "bad" };
}
function Sn(e) {
  if (!Number.isFinite(e)) return 0;
  const t = Math.abs(e).toString(), a = t.indexOf("e-");
  if (a >= 0) {
    const s = t.slice(0, a), o = s.indexOf(".");
    return (o >= 0 ? s.length - o - 1 : 0) + Number(t.slice(a + 2));
  }
  const r = t.indexOf(".");
  return r >= 0 ? t.length - r - 1 : 0;
}
function Fr(e, t) {
  if (!Number.isFinite(e)) return e;
  const a = Math.max(0, Math.floor(t));
  if (Sn(e) <= a) return e;
  const r = e < 0 ? -1 : 1, s = Math.abs(e).toFixed(Math.min(20, Sn(e))), o = Math.round(+`${s}e${a}`), l = r * +`${o}e-${a}`;
  return l === 0 ? 0 : l;
}
function Ot(e) {
  return e == null || !Number.isFinite(e) ? "" : String(Number(e.toPrecision(12)));
}
function F_(e, t, a) {
  return t != null && e < t || a != null && e > a;
}
function H_(e, t, a, r, s, o) {
  let l = e == null ? s != null ? s : 0 : Fr(e + a * t, Math.max(r, Sn(t)));
  return s != null && l < s && (l = s), o != null && l > o && (l = o), l;
}
const W_ = 2500;
function K_({
  value: e,
  onChange: t,
  decimals: a = 1,
  min: r,
  max: s,
  step: o,
  unit: l,
  disabled: c,
  label: i,
  id: u,
  "aria-describedby": m,
  "aria-invalid": f,
  "aria-required": _,
  width: p,
  onEnter: y,
  onInvalidChange: d,
  placeholder: b,
  className: w = ""
}) {
  const [N, g] = A(() => Ot(e)), [$, h] = A(!1), [v, E] = A(null), [x, C] = A(!1), M = B(null), T = B(N);
  T.current = N, G(() => {
    const k = en(T.current), O = k.kind === "num" ? k.value : k.kind === "empty" ? null : void 0;
    O !== void 0 && O === (e != null ? e : null) || g(Ot(e));
  }, [e]), G(() => () => {
    M.current && clearTimeout(M.current);
  }, []);
  const I = en(N), q = I.kind === "bad" || I.kind === "partial";
  G(() => {
    q || C(!1);
  }, [q]);
  const X = B(d);
  X.current = d, G(() => {
    var k;
    (k = X.current) == null || k.call(X, q);
  }, [q]), G(() => () => {
    var k;
    (k = X.current) == null || k.call(X, !1);
  }, []);
  const Y = (k) => {
    M.current && clearTimeout(M.current), E(k), M.current = setTimeout(() => E(null), W_);
  }, K = (k) => {
    g(k);
    const O = en(k);
    O.kind === "empty" ? t(null) : O.kind === "num" && t(O.value);
  }, j = () => {
    const k = en(N);
    if (k.kind !== "num") return;
    if (Sn(k.value) > a) {
      const Q = Fr(k.value, a);
      g(Ot(Q)), t(Q), Y(`반올림했습니다 → ${Ot(Q)}`);
      return;
    }
    const O = Ot(k.value);
    O !== N && g(O);
  }, ne = (k) => {
    if (!k.nativeEvent.isComposing) {
      if (k.key === "Enter") {
        if (q) {
          C(!0);
          return;
        }
        j(), y == null || y();
        return;
      }
      if (o && (k.key === "ArrowUp" || k.key === "ArrowDown")) {
        k.preventDefault();
        const O = en(N), Q = O.kind === "num" ? O.value : O.kind === "empty" ? null : e, J = H_(Q, o, k.key === "ArrowUp" ? 1 : -1, a, r, s);
        g(Ot(J)), t(J);
      }
    }
  }, ae = I.kind === "bad" || I.kind === "partial" && (!$ || x) || I.kind === "num" && F_(I.value, r, s);
  return /* @__PURE__ */ n.createElement("span", { className: [kt.qty, w].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(
    "input",
    {
      type: "text",
      inputMode: "decimal",
      id: u,
      className: [kt.qtyInput, ae ? kt.invalid : ""].filter(Boolean).join(" "),
      style: p != null ? { width: p, maxWidth: "none" } : void 0,
      value: N,
      placeholder: b,
      disabled: c,
      "aria-label": i,
      "aria-describedby": m,
      "aria-invalid": f != null ? f : ae || void 0,
      "aria-required": _,
      onChange: (k) => K(k.target.value),
      onFocus: () => h(!0),
      onBlur: () => {
        h(!1), j();
      },
      onKeyDown: ne
    }
  ), l && /* @__PURE__ */ n.createElement("span", { className: kt.unit }, l), (I.kind === "bad" || I.kind === "partial" && (!$ || x)) && /* @__PURE__ */ n.createElement("span", { className: kt.qtyErr, role: "alert" }, "숫자로 입력하세요"), /* @__PURE__ */ n.createElement("span", { className: kt.note, role: "status", "aria-live": "polite" }, v));
}
K_.axeFormControl = !0;
function U_(e, t) {
  if (e === t || e == null && t == null) return !0;
  if (e == null || t == null) return !1;
  if (typeof e == "object" && typeof t == "object")
    try {
      return JSON.stringify(e) === JSON.stringify(t);
    } catch {
      return !1;
    }
  return typeof e == "number" && typeof t == "number" && Number.isNaN(e) && Number.isNaN(t);
}
function G_(e, t) {
  var s;
  if (e === t) return [];
  if (e === null || t === null) return e === null && t === null ? [] : Object.keys((s = e != null ? e : t) != null ? s : {});
  const a = /* @__PURE__ */ new Set([...Object.keys(e), ...Object.keys(t)]), r = [];
  return a.forEach((o) => {
    U_(e[o], t[o]) || r.push(o);
  }), r;
}
function Y_(e, t) {
  return e === null || t === null ? e === t : G_(e, t).length === 0;
}
function q0() {
  const [e, t] = A(null), [a, r] = A(!1), [s, o] = A(null), l = we(() => a || !Y_(s, e), [a, s, e]), c = oe((p) => {
    t((y) => y === null ? y : { ...y, ...p });
  }, []), i = oe((p, y) => {
    t((d) => d === null ? d : { ...d, [p]: y });
  }, []), u = B(null), m = oe((p) => {
    u.current = p, t(p), o(p), r(!1);
  }, []), f = oe((p) => {
    u.current = p, t(p), o(p), r(!0);
  }, []), _ = oe(() => t(u.current), []);
  return we(
    () => ({ draft: e, isNew: a, dirty: l, set: i, patch: c, load: m, start: f, reset: _, snapshot: s }),
    [e, a, l, i, c, m, f, _, s]
  );
}
function B0() {
  const e = B(!1), [t, a] = A(!1), r = oe(async (s) => {
    if (!e.current) {
      e.current = !0, a(!0);
      try {
        await s();
      } finally {
        e.current = !1, a(!1);
      }
    }
  }, []);
  return [t, r];
}
const V_ = "_panel_1w7xx_2", Q_ = "_band_1w7xx_7", J_ = "_chev_1w7xx_11", Z_ = "_title_1w7xx_17", ep = "_note_1w7xx_19", tp = "_chip_1w7xx_21", np = "_other_1w7xx_32", ap = "_reset_1w7xx_33", rp = "_form_1w7xx_42", st = {
  panel: V_,
  band: Q_,
  chev: J_,
  title: Z_,
  note: ep,
  chip: tp,
  other: np,
  reset: ap,
  form: rp
};
function L0({
  chips: e,
  onReset: t,
  open: a,
  onToggle: r,
  toggleLabel: s = "상세검색",
  title: o = "적용된 조건",
  note: l,
  children: c,
  hideWhenEmpty: i,
  ariaLabel: u = "상세검색",
  className: m = ""
}) {
  const f = B(null);
  if (i && !a && e.length === 0) return null;
  const _ = (y, d = 0) => {
    var $, h, v;
    const b = ($ = document.querySelector(`section[aria-label="${CSS.escape(u)}"]`)) != null ? $ : f.current, w = b == null ? void 0 : b.querySelectorAll("button[data-chip-clear]"), N = (v = w && ((h = w[y]) != null ? h : w[y - 1])) != null ? v : b == null ? void 0 : b.querySelector("button[aria-expanded]"), g = !document.activeElement || document.activeElement === document.body;
    N && N !== document.activeElement && (d === 0 || g) && N.focus(), d < 4 && setTimeout(() => _(y, d + 1), 250);
  }, p = (y) => {
    e[y].onClear(), requestAnimationFrame(() => _(y));
  };
  return /* @__PURE__ */ n.createElement("section", { className: [st.panel, m].filter(Boolean).join(" "), "aria-label": u }, /* @__PURE__ */ n.createElement("div", { className: st.band, ref: f }, r && /* @__PURE__ */ n.createElement("button", { type: "button", className: st.chev, "aria-expanded": !!a, onClick: r }, /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true" }, a ? "⌃" : "⌄"), " ", s), o !== null && /* @__PURE__ */ n.createElement("span", { className: st.title, "aria-live": "polite" }, o, " ", /* @__PURE__ */ n.createElement("b", null, e.length), "개"), e.map((y, d) => {
    var b;
    return /* @__PURE__ */ n.createElement("span", { key: y.key, className: [st.chip, y.tone === "other" ? st.other : ""].filter(Boolean).join(" ") }, y.text, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        "data-chip-clear": !0,
        "aria-label": `${(b = y.label) != null ? b : typeof y.text == "string" ? y.text : "조건"} 해제`,
        onClick: () => p(d)
      },
      "✕"
    ));
  }), t && e.length > 0 && /* @__PURE__ */ n.createElement("button", { type: "button", className: st.reset, onClick: () => {
    t(), requestAnimationFrame(() => _(0));
  } }, "초기화"), l && /* @__PURE__ */ n.createElement("span", { className: st.note }, l)), a && c && /* @__PURE__ */ n.createElement("div", { className: st.form }, c));
}
const sp = "_zone_1y6sp_2", op = "_drag_1y6sp_8", lp = "_busy_1y6sp_9", cp = "_attached_1y6sp_10", ip = "_left_1y6sp_12", up = "_icon_1y6sp_13", mp = "_title_1y6sp_18", dp = "_desc_1y6sp_19", fp = "_right_1y6sp_20", _p = "_count_1y6sp_21", pp = "_pick_1y6sp_22", We = {
  zone: sp,
  drag: op,
  busy: lp,
  attached: cp,
  left: ip,
  icon: up,
  title: mp,
  desc: dp,
  right: fp,
  count: _p,
  pick: pp
};
function yp({
  onFiles: e,
  title: t = "파일 업로드",
  desc: a,
  countText: r,
  accept: s,
  multiple: o = !0,
  disabled: l,
  attached: c,
  pickLabel: i = "파일 선택",
  className: u = ""
}) {
  const m = B(null), [f, _] = A(!1), p = (y) => {
    !y || y.length === 0 || l || e(Array.from(y));
  };
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [We.zone, f ? We.drag : "", l ? We.busy : "", c ? We.attached : "", u].filter(Boolean).join(" "),
      onClick: () => {
        var y;
        l || (y = m.current) == null || y.click();
      },
      onDragOver: (y) => {
        y.preventDefault(), l || _(!0);
      },
      onDragLeave: () => _(!1),
      onDrop: (y) => {
        y.preventDefault(), _(!1), p(y.dataTransfer.files);
      }
    },
    /* @__PURE__ */ n.createElement("div", { className: We.left }, /* @__PURE__ */ n.createElement("div", { className: We.icon, "aria-hidden": "true" }, /* @__PURE__ */ n.createElement("svg", { width: "22", height: "22", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }, /* @__PURE__ */ n.createElement("polyline", { points: "16 16 12 12 8 16" }), /* @__PURE__ */ n.createElement("line", { x1: "12", y1: "12", x2: "12", y2: "21" }), /* @__PURE__ */ n.createElement("path", { d: "M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3" }))), /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: We.title }, t), a && /* @__PURE__ */ n.createElement("div", { className: We.desc }, a))),
    /* @__PURE__ */ n.createElement("div", { className: We.right }, r && /* @__PURE__ */ n.createElement("span", { className: We.count, "aria-live": "polite" }, r), /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: We.pick,
        disabled: l,
        onClick: (y) => {
          var d;
          y.stopPropagation(), (d = m.current) == null || d.click();
        }
      },
      i
    ), /* @__PURE__ */ n.createElement(
      "input",
      {
        ref: m,
        type: "file",
        accept: s,
        multiple: o,
        hidden: !0,
        onChange: (y) => {
          p(y.target.files), y.target.value = "";
        }
      }
    ))
  );
}
function bp(e, t) {
  var o, l;
  const a = (o = e.headers.get("Content-Disposition")) != null ? o : "", r = /filename\*=UTF-8''([^;]+)/i.exec(a);
  if (r)
    try {
      return decodeURIComponent(r[1]);
    } catch {
    }
  const s = /filename="?([^";]+)"?/i.exec(a);
  return (l = s == null ? void 0 : s[1]) != null ? l : t;
}
function Hr(e, t) {
  const a = URL.createObjectURL(e), r = document.createElement("a");
  r.href = a, r.download = t, document.body.appendChild(r), r.click(), r.remove(), setTimeout(() => URL.revokeObjectURL(a), 1e3);
}
async function j0(e, t, a) {
  Hr(await e.blob(), a != null ? a : bp(e, t));
}
const Ep = /^([△▲\-−]?)\s*[¥￥]?\s*(\d{1,3}(?:,\d{3})+|\d+)(\.\d+)?$/, hp = /^\(\s*[¥￥]?\s*(\d{1,3}(?:,\d{3})+|\d+)(\.\d+)?\s*\)$/;
function Wr(e, t = {}) {
  var s, o;
  const a = e.trim();
  if (t.parenNegative) {
    const l = hp.exec(a);
    if (l) return `-${l[1].replace(/,/g, "")}${(s = l[2]) != null ? s : ""}`;
  }
  const r = Ep.exec(a);
  return r ? (r[1] ? "-" : "") + r[2].replace(/,/g, "") + ((o = r[3]) != null ? o : "") : null;
}
function Ft(e) {
  return e === "-" || e === "+" ? e : /^[=+\-@\t\r]/.test(e) ? `'${e}` : e;
}
function gp(e, t = {}) {
  const a = [];
  t.meta && t.meta.length && (t.meta.forEach((l) => a.push(l.map((c) => vn(Ft(String(c != null ? c : "")))).join(","))), a.push(""));
  const r = a.length;
  let s = null;
  const o = (l) => {
    var i;
    const c = vp(l, e);
    !c || c === s || (s = c, a.length > r && a.push(""), a.push(vn(Ft((i = c.getAttribute("data-csv-title")) != null ? i : ""))));
  };
  return e.querySelectorAll("table, [data-csv-kv]").forEach((l) => {
    var p;
    if (l.tagName !== "TABLE") {
      if ((p = l.parentElement) != null && p.closest("table") && e.contains(l.parentElement.closest("table"))) return;
      const y = kp(l, t);
      if (!y) return;
      o(l), a.push(y.map(vn).join(","));
      return;
    }
    const c = l;
    o(c);
    const i = c.querySelector("[data-tree-depth]"), u = i ? i.closest("td, th") : null, m = u ? u.cellIndex : -1, f = m >= 0 && !!c.querySelector("[data-csv-path]"), _ = [];
    Array.from(c.rows).forEach((y) => {
      if (y.hasAttribute("data-state") || y.getAttribute("aria-hidden") === "true") return;
      const d = [];
      let b = 0;
      const w = () => {
        for (; _[b] && _[b].n > 0; )
          _[b].n -= 1, _[b].skip || d.push(""), b += 1;
      };
      Array.from(y.cells).forEach((N) => {
        var E, x;
        w();
        const g = Np(N), $ = g ? "" : $p(N, t), h = Math.max(1, N.colSpan || 1), v = Math.max(1, N.rowSpan || 1);
        for (let C = 0; C < h; C += 1)
          g || d.push(C === 0 ? $ : ""), _[b] = { n: v - 1, skip: g }, b += 1;
        if (m >= 0 && N.cellIndex === m) {
          const C = N.querySelector("[data-tree-depth]");
          C ? (d.push(String(Number(C.getAttribute("data-tree-depth")) + 1)), f && d.push(Ft((E = C.getAttribute("data-csv-path")) != null ? E : ""))) : ((x = y.parentElement) == null ? void 0 : x.tagName) === "THEAD" ? (d.push("단계"), f && d.push("상위 경로")) : (d.push(""), f && d.push(""));
        }
      }), w(), d.some((N) => N !== "") && a.push(d.map(vn).join(","));
    });
  }), a.join(`\r
`);
}
function vp(e, t) {
  let a = e.parentElement;
  for (; a; ) {
    if (a.hasAttribute("data-csv-title") && a.getAttribute("data-csv-title")) return a;
    if (a === t) return null;
    a = a.parentElement;
  }
  return null;
}
function kp(e, t) {
  var u, m;
  const a = e.querySelector("[data-csv-k]"), r = e.querySelector("[data-csv-v]"), s = e.querySelector("[data-csv-unit]"), o = s ? gn(s) : "";
  let c = ((u = e.getAttribute("data-csv-kv")) != null ? u : "") || (a ? gn(a) : "");
  if (!c) return null;
  o && (c = `${c} (${o})`);
  let i;
  if (r) {
    const f = r.cloneNode(!0);
    f.querySelectorAll("[data-csv-unit], [data-csv-skip]").forEach((_) => _.remove()), i = gn(f);
  } else {
    const f = e.cloneNode(!0);
    f.querySelectorAll("[data-csv-k], [data-csv-unit], [data-csv-skip]").forEach((_) => _.remove()), i = gn(f);
  }
  return (i === "—" || i === "-" || i === "–") && (i = ""), [Ft(c), (m = Wr(i, t)) != null ? m : Ft(i)];
}
function gn(e) {
  var t, a;
  return ((a = (t = e.innerText) != null ? t : e.textContent) != null ? a : "").replace(/\s+/g, " ").trim();
}
function wp(e, t) {
  const a = t.toLowerCase().endsWith(".csv") ? t : `${t}.csv`;
  Hr(new Blob(["\uFEFF", e], { type: "text/csv;charset=utf-8" }), a);
}
function Np(e) {
  var t;
  return ((t = e.textContent) != null ? t : "").trim() !== "" ? !1 : !!e.querySelector("input[type=checkbox], input[type=radio]");
}
function $p(e, t) {
  var s, o, l;
  let a = e;
  e.querySelector("[data-csv-skip], [data-csv-sep]") && (a = e.cloneNode(!0), a.querySelectorAll("[data-csv-skip]").forEach((c) => c.remove()), a.querySelectorAll("[data-csv-sep]").forEach((c) => c.after(" ")));
  let r = ((o = (s = a.innerText) != null ? s : a.textContent) != null ? o : "").replace(/\s+/g, " ").trim();
  if (!r && a.textContent && (r = a.textContent.replace(/\s+/g, " ").trim()), !r) {
    const c = e.querySelector("input:not([type=checkbox]):not([type=radio]), select, textarea");
    c && (r = c.value.trim());
  }
  return r === "—" || r === "-" || r === "–" ? "" : (l = Wr(r, t)) != null ? l : Ft(r);
}
function vn(e) {
  return /[",\r\n]/.test(e) ? `"${e.replace(/"/g, '""')}"` : e;
}
const xp = () => new Promise((e) => requestAnimationFrame(() => requestAnimationFrame(() => e())));
function R0({ target: e, fileName: t, label: a = "CSV 내려받기", disabled: r, parenNegative: s, prepare: o, meta: l }) {
  return /* @__PURE__ */ n.createElement(
    na,
    {
      label: a,
      disabled: r,
      style: { width: "auto", padding: "0 9px", gap: 4, border: "1px solid var(--axe-border, #d5dde9)", fontSize: 11, fontWeight: 700 },
      onClick: async () => {
        let c;
        o && (c = await o(), await xp());
        try {
          const i = e.current;
          if (!i) return;
          wp(gp(i, { parenNegative: s, meta: l == null ? void 0 : l() }), typeof t == "function" ? t() : t);
        } finally {
          typeof c == "function" && c();
        }
      }
    },
    /* @__PURE__ */ n.createElement(un, { name: "download", size: 14 }),
    "CSV"
  );
}
const Dp = "_root_kpw7f_1", Ap = "_guide_kpw7f_2", Cp = "_tpl_kpw7f_3", Gn = {
  root: Dp,
  guide: Ap,
  tpl: Cp
};
function I0({
  guide: e,
  onTemplate: t,
  templateLabel: a = "빈 양식 받기",
  file: r,
  onFile: s,
  maxBytes: o,
  onTooBig: l,
  fileInfo: c,
  accept: i = ".csv,text/csv",
  label: u = "CSV 파일",
  pickLabel: m = "파일 선택",
  busyReason: f,
  className: _ = ""
}) {
  const p = (d) => {
    var w;
    const b = (w = d[0]) != null ? w : null;
    if (b && o !== void 0 && b.size > o) {
      l == null || l(b);
      return;
    }
    s(b);
  }, y = r ? `${r.name}${c != null ? c : r.size !== void 0 ? ` · ${(r.size / 1024).toFixed(1)}KB` : ""}` : void 0;
  return /* @__PURE__ */ n.createElement("div", { className: [Gn.root, _].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(Gf, { tone: "info" }, /* @__PURE__ */ n.createElement("div", { className: Gn.guide }, e), t && /* @__PURE__ */ n.createElement("div", { className: Gn.tpl }, /* @__PURE__ */ n.createElement(mt, { size: "sm", onClick: t }, a))), /* @__PURE__ */ n.createElement(
    yp,
    {
      title: u,
      desc: r ? void 0 : "선택된 파일 없음",
      countText: y,
      accept: i,
      multiple: !1,
      disabled: !!f,
      pickLabel: m,
      onFiles: p
    }
  ));
}
const Sp = { info: "info", ok: "ok", warn: "warn", danger: "off", muted: "muted", off: "off" };
function O0({ map: e, value: t, empty: a = "-" }) {
  if (t == null) return /* @__PURE__ */ n.createElement(n.Fragment, null, a);
  const r = e[t];
  return r ? /* @__PURE__ */ n.createElement(Ha, { tone: Sp[r.tone] }, r.label) : /* @__PURE__ */ n.createElement(Ha, null, String(t));
}
const Ya = "axerp-form-modal";
function P0({
  title: e,
  onClose: t,
  onSubmit: a,
  busy: r = !1,
  error: s,
  submitLabel: o,
  submitBlocked: l,
  wide: c,
  labels: i,
  formClassName: u,
  children: m
}) {
  var _, p, y;
  const f = (d) => {
    d.preventDefault(), !r && !l && a();
  };
  return /* @__PURE__ */ n.createElement(
    On,
    {
      title: e,
      onClose: t,
      wide: c,
      closeOnBackdrop: !1,
      error: s,
      footer: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(mt, { onClick: t, disabled: r }, (_ = i == null ? void 0 : i.cancel) != null ? _ : "취소"), /* @__PURE__ */ n.createElement(mt, { type: "submit", form: Ya, variant: "primary", blockedReason: r ? (p = i == null ? void 0 : i.saving) != null ? p : "저장 중입니다" : l }, (y = o != null ? o : i == null ? void 0 : i.save) != null ? y : "저장"))
    },
    /* @__PURE__ */ n.createElement("form", { id: Ya, className: u, onSubmit: f, noValidate: !0 }, m)
  );
}
const Mp = { left: "axe-l", center: "axe-c", right: "axe-r" };
function Va(e) {
  const t = e.currentTarget;
  t.scrollWidth > t.clientWidth + 1 && t.textContent ? t.title = t.textContent : t.removeAttribute("title");
}
const Qa = (e) => {
  var t;
  return Mp[(t = e.align) != null ? t : e.num ? "right" : "left"];
};
function X0({
  columns: e,
  rows: t,
  rowKey: a,
  loading: r = !1,
  error: s = null,
  emptyText: o = "표시할 행이 없습니다",
  selectedKey: l,
  onRowClick: c,
  rowClassName: i,
  title: u,
  grow: m = !1,
  growClassName: f,
  pagination: _
}) {
  const p = t != null ? t : [];
  return /* @__PURE__ */ n.createElement(Tc, { grow: m, className: m ? f : void 0, cols: e.map((y) => y.width), busy: r, title: u, pagination: _ }, /* @__PURE__ */ n.createElement("thead", null, /* @__PURE__ */ n.createElement("tr", null, e.map((y) => /* @__PURE__ */ n.createElement("th", { key: y.key, className: Qa(y) === "axe-r" ? "axe-r" : "axe-c", onMouseEnter: Va }, y.header)))), /* @__PURE__ */ n.createElement("tbody", null, /* @__PURE__ */ n.createElement(
    Uc,
    {
      colSpan: e.length,
      loading: r,
      error: s,
      count: t ? p.length : null,
      empty: o,
      idle: null
    }
  ), p.map((y, d) => {
    var N;
    const b = a(y), w = [c ? "axe-clickable" : "", l === b ? "axe-sel" : "", (N = i == null ? void 0 : i(y)) != null ? N : ""].filter(Boolean).join(" ");
    return /* @__PURE__ */ n.createElement(
      "tr",
      {
        key: b,
        className: w || void 0,
        onClick: c ? () => c(y) : void 0,
        ...c ? Gc(() => c(y), l === void 0 ? void 0 : l === b) : {}
      },
      e.map((g) => /* @__PURE__ */ n.createElement("td", { key: g.key, className: Qa(g), onMouseEnter: Va }, g.render(y, d)))
    );
  })));
}
function z0({ title: e, info: t, badge: a, notice: r, actions: s, minWidth: o, bodyClassName: l, children: c }) {
  return /* @__PURE__ */ n.createElement(_s, { style: { height: "100%" }, minWidth: o }, /* @__PURE__ */ n.createElement(js, { title: e, info: t, badge: a, notice: r }, s), /* @__PURE__ */ n.createElement("div", { className: l }, c));
}
const Tp = "_menu_1ow3k_1", qp = "_heading_1ow3k_11", Bp = "_section_1ow3k_18", Lp = "_item_1ow3k_23", kn = {
  menu: Tp,
  heading: qp,
  section: Bp,
  item: Lp
}, wn = 8;
function F0({ x: e, y: t, entries: a, onClose: r, ariaLabel: s, heading: o }) {
  const l = B(null), c = B(r);
  c.current = r;
  const [i, u] = A({ left: e, top: t });
  xe(() => {
    const _ = l.current;
    if (!_) return;
    const p = Math.max(wn, Math.min(e, window.innerWidth - _.offsetWidth - wn)), y = Math.max(wn, Math.min(t, window.innerHeight - _.offsetHeight - wn));
    u({ left: p, top: y });
  }, [e, t]);
  const m = () => {
    var _, p;
    return Array.from((p = (_ = l.current) == null ? void 0 : _.querySelectorAll("[role=menuitem]:not(:disabled)")) != null ? p : []);
  };
  G(() => {
    var _;
    (_ = m()[0]) == null || _.focus();
  }, []), G(() => {
    const _ = () => c.current(), p = (d) => {
      l.current && !l.current.contains(d.target) && _();
    }, y = (d) => {
      d.key !== "Escape" || d.isComposing || (d.preventDefault(), d.stopPropagation(), _());
    };
    return document.addEventListener("mousedown", p), document.addEventListener("keydown", y, !0), window.addEventListener("resize", _), window.addEventListener("scroll", _, !0), () => {
      document.removeEventListener("mousedown", p), document.removeEventListener("keydown", y, !0), window.removeEventListener("resize", _), window.removeEventListener("scroll", _, !0);
    };
  }, []);
  const f = (_) => {
    const p = m();
    if (p.length === 0) return;
    const y = p.indexOf(document.activeElement);
    let d = -1;
    if (_.key === "ArrowDown") d = (y + 1) % p.length;
    else if (_.key === "ArrowUp") d = (y - 1 + p.length) % p.length;
    else if (_.key === "Home") d = 0;
    else if (_.key === "End") d = p.length - 1;
    else if (_.key === "Tab") {
      c.current();
      return;
    }
    d >= 0 && (_.preventDefault(), p[d].focus());
  };
  return fa(
    /* @__PURE__ */ n.createElement(
      "div",
      {
        ref: l,
        className: kn.menu,
        role: "menu",
        "aria-label": s,
        style: { left: i.left, top: i.top },
        onKeyDown: f,
        onContextMenu: (_) => _.preventDefault()
      },
      o && /* @__PURE__ */ n.createElement("div", { className: kn.heading }, o),
      a.map((_) => _.kind === "section" ? /* @__PURE__ */ n.createElement("div", { key: _.key, className: kn.section }, _.label) : /* @__PURE__ */ n.createElement(
        "button",
        {
          key: _.key,
          type: "button",
          role: "menuitem",
          className: kn.item,
          disabled: _.disabled,
          onClick: () => {
            c.current(), _.onClick();
          }
        },
        _.label
      ))
    ),
    document.body
  );
}
const jp = "_sw_xhqlf_1", Rp = "_on_xhqlf_10", Ja = {
  sw: jp,
  on: Rp
};
function H0({ checked: e, onChange: t, label: a, onText: r = "ON", offText: s = "OFF", disabled: o, className: l = "" }) {
  return /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      role: "switch",
      "aria-checked": e,
      "aria-label": a,
      disabled: o,
      className: [Ja.sw, e ? Ja.on : "", l].filter(Boolean).join(" "),
      onClick: () => t(!e)
    },
    /* @__PURE__ */ n.createElement("span", null, e ? r : s),
    /* @__PURE__ */ n.createElement("i", null)
  );
}
const Ip = "_box_lrwei_1", Op = "_btn_lrwei_2", Pp = "_pop_lrwei_9", Yn = {
  box: Ip,
  btn: Op,
  pop: Pp
};
function W0({ summary: e, items: t, onToggle: a, label: r, disabled: s, className: o = "" }) {
  const [l, c] = A(!1), i = B(null), u = B(null);
  return G(() => {
    if (!l) return;
    const m = (_) => {
      i.current && !i.current.contains(_.target) && c(!1);
    }, f = (_) => {
      var p;
      _.key !== "Escape" || _.isComposing || (_.stopPropagation(), c(!1), (p = u.current) == null || p.focus());
    };
    return document.addEventListener("mousedown", m), document.addEventListener("keydown", f, !0), () => {
      document.removeEventListener("mousedown", m), document.removeEventListener("keydown", f, !0);
    };
  }, [l]), /* @__PURE__ */ n.createElement("div", { className: [Yn.box, o].filter(Boolean).join(" "), ref: i }, /* @__PURE__ */ n.createElement(
    "button",
    {
      ref: u,
      type: "button",
      className: Yn.btn,
      "aria-haspopup": "listbox",
      "aria-expanded": l,
      "aria-label": r,
      disabled: s,
      onClick: () => c((m) => !m)
    },
    e,
    " ▾"
  ), l && /* @__PURE__ */ n.createElement("div", { className: Yn.pop, role: "listbox", "aria-multiselectable": "true", "aria-label": r }, t.map((m) => /* @__PURE__ */ n.createElement("label", { key: m.key }, /* @__PURE__ */ n.createElement("input", { type: "checkbox", checked: m.checked, onChange: () => a(m.key) }), m.label))));
}
const Xp = "_card_1adld_1", zp = "_sub_1adld_2", Fp = "_state_1adld_3", Hp = "_list_1adld_7", Wp = "_row_1adld_8", Kp = "_warn_1adld_20", Up = "_danger_1adld_21", Dt = {
  card: Xp,
  sub: zp,
  state: Fp,
  list: Hp,
  row: Wp,
  warn: Kp,
  danger: Up
};
function K0({
  title: e,
  sub: t,
  trailing: a,
  state: r = "ready",
  error: s,
  onRetry: o,
  loadingText: l = "불러오는 중…",
  rows: c,
  className: i = ""
}) {
  return /* @__PURE__ */ n.createElement(
    Cr,
    {
      flush: !0,
      className: [Dt.card, i].filter(Boolean).join(" "),
      title: /* @__PURE__ */ n.createElement(n.Fragment, null, e, t ? /* @__PURE__ */ n.createElement("small", { className: Dt.sub }, t) : null),
      trailing: a
    },
    r === "loading" && /* @__PURE__ */ n.createElement("div", { className: Dt.state }, l),
    r === "error" && /* @__PURE__ */ n.createElement("div", { className: Dt.state }, /* @__PURE__ */ n.createElement(zr, null, s != null ? s : "불러오지 못했습니다"), o && /* @__PURE__ */ n.createElement(_a, { onClick: o }, "다시 시도")),
    r === "ready" && /* @__PURE__ */ n.createElement("div", { className: Dt.list }, c.map((u, m) => {
      var p, y;
      const f = [Dt.row, u.tone ? Dt[u.tone] : ""].filter(Boolean).join(" "), _ = /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", null, u.label), /* @__PURE__ */ n.createElement("strong", null, u.value, u.unit ? /* @__PURE__ */ n.createElement("small", null, u.unit) : null));
      return u.onClick ? /* @__PURE__ */ n.createElement("button", { type: "button", key: (p = u.key) != null ? p : m, className: f, onClick: u.onClick }, _) : /* @__PURE__ */ n.createElement("div", { key: (y = u.key) != null ? y : m, className: f }, _);
    }))
  );
}
function Gp(e, t, a, r, s) {
  const o = Math.max(0, Math.floor(e));
  if (o === 0) return 1;
  const l = Math.max(1, Math.min(o, s != null && s > 0 ? Math.floor(s) : o)), c = Math.max(1, Math.min(l, Math.floor((t + r) / (a + r)))), i = Math.ceil(o / c);
  return Math.ceil(o / i);
}
const Yp = "_group_44kzq_1", Vp = "_tile_44kzq_2", Qp = "_click_44kzq_9", Jp = "_pressed_44kzq_13", Zp = "_ok_44kzq_14", ey = "_warn_44kzq_15", ty = "_danger_44kzq_16", ny = "_info_44kzq_17", ay = "_accent_44kzq_18", ry = "_muted_44kzq_19", sy = "_label_44kzq_20", oy = "_value_44kzq_22", ly = "_desc_44kzq_27", vt = {
  group: Yp,
  tile: Vp,
  click: Qp,
  pressed: Jp,
  ok: Zp,
  warn: ey,
  danger: ty,
  info: ny,
  accent: ay,
  muted: ry,
  label: sy,
  value: oy,
  desc: ly
};
function U0({
  label: e,
  value: t,
  unit: a,
  desc: r,
  tone: s = "info",
  onClick: o,
  pressed: l,
  title: c,
  className: i = ""
}) {
  const u = [vt.tile, vt[s], o ? vt.click : "", o && l ? vt.pressed : "", i].filter(Boolean).join(" "), m = /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: vt.label, "data-csv-k": "" }, /* @__PURE__ */ n.createElement("i", { "aria-hidden": "true" }), e), /* @__PURE__ */ n.createElement("span", { className: vt.value, "data-csv-v": "" }, t, a ? /* @__PURE__ */ n.createElement("small", { "data-csv-unit": "" }, a) : null), r ? /* @__PURE__ */ n.createElement("span", { className: vt.desc, title: typeof r == "string" ? r : void 0 }, r) : null);
  return o ? /* @__PURE__ */ n.createElement("button", { type: "button", className: u, onClick: o, "aria-pressed": l, title: c, "data-csv-kv": "" }, m) : /* @__PURE__ */ n.createElement("div", { className: u, title: c, "data-csv-kv": "" }, m);
}
const cy = 150, iy = 12, uy = 8;
function G0({ children: e, columns: t, className: a = "" }) {
  const r = B(null), s = ta.toArray(e).filter(cn).length, o = t != null || s <= uy, [l, c] = A(null);
  xe(() => {
    const m = r.current;
    if (!o || !m || (c(m.clientWidth), typeof ResizeObserver == "undefined")) return;
    const f = new ResizeObserver(() => c(m.clientWidth));
    return f.observe(m), () => f.disconnect();
  }, [o]);
  const i = o ? Gp(s, l != null ? l : Number.MAX_SAFE_INTEGER, cy, iy, t) : 0, u = o ? { gridTemplateColumns: `repeat(${i}, minmax(0, 1fr))` } : void 0;
  return /* @__PURE__ */ n.createElement("div", { ref: r, className: [vt.group, a].filter(Boolean).join(" "), style: u }, e);
}
const my = "_card_1lav2_1", dy = "_n_1lav2_2", fy = "_list_1lav2_7", _y = "_row_1lav2_8", py = "_go_1lav2_15", yy = "_name_1lav2_16", by = "_empty_1lav2_17", Ey = "_star_1lav2_18", hy = "_clear_1lav2_27", Qe = {
  card: my,
  n: dy,
  list: fy,
  row: _y,
  go: py,
  name: yy,
  empty: by,
  star: Ey,
  clear: hy
};
function Y0({
  mine: e,
  recent: t,
  onOpen: a,
  onClearRecent: r,
  mineHint: s = "메뉴 목록에서 ☆ 를 누르면 여기에 담깁니다",
  className: o = ""
}) {
  const [l, c] = A("mine"), i = l === "mine" ? e : t;
  return /* @__PURE__ */ n.createElement(
    Cr,
    {
      flush: !0,
      className: [Qe.card, o].filter(Boolean).join(" "),
      title: /* @__PURE__ */ n.createElement(
        vr,
        {
          variant: "segmented",
          "aria-label": "빠른 메뉴",
          value: l,
          onChange: (u) => c(u),
          items: [
            { key: "mine", label: /* @__PURE__ */ n.createElement(n.Fragment, null, "마이메뉴", e.length > 0 && /* @__PURE__ */ n.createElement("em", { className: Qe.n }, e.length)) },
            { key: "recent", label: /* @__PURE__ */ n.createElement(n.Fragment, null, "최근 사용", t.length > 0 && /* @__PURE__ */ n.createElement("em", { className: Qe.n }, t.length)) }
          ]
        }
      ),
      trailing: l === "recent" && t.length > 0 && r ? /* @__PURE__ */ n.createElement(_a, { className: Qe.clear, onClick: r }, "목록 비우기") : void 0
    },
    i.length > 0 ? /* @__PURE__ */ n.createElement("ul", { className: Qe.list }, i.map((u) => /* @__PURE__ */ n.createElement("li", { key: u.path }, /* @__PURE__ */ n.createElement("button", { type: "button", className: Qe.row, onClick: () => a(u) }, /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true", className: Qe.go }, "↗"), /* @__PURE__ */ n.createElement("span", { className: Qe.name }, u.label))))) : /* @__PURE__ */ n.createElement("div", { className: Qe.empty }, /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true", className: Qe.star }, "★"), /* @__PURE__ */ n.createElement("strong", null, l === "mine" ? "아직 추가한 메뉴가 없습니다" : "최근 사용한 메뉴가 없습니다"), /* @__PURE__ */ n.createElement("p", null, l === "mine" ? s : "메뉴를 실행하면 최근 사용 목록에 표시됩니다"))
  );
}
function Za(e) {
  var t;
  try {
    const a = JSON.parse((t = window.localStorage.getItem(e)) != null ? t : "[]");
    return Array.isArray(a) ? a.filter((r) => r && typeof r.path == "string" && typeof r.label == "string") : [];
  } catch {
    return [];
  }
}
function Vn(e, t) {
  try {
    window.localStorage.setItem(e, JSON.stringify(t));
  } catch {
  }
}
function V0({ mineKey: e, recentKey: t, recentMax: a = 6 }) {
  const [r, s] = A(() => Za(e)), [o, l] = A(() => Za(t)), c = oe((f) => r.some((_) => _.path === f), [r]), i = oe((f) => s((_) => {
    const p = _.some((y) => y.path === f.path) ? _.filter((y) => y.path !== f.path) : [..._, f];
    return Vn(e, p), p;
  }), [e]), u = oe((f) => l((_) => {
    const p = [f, ..._.filter((y) => y.path !== f.path)].slice(0, a);
    return Vn(t, p), p;
  }), [t, a]), m = oe(() => {
    l([]), Vn(t, []);
  }, [t]);
  return { mine: r, recent: o, isMine: c, toggleMine: i, remember: u, clearRecent: m };
}
const gy = "_banner_7tqhk_2", vy = "_heading_7tqhk_7", ky = "_sparkleBox_7tqhk_8", wy = "_eyebrow_7tqhk_12", Ny = "_headline_7tqhk_13", $y = "_desc_7tqhk_15", xy = "_err_7tqhk_16", Dy = "_chips_7tqhk_18", Ay = "_footer_7tqhk_28", Cy = "_kicker_7tqhk_35", Sy = "_list_7tqhk_36", My = "_row_7tqhk_37", Ty = "_icon_7tqhk_39", qy = "_text_7tqhk_40", By = "_cap_7tqhk_41", Ly = "_body_7tqhk_43", jy = "_reason_7tqhk_44", Ry = "_empty_7tqhk_45", ye = {
  banner: gy,
  heading: vy,
  sparkleBox: ky,
  eyebrow: wy,
  headline: Ny,
  desc: $y,
  err: xy,
  chips: Dy,
  footer: Ay,
  kicker: Cy,
  list: Sy,
  row: My,
  icon: Ty,
  text: qy,
  cap: By,
  body: Ly,
  reason: jy,
  empty: Ry
};
function er({ size: e = 18 }) {
  return /* @__PURE__ */ n.createElement("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", "aria-hidden": "true" }, /* @__PURE__ */ n.createElement("path", { d: "M12 2.8c.72 5.16 2.85 7.3 8.02 8.02-5.17.72-7.3 2.86-8.02 8.02-.72-5.16-2.85-7.3-8.02-8.02C9.15 10.1 11.28 7.96 12 2.8Z", fill: "currentColor" }));
}
function Q0({
  eyebrow: e,
  headline: t,
  desc: a,
  error: r,
  groups: s,
  maxChips: o = 4,
  onOpen: l,
  note: c,
  noteError: i,
  allLabel: u = "전체 업무 제안 보기",
  allDisabled: m,
  className: f = ""
}) {
  const _ = s.slice(0, o), p = s.length - _.length;
  return /* @__PURE__ */ n.createElement("section", { className: [ye.banner, f].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: ye.heading }, /* @__PURE__ */ n.createElement("span", { className: ye.sparkleBox }, /* @__PURE__ */ n.createElement(er, { size: 22 })), /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: ye.eyebrow }, /* @__PURE__ */ n.createElement(er, { size: 11 }), " ", e), /* @__PURE__ */ n.createElement("h2", { className: ye.headline }, t), a ? /* @__PURE__ */ n.createElement("p", { className: [ye.desc, r ? ye.err : ""].filter(Boolean).join(" ") }, a) : null)), s.length > 0 && /* @__PURE__ */ n.createElement("div", { className: ye.chips }, _.map((y) => /* @__PURE__ */ n.createElement("button", { type: "button", key: y.key, title: y.label, onClick: () => l(y.key) }, /* @__PURE__ */ n.createElement("i", { style: y.color ? { background: y.color } : void 0, "aria-hidden": "true" }), y.label, " ", /* @__PURE__ */ n.createElement("strong", { style: y.color ? { color: y.color } : void 0 }, y.count, "건"))), p > 0 && /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => l(null) }, "+", p, "종류 더")), /* @__PURE__ */ n.createElement("div", { className: ye.footer }, /* @__PURE__ */ n.createElement(
    "span",
    {
      className: i ? ye.err : void 0,
      role: i ? "alert" : void 0
    },
    c
  ), /* @__PURE__ */ n.createElement(_a, { onClick: () => l(null), disabled: m }, u, " ", /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true" }, "→"))));
}
function Iy({ items: e, onRun: t, onSkip: a, busy: r, emptyText: s = "남은 제안이 없습니다." }) {
  return e.length === 0 ? /* @__PURE__ */ n.createElement("div", { className: ye.empty }, s) : /* @__PURE__ */ n.createElement("ul", { className: ye.list }, e.map((o) => {
    var l, c;
    return /* @__PURE__ */ n.createElement("li", { key: o.id, className: ye.row }, /* @__PURE__ */ n.createElement("span", { className: ye.icon, "aria-hidden": "true" }, (l = o.icon) != null ? l : "💡"), /* @__PURE__ */ n.createElement("div", { className: ye.text }, /* @__PURE__ */ n.createElement("div", { className: ye.cap }, o.title, o.meta ? /* @__PURE__ */ n.createElement("small", null, " · ", o.meta) : null), /* @__PURE__ */ n.createElement("div", { className: ye.body }, o.body), o.reason ? /* @__PURE__ */ n.createElement("div", { className: ye.reason }, o.reason) : null), /* @__PURE__ */ n.createElement(mt, { variant: "primary", disabled: r, onClick: () => t(o) }, (c = o.actionLabel) != null ? c : "실행"), /* @__PURE__ */ n.createElement(mt, { disabled: r, onClick: () => a(o) }, "무시"));
  }));
}
function J0({ title: e, kicker: t = "ProActive AI 업무 제안", items: a, onClose: r, onRun: s, onSkip: o }) {
  const l = B(!1), [c, i] = A(!1), [u, m] = A(""), f = async (_) => {
    if (!l.current) {
      l.current = !0, i(!0), m("");
      try {
        await _();
      } catch {
        m("처리하지 못했습니다. 잠시 후 다시 시도하세요.");
      } finally {
        l.current = !1, i(!1);
      }
    }
  };
  return /* @__PURE__ */ n.createElement(
    On,
    {
      title: e,
      onClose: r,
      closeOnEsc: !0,
      confirmDiscard: !1,
      headerExtra: /* @__PURE__ */ n.createElement("span", { className: ye.kicker }, "✦ ", t),
      error: u,
      footer: /* @__PURE__ */ n.createElement(mt, { onClick: r }, "닫기")
    },
    /* @__PURE__ */ n.createElement(Iy, { items: a, busy: c, onRun: (_) => f(() => s(_)), onSkip: (_) => f(() => o(_)) })
  );
}
const Oy = "_wrap_1wvdc_2", Py = "_header_1wvdc_7", Xy = "_iconBox_1wvdc_8", zy = "_headText_1wvdc_12", Fy = "_eyebrow_1wvdc_13", Hy = "_headline_1wvdc_14", Wy = "_headerExtra_1wvdc_16", Ky = "_grid_1wvdc_19", Uy = "_card_1wvdc_20", Gy = "_badge_1wvdc_29", Yy = "_toneRed_1wvdc_33", Vy = "_toneViolet_1wvdc_34", Qy = "_toneGreen_1wvdc_35", Jy = "_toneBlue_1wvdc_36", Zy = "_title_1wvdc_38", eb = "_summary_1wvdc_42", tb = "_action_1wvdc_46", nb = "_notice_1wvdc_53", ab = "_err_1wvdc_56", fe = {
  wrap: Oy,
  header: Py,
  iconBox: Xy,
  headText: zy,
  eyebrow: Fy,
  headline: Hy,
  headerExtra: Wy,
  grid: Ky,
  card: Uy,
  badge: Gy,
  toneRed: Yy,
  toneViolet: Vy,
  toneGreen: Qy,
  toneBlue: Jy,
  title: Zy,
  summary: eb,
  action: tb,
  notice: nb,
  err: ab
};
function tr({ size: e = 16 }) {
  return /* @__PURE__ */ n.createElement("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", "aria-hidden": "true" }, /* @__PURE__ */ n.createElement("path", { d: "M12 2.8c.72 5.16 2.85 7.3 8.02 8.02-5.17.72-7.3 2.86-8.02 8.02-.72-5.16-2.85-7.3-8.02-8.02C9.15 10.1 11.28 7.96 12 2.8Z", fill: "currentColor" }));
}
const rb = {
  red: fe.toneRed,
  violet: fe.toneViolet,
  green: fe.toneGreen,
  blue: fe.toneBlue
};
function Z0({
  items: e,
  onOpen: t,
  eyebrow: a = "PROACTIVE AI",
  headline: r = "지금 처리할 수 있는 업무를 발견했습니다",
  error: s,
  loading: o,
  emptyText: l = "지금은 처리할 업무 제안이 없습니다.",
  headerExtra: c,
  className: i = ""
}) {
  return /* @__PURE__ */ n.createElement("section", { className: [fe.wrap, i].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: fe.header }, /* @__PURE__ */ n.createElement("span", { className: fe.iconBox }, /* @__PURE__ */ n.createElement(tr, { size: 18 })), /* @__PURE__ */ n.createElement("div", { className: fe.headText }, /* @__PURE__ */ n.createElement("div", { className: fe.eyebrow }, a), /* @__PURE__ */ n.createElement("h2", { className: fe.headline }, r)), c ? /* @__PURE__ */ n.createElement("div", { className: fe.headerExtra }, c) : null), s ? /* @__PURE__ */ n.createElement("div", { className: fe.notice + " " + fe.err, role: "alert" }, s) : null, e.length === 0 ? s ? null : o ? /* @__PURE__ */ n.createElement("div", { className: fe.notice, role: "status" }, "업무 제안을 확인하고 있습니다.") : /* @__PURE__ */ n.createElement("div", { className: fe.notice }, l) : /* @__PURE__ */ n.createElement("div", { className: fe.grid }, e.map((u) => {
    var m, f;
    return /* @__PURE__ */ n.createElement("button", { type: "button", key: u.id, className: fe.card, onClick: () => t(u) }, /* @__PURE__ */ n.createElement("span", { className: [fe.badge, rb[(m = u.tone) != null ? m : "violet"]].join(" ") }, /* @__PURE__ */ n.createElement(tr, { size: 9 }), u.badge), /* @__PURE__ */ n.createElement("span", { className: fe.title }, u.title), u.summary ? /* @__PURE__ */ n.createElement("span", { className: fe.summary, title: typeof u.summary == "string" ? u.summary : void 0 }, u.summary) : null, /* @__PURE__ */ n.createElement("span", { className: fe.action }, (f = u.actionLabel) != null ? f : "상세 보기", " ", /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true" }, "→")));
  })));
}
const sb = "_wrapper_wrch3_1", ob = "_searchIcon_wrch3_18", lb = "_input_wrch3_26", cb = "_clearButton_wrch3_40", ib = "_hint_wrch3_60", tn = {
  wrapper: sb,
  searchIcon: ob,
  input: lb,
  clearButton: cb,
  hint: ib
}, ub = /* @__PURE__ */ n.createElement("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.8", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("circle", { cx: "11", cy: "11", r: "7" }), /* @__PURE__ */ n.createElement("path", { d: "M21 21l-4.35-4.35" }));
function mb({
  value: e,
  onChange: t,
  placeholder: a,
  hint: r,
  onSubmit: s,
  onClear: o
}) {
  const l = (c) => {
    c.key === "Enter" && (s == null || s());
  };
  return /* @__PURE__ */ n.createElement("div", { className: tn.wrapper }, /* @__PURE__ */ n.createElement("span", { className: tn.searchIcon }, ub), /* @__PURE__ */ n.createElement(
    "input",
    {
      type: "text",
      className: tn.input,
      value: e,
      placeholder: a,
      onChange: (c) => t(c.target.value),
      onKeyDown: l
    }
  ), o && e.length > 0 && /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: tn.clearButton,
      onClick: o,
      "aria-label": "비우기"
    },
    /* @__PURE__ */ n.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("path", { d: "M18 6L6 18" }), /* @__PURE__ */ n.createElement("path", { d: "M6 6l12 12" }))
  ), r && /* @__PURE__ */ n.createElement("span", { className: tn.hint }, r));
}
const db = "_screen_1bsma_1", fb = "_shell_1bsma_8", _b = "_command_1bsma_10", pb = "_body_1bsma_20", yb = "_overview_1bsma_22", bb = "_areaHead_1bsma_25", Xt = {
  screen: db,
  shell: fb,
  command: _b,
  body: pb,
  overview: yb,
  areaHead: bb
};
function ek({ search: e, panel: t, children: a, className: r = "" }) {
  var s;
  return /* @__PURE__ */ n.createElement("main", { className: [Xt.screen, r].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: Xt.shell }, e && /* @__PURE__ */ n.createElement("div", { className: Xt.command }, /* @__PURE__ */ n.createElement(
    mb,
    {
      value: e.value,
      onChange: e.onChange,
      onClear: e.onClear,
      onSubmit: e.onSubmit,
      placeholder: e.placeholder,
      hint: (s = e.hint) != null ? s : /* @__PURE__ */ n.createElement("kbd", null, "F10")
    }
  ), t), /* @__PURE__ */ n.createElement("div", { className: Xt.body }, a)));
}
function tk({ children: e, className: t = "" }) {
  return /* @__PURE__ */ n.createElement("div", { className: [Xt.overview, t].filter(Boolean).join(" ") }, e);
}
function nk({ title: e, hint: t }) {
  return /* @__PURE__ */ n.createElement("div", { className: Xt.areaHead }, /* @__PURE__ */ n.createElement("h2", null, e), t && /* @__PURE__ */ n.createElement("span", null, t));
}
const Eb = "_group_oodts_1", hb = "_grid_oodts_7", gb = "_row_oodts_8", vb = "_item_oodts_9", kb = "_launch_oodts_14", wb = "_name_oodts_17", Nb = "_desc_oodts_18", $b = "_badge_oodts_19", xb = "_disabled_oodts_23", Db = "_tab_oodts_25", Ab = "_star_oodts_25", Cb = "_on_oodts_30", Sb = "_empty_oodts_32", Pe = {
  group: Eb,
  grid: hb,
  row: gb,
  item: vb,
  launch: kb,
  name: wb,
  desc: Nb,
  badge: $b,
  disabled: xb,
  tab: Db,
  star: Ab,
  on: Cb,
  empty: Sb
};
function Mb() {
  return /* @__PURE__ */ n.createElement("svg", { width: "12", height: "12", viewBox: "0 0 12 12", "aria-hidden": "true", fill: "none", stroke: "currentColor", strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("path", { d: "M3 1.5h4l2.5 2.5v6a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5v-8A.5.5 0 0 1 3 1.5Z" }), /* @__PURE__ */ n.createElement("path", { d: "M7 1.5V4h2.5M4.2 6.2h3.6M4.2 8.2h3.6" }));
}
function Tb() {
  return /* @__PURE__ */ n.createElement("svg", { width: "13", height: "13", viewBox: "0 0 12 12", "aria-hidden": "true", fill: "none", stroke: "currentColor", strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("path", { d: "M5 2H2.5A.5.5 0 0 0 2 2.5v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V7M7.5 2H10v2.5M10 2 5.5 6.5" }));
}
function ak({ title: e, items: t, emptyText: a, className: r = "" }) {
  return /* @__PURE__ */ n.createElement("section", { className: [Pe.group, r].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("h3", null, e), /* @__PURE__ */ n.createElement("div", { className: Pe.grid }, t.map((s) => /* @__PURE__ */ n.createElement("div", { className: Pe.row, key: s.key }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: [Pe.item, s.disabled ? Pe.disabled : ""].filter(Boolean).join(" "),
      disabled: s.disabled,
      onClick: s.onOpen
    },
    /* @__PURE__ */ n.createElement("span", { className: Pe.launch }, /* @__PURE__ */ n.createElement(Mb, null)),
    /* @__PURE__ */ n.createElement("span", { className: Pe.name }, s.label),
    s.desc && /* @__PURE__ */ n.createElement("span", { className: Pe.desc }, s.desc),
    s.badge != null && /* @__PURE__ */ n.createElement("em", { className: Pe.badge }, s.badge)
  ), s.onOpenNewTab && !s.disabled && /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: Pe.tab,
      "aria-label": `${s.label} 새 탭으로 열기`,
      title: "새 탭으로 열기",
      onClick: s.onOpenNewTab
    },
    /* @__PURE__ */ n.createElement(Tb, null)
  ), s.onToggleStar && !s.disabled && /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: [Pe.star, s.starred ? Pe.on : ""].filter(Boolean).join(" "),
      "aria-pressed": !!s.starred,
      "aria-label": `${s.label} ${s.starred ? "마이메뉴에서 삭제" : "마이메뉴에 추가"}`,
      onClick: s.onToggleStar
    },
    s.starred ? "★" : "☆"
  ))), t.length === 0 && a != null && /* @__PURE__ */ n.createElement("p", { className: Pe.empty }, a)));
}
const qb = "_strip_8zhai_2", Bb = "_day_8zhai_9", Lb = "_total_8zhai_10", jb = "_sel_8zhai_31", Rb = "_today_8zhai_35", Ib = "_md_8zhai_35", Ob = "_off_8zhai_36", Pb = "_head_8zhai_45", Xb = "_wd_8zhai_46", zb = "_sun_8zhai_47", Fb = "_sat_8zhai_48", Hb = "_lock_8zhai_50", Wb = "_value_8zhai_60", Kb = "_mark_8zhai_66", Ub = "_warn_8zhai_67", Gb = "_danger_8zhai_68", Yb = "_info_8zhai_69", Ne = {
  strip: qb,
  day: Bb,
  total: Lb,
  sel: jb,
  today: Rb,
  md: Ib,
  off: Ob,
  head: Pb,
  wd: Xb,
  sun: zb,
  sat: Fb,
  lock: Hb,
  value: Wb,
  mark: Kb,
  warn: Ub,
  danger: Gb,
  info: Yb
}, nr = ["일", "월", "화", "수", "목", "금", "토"];
function Vb(e) {
  const [t, a, r] = e.split("-").map(Number), s = new Date(t, a - 1, r).getDay();
  return { md: `${a}/${r}`, wd: s };
}
function rk({
  days: e,
  selected: t,
  today: a,
  onSelect: r,
  total: s,
  totalLabel: o = "합계",
  "aria-label": l,
  className: c
}) {
  const i = B([]), u = (_) => {
    var y;
    const p = e.length;
    for (let d = 0; d < p; d++) {
      const b = (_ + d + p) % p;
      if (!e[b].disabled) {
        (y = i.current[b]) == null || y.focus();
        return;
      }
    }
  }, m = (_, p) => {
    _.key === "ArrowRight" ? (_.preventDefault(), u(p + 1)) : _.key === "ArrowLeft" ? (_.preventDefault(), u(p - 1)) : _.key === "Home" ? (_.preventDefault(), u(0)) : _.key === "End" && (_.preventDefault(), u(e.length - 1));
  }, f = Math.max(0, e.findIndex((_) => _.date === t));
  return /* @__PURE__ */ n.createElement("div", { className: `${Ne.strip}${c ? ` ${c}` : ""}`, role: "group", "aria-label": l }, e.map((_, p) => {
    var N, g, $, h;
    const { md: y, wd: d } = Vb(_.date), b = [
      Ne.day,
      _.off ? Ne.off : "",
      _.date === t ? Ne.sel : "",
      _.date === a ? Ne.today : "",
      d === 0 ? Ne.sun : d === 6 ? Ne.sat : ""
    ].filter(Boolean).join(" "), w = [`${y}(${nr[d]})`, _.offLabel, _.locked ? "잠김" : null, (N = _.mark) == null ? void 0 : N.text].filter(Boolean).join(" · ");
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: _.date,
        ref: (v) => {
          i.current[p] = v;
        },
        type: "button",
        className: b,
        disabled: _.disabled,
        tabIndex: p === f ? 0 : -1,
        "aria-pressed": _.date === t,
        "aria-label": w,
        title: w,
        onClick: () => r == null ? void 0 : r(_.date),
        onKeyDown: (v) => m(v, p)
      },
      /* @__PURE__ */ n.createElement("span", { className: Ne.head }, /* @__PURE__ */ n.createElement("span", { className: Ne.wd }, nr[d]), /* @__PURE__ */ n.createElement("span", { className: Ne.md }, y), _.locked && /* @__PURE__ */ n.createElement("span", { className: Ne.lock, "aria-hidden": "true" }, "잠김")),
      /* @__PURE__ */ n.createElement("span", { className: Ne.value }, _.value),
      /* @__PURE__ */ n.createElement("span", { className: `${Ne.mark}${_.mark ? ` ${Ne[_.mark.tone]}` : ""}` }, (h = (g = _.mark) == null ? void 0 : g.text) != null ? h : _.off && ($ = _.offLabel) != null ? $ : "")
    );
  }), s !== void 0 && /* @__PURE__ */ n.createElement("div", { className: Ne.total }, /* @__PURE__ */ n.createElement("span", { className: Ne.wd }, o), /* @__PURE__ */ n.createElement("span", { className: Ne.value }, s)));
}
const Qb = "_stepper_1wbt2_1", Jb = "_nav_1wbt2_2", Zb = "_today_1wbt2_3", e1 = "_range_1wbt2_14", nn = {
  stepper: Qb,
  nav: Jb,
  today: Zb,
  range: e1
};
function t1(e) {
  const t = ba(e);
  return t === 0 ? 7 : t;
}
function n1(e, t = 1) {
  const a = (t1(e) - t + 7) % 7;
  return Bn(e, -a);
}
function Qn(e, t) {
  return Bn(e, t);
}
function sk({ value: e, onChange: t, weekStart: a = 1, today: r, disabled: s, label: o = "주" }) {
  const l = Qn(e, 6), c = n1(r, a), i = l.slice(0, 4) === e.slice(0, 4) ? l.slice(5) : l;
  return /* @__PURE__ */ n.createElement("span", { className: nn.stepper, role: "group", "aria-label": o }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: nn.nav,
      onClick: () => t(Qn(e, -7)),
      disabled: s,
      "aria-label": "이전 주"
    },
    "◀"
  ), /* @__PURE__ */ n.createElement("span", { className: nn.range, "aria-live": "polite" }, e, " ~ ", i), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: nn.nav,
      onClick: () => t(Qn(e, 7)),
      disabled: s,
      "aria-label": "다음 주"
    },
    "▶"
  ), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: nn.today,
      onClick: () => t(c),
      disabled: s || e === c
    },
    "이번 주"
  ));
}
const a1 = "_wrap_1dtpy_1", r1 = "_svg_1dtpy_2", s1 = "_grid_1dtpy_3", o1 = "_axis_1dtpy_4", l1 = "_accent_1dtpy_5", c1 = "_muted_1dtpy_6", i1 = "_ok_1dtpy_7", u1 = "_warn_1dtpy_8", m1 = "_danger_1dtpy_9", d1 = "_legend_1dtpy_10", f1 = "_dot_accent_1dtpy_13", _1 = "_dot_muted_1dtpy_14", p1 = "_dot_ok_1dtpy_15", y1 = "_dot_warn_1dtpy_16", b1 = "_dot_danger_1dtpy_17", ht = {
  wrap: a1,
  svg: r1,
  grid: s1,
  axis: o1,
  accent: l1,
  muted: c1,
  ok: i1,
  warn: u1,
  danger: m1,
  legend: d1,
  dot_accent: f1,
  dot_muted: _1,
  dot_ok: p1,
  dot_warn: y1,
  dot_danger: b1
}, E1 = 600;
function h1(e) {
  if (e <= 0) return 1;
  const t = Math.pow(10, Math.floor(Math.log10(e))), a = e / t;
  return (a <= 1 ? 1 : a <= 2 ? 2 : a <= 5 ? 5 : 10) * t;
}
const ar = (e) => e.toLocaleString("ko-KR", { maximumFractionDigits: 1 });
function ok({ categories: e, series: t, unit: a = "", height: r = 180, label: s, labelEvery: o }) {
  const l = B(null), [c, i] = A(E1);
  xe(() => {
    const E = l.current;
    if (!E) return;
    const x = () => {
      const M = E.clientWidth;
      M > 0 && i((T) => T === M ? T : M);
    };
    if (x(), typeof ResizeObserver == "undefined") return;
    const C = new ResizeObserver(x);
    return C.observe(E), () => C.disconnect();
  }, []);
  const u = r, m = 40, f = 22, _ = 8, p = c - m - 4, y = u - f - _, d = t.flatMap((E) => E.values.filter((x) => x != null)), b = h1(Math.max(0, ...d)), w = Math.max(e.length, 1), N = p / w, g = Math.min(8, N * 0.2), $ = Math.max(1, (N - g) / Math.max(t.length, 1)), h = o != null ? o : Math.max(1, Math.ceil(w / 8)), v = [0, b / 2, b];
  return /* @__PURE__ */ n.createElement("div", { className: ht.wrap, ref: l }, /* @__PURE__ */ n.createElement(
    "svg",
    {
      className: ht.svg,
      viewBox: `0 0 ${c} ${u}`,
      role: "img",
      "aria-label": s,
      style: { height: r }
    },
    v.map((E) => {
      const x = _ + y - E / b * y;
      return /* @__PURE__ */ n.createElement("g", { key: E }, /* @__PURE__ */ n.createElement("line", { className: ht.grid, x1: m, x2: c - 4, y1: x, y2: x }), /* @__PURE__ */ n.createElement("text", { className: ht.axis, x: m - 4, y: x + 3, textAnchor: "end" }, ar(E)));
    }),
    e.map((E, x) => /* @__PURE__ */ n.createElement("g", { key: E }, t.map((C, M) => {
      var q;
      const T = C.values[x];
      if (T == null || T <= 0) return null;
      const I = T / b * y;
      return /* @__PURE__ */ n.createElement(
        "rect",
        {
          key: C.key,
          className: ht[(q = C.tone) != null ? q : "accent"],
          x: m + x * N + g / 2 + M * $,
          y: _ + y - I,
          width: $,
          height: I
        },
        /* @__PURE__ */ n.createElement("title", null, `${E} · ${C.label} ${ar(T)}${a}`)
      );
    }), x % h === 0 && /* @__PURE__ */ n.createElement("text", { className: ht.axis, x: m + x * N + N / 2, y: u - 6, textAnchor: "middle" }, E)))
  ), /* @__PURE__ */ n.createElement("ul", { className: ht.legend }, t.map((E) => {
    var x;
    return /* @__PURE__ */ n.createElement("li", { key: E.key }, /* @__PURE__ */ n.createElement("i", { className: ht[`dot_${(x = E.tone) != null ? x : "accent"}`], "aria-hidden": "true" }), E.label, a ? ` (${a})` : "");
  })));
}
const g1 = "_wrap_85lir_1", v1 = "_track_85lir_2", k1 = "_accent_85lir_3", w1 = "_muted_85lir_3", N1 = "_ok_85lir_3", $1 = "_warn_85lir_3", x1 = "_danger_85lir_3", D1 = "_center_85lir_9", A1 = "_legend_85lir_10", C1 = "_name_85lir_13", S1 = "_val_85lir_14", M1 = "_pct_85lir_15", T1 = "_dot_accent_85lir_16", q1 = "_dot_muted_85lir_17", B1 = "_dot_ok_85lir_18", L1 = "_dot_warn_85lir_19", j1 = "_dot_danger_85lir_20", ot = {
  wrap: g1,
  track: v1,
  accent: k1,
  muted: w1,
  ok: N1,
  warn: $1,
  danger: x1,
  center: D1,
  legend: A1,
  name: C1,
  val: S1,
  pct: M1,
  dot_accent: T1,
  dot_muted: q1,
  dot_ok: B1,
  dot_warn: L1,
  dot_danger: j1
}, la = 40, rr = 2 * Math.PI * la;
function lk({ items: e, center: t, size: a = 120, label: r, emptyText: s = "자료 없음", unit: o = "" }) {
  const l = e.reduce((i, u) => i + Math.max(0, u.value), 0);
  let c = 0;
  return /* @__PURE__ */ n.createElement("div", { className: ot.wrap }, /* @__PURE__ */ n.createElement("svg", { viewBox: "0 0 100 100", width: a, height: a, role: "img", "aria-label": r }, /* @__PURE__ */ n.createElement("circle", { className: ot.track, cx: "50", cy: "50", r: la }), l > 0 && e.map((i) => {
    var f;
    const u = Math.max(0, i.value) / l * rr, m = c;
    return c += u, u <= 0 ? null : /* @__PURE__ */ n.createElement(
      "circle",
      {
        key: i.key,
        className: ot[(f = i.tone) != null ? f : "accent"],
        cx: "50",
        cy: "50",
        r: la,
        strokeDasharray: `${u} ${rr - u}`,
        strokeDashoffset: -m,
        transform: "rotate(-90 50 50)"
      },
      /* @__PURE__ */ n.createElement("title", null, `${i.label} ${i.value.toLocaleString("ko-KR")}${o}`)
    );
  }), /* @__PURE__ */ n.createElement("text", { className: ot.center, x: "50", y: "54", textAnchor: "middle" }, l > 0 ? t != null ? t : l.toLocaleString("ko-KR") : s)), /* @__PURE__ */ n.createElement("ul", { className: ot.legend }, e.map((i) => {
    var u;
    return /* @__PURE__ */ n.createElement("li", { key: i.key }, /* @__PURE__ */ n.createElement("i", { className: ot[`dot_${(u = i.tone) != null ? u : "accent"}`], "aria-hidden": "true" }), /* @__PURE__ */ n.createElement("span", { className: ot.name }, i.label), /* @__PURE__ */ n.createElement("span", { className: ot.val }, i.value.toLocaleString("ko-KR"), o), /* @__PURE__ */ n.createElement("span", { className: ot.pct }, l > 0 ? `${Math.round(i.value / l * 100)}%` : "-"));
  })));
}
const R1 = "_wrap_1b8ll_1", I1 = "_track_1b8ll_2", O1 = "_compact_1b8ll_3", P1 = "_fill_1b8ll_4", X1 = "_accent_1b8ll_5", z1 = "_muted_1b8ll_6", F1 = "_ok_1b8ll_7", H1 = "_warn_1b8ll_8", W1 = "_danger_1b8ll_9", K1 = "_num_1b8ll_10", U1 = "_none_1b8ll_12", At = {
  wrap: R1,
  track: I1,
  compact: O1,
  fill: P1,
  accent: X1,
  muted: z1,
  ok: F1,
  warn: H1,
  danger: W1,
  num: K1,
  none: U1
};
function ck({ value: e, label: t, tone: a = "accent", compact: r }) {
  if (e == null)
    return /* @__PURE__ */ n.createElement("span", { className: At.none, "aria-label": `${t} 해당 없음` }, "-");
  const s = Math.max(0, Math.min(100, e));
  return /* @__PURE__ */ n.createElement(
    "span",
    {
      className: [At.wrap, r ? At.compact : ""].filter(Boolean).join(" "),
      role: "progressbar",
      "aria-label": t,
      "aria-valuemin": 0,
      "aria-valuemax": 100,
      "aria-valuenow": s
    },
    /* @__PURE__ */ n.createElement("span", { className: At.track }, /* @__PURE__ */ n.createElement("span", { className: `${At.fill} ${At[a]}`, style: { width: `${s}%` } })),
    /* @__PURE__ */ n.createElement("span", { className: At.num }, s, "%")
  );
}
const G1 = { day: 28, week: 10, month: 3 };
function Bt(e, t) {
  return Bn(e, t);
}
function ca(e, t) {
  return wt(t) - wt(e) + 1;
}
function Kr(e) {
  return ba(e);
}
const sr = (e) => {
  const t = Kr(e);
  return t === 0 || t === 6;
};
function Pt(e, t, a, r) {
  const s = [], o = ca(e, t);
  for (let l = 0; l < o; l++) {
    const c = Bt(e, l), i = a(c), u = s[s.length - 1];
    u && u.key === i ? u.days++ : s.push({ key: i, label: r(c), offset: l, days: 1 });
  }
  return s;
}
function Y1(e, t, a) {
  const r = (o) => o.slice(0, 7), s = (o) => `${o.slice(0, 4)}.${o.slice(5, 7)}`;
  if (a === "month")
    return {
      top: Pt(e, t, (o) => o.slice(0, 4), (o) => `${o.slice(0, 4)}년`),
      bottom: Pt(e, t, r, (o) => `${Number(o.slice(5, 7))}월`)
    };
  if (a === "week") {
    const o = (l) => Bt(l, -((Kr(l) + 6) % 7));
    return {
      top: Pt(e, t, r, s),
      bottom: Pt(e, t, o, (l) => {
        const c = o(l);
        return `${Number(c.slice(5, 7))}/${Number(c.slice(8, 10))}`;
      })
    };
  }
  return {
    top: Pt(e, t, r, s),
    bottom: Pt(e, t, (o) => o, (o) => String(Number(o.slice(8, 10))))
  };
}
function Jn(e, t, a, r) {
  if (a === "move") return { start: Bt(e, r), end: Bt(t, r) };
  if (a === "start") {
    const o = Bt(e, r);
    return { start: o > t ? t : o, end: t };
  }
  const s = Bt(t, r);
  return { start: e, end: s < e ? e : s };
}
const V1 = "_gantt_1smka_3", Q1 = "_scroll_1smka_15", J1 = "_canvas_1smka_21", Z1 = "_head_1smka_24", eE = "_headLabel_1smka_32", tE = "_headTrack_1smka_43", nE = "_band_1smka_44", aE = "_seg_1smka_46", rE = "_tick_1smka_59", sE = "_tickOff_1smka_60", oE = "_body_1smka_62", lE = "_overlay_1smka_65", cE = "_weekend_1smka_66", iE = "_holiday_1smka_66", uE = "_today_1smka_68", mE = "_row_1smka_70", dE = "_label_1smka_76", fE = "_sel_1smka_77", _E = "_track_1smka_77", pE = "_dim_1smka_78", yE = "_labelText_1smka_95", bE = "_dot_1smka_96", EE = "_warn_1smka_97", hE = "_err_1smka_98", gE = "_bar_1smka_113", vE = "_can_1smka_21", kE = "_dragging_1smka_126", wE = "_fill_1smka_127", NE = "_late_1smka_128", $E = "_summary_1smka_130", xE = "_handle_1smka_133", DE = "_hL_1smka_134", AE = "_hR_1smka_135", CE = "_mark_1smka_137", SE = "_barText_1smka_138", ME = "_empty_1smka_147", TE = "_srOnly_1smka_150", ee = {
  gantt: V1,
  scroll: Q1,
  canvas: J1,
  head: Z1,
  headLabel: eE,
  headTrack: tE,
  band: nE,
  seg: aE,
  tick: rE,
  tickOff: sE,
  body: oE,
  overlay: lE,
  weekend: cE,
  holiday: iE,
  today: uE,
  row: mE,
  label: dE,
  sel: fE,
  track: _E,
  dim: pE,
  labelText: yE,
  dot: bE,
  warn: EE,
  err: hE,
  bar: gE,
  can: vE,
  dragging: kE,
  fill: wE,
  late: NE,
  summary: $E,
  handle: xE,
  hL: DE,
  hR: AE,
  mark: CE,
  barText: SE,
  empty: ME,
  srOnly: TE
}, or = 28, lr = "키보드: ←→ 옮기기 · Shift+←→ 끝 조절 · Alt+←→ 시작 조절 · Enter 열기";
let qE = 0;
function ik({
  rows: e,
  from: t,
  to: a,
  scale: r = "day",
  holidays: s = {},
  today: o,
  scrollToToday: l = !0,
  onChange: c,
  onRowClick: i,
  selectedId: u,
  labelWidth: m = 280,
  labelHeader: f,
  lockedReason: _,
  scrollMemory: p,
  className: y = "",
  style: d,
  "aria-label": b
}) {
  const w = B("");
  w.current || (w.current = `axe-gantt-keys-${++qE}`);
  const N = G1[r], g = Math.max(ca(t, a), 1), $ = wt(t), h = g * N, v = we(() => Y1(t, a, r), [t, a, r]), E = we(() => {
    const k = [];
    for (let O = 0; O < g; O++) {
      const Q = Bt(t, O), J = Q in s;
      if (!J && !sr(Q)) continue;
      const se = k[k.length - 1];
      se && se.offset + se.days === O && se.holiday === J ? se.days++ : k.push({ offset: O, days: 1, holiday: J });
    }
    return k;
  }, [t, g, s]), [x, C] = A(null), M = B(null), T = (k) => !!c && !k.locked && !k.summary && !!k.start && !!k.end, I = (k, O, Q) => {
    if (!T(O) || k.button !== 0) return;
    k.stopPropagation(), k.currentTarget.setPointerCapture(k.pointerId);
    const J = { id: O.id, mode: Q, x: k.clientX, delta: 0, moved: !1 };
    M.current = J, C(J);
  }, q = (k) => {
    const O = M.current;
    if (!O) return;
    const Q = Math.round((k.clientX - O.x) / N), J = O.moved || Math.abs(k.clientX - O.x) > 3;
    if (Q !== O.delta || J !== O.moved) {
      const se = { ...O, delta: Q, moved: J };
      M.current = se, C(se);
    }
  }, X = (k) => {
    const O = M.current;
    if (M.current = null, C(null), !!O) {
      if (!O.moved) {
        i == null || i(k);
        return;
      }
      O.delta !== 0 && k.start && k.end && (c == null || c(k, Jn(k.start, k.end, O.mode, O.delta), O.mode));
    }
  }, Y = () => {
    M.current = null, C(null);
  }, K = (k, O) => {
    if (k.key === "Escape" && M.current) {
      Y();
      return;
    }
    if (k.key === "Enter") {
      i == null || i(O);
      return;
    }
    if (!T(O) || k.key !== "ArrowLeft" && k.key !== "ArrowRight") return;
    k.preventDefault();
    const Q = k.key === "ArrowLeft" ? -1 : 1, J = k.shiftKey ? "end" : k.altKey ? "start" : "move";
    c == null || c(O, Jn(O.start, O.end, J, Q), J);
  }, j = o ? wt(o) - $ : -1, ne = B(null), ae = B(null);
  return xe(() => {
    const k = ne.current;
    if (k && (p != null && p.current) && ae.current === null) {
      ae.current = r, k.scrollLeft = p.current.left, k.scrollTop = p.current.top;
      return;
    }
    if (!l || !k || j < 0 || j >= g || ae.current === r) return;
    ae.current = r;
    const O = Math.max(k.clientWidth - m, 0);
    k.scrollLeft = Math.max(0, j * N + N / 2 - O / 3);
  }, [l, r, j, g, N, m]), /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [ee.gantt, y].filter(Boolean).join(" "),
      style: d,
      role: "region",
      "aria-label": b != null ? b : "간트",
      onKeyDown: (k) => {
        k.key === "Escape" && M.current && Y();
      }
    },
    /* @__PURE__ */ n.createElement("span", { id: w.current, className: ee.srOnly }, lr),
    /* @__PURE__ */ n.createElement(
      "div",
      {
        ref: ne,
        className: ee.scroll,
        onScroll: p ? (k) => {
          p.current = { left: k.currentTarget.scrollLeft, top: k.currentTarget.scrollTop };
        } : void 0
      },
      /* @__PURE__ */ n.createElement("div", { className: ee.canvas, style: { width: m + h } }, /* @__PURE__ */ n.createElement("div", { className: ee.head, style: { gridTemplateColumns: `${m}px ${h}px` } }, /* @__PURE__ */ n.createElement("div", { className: ee.headLabel }, f), /* @__PURE__ */ n.createElement("div", { className: ee.headTrack }, /* @__PURE__ */ n.createElement("div", { className: ee.band }, v.top.map((k) => /* @__PURE__ */ n.createElement("span", { key: k.key, className: ee.seg, style: { left: k.offset * N, width: k.days * N }, title: k.label }, k.label))), /* @__PURE__ */ n.createElement("div", { className: ee.band }, v.bottom.map((k) => {
        var Q;
        const O = r === "day" && (k.key in s || sr(k.key));
        return /* @__PURE__ */ n.createElement(
          "span",
          {
            key: k.key,
            className: [ee.seg, ee.tick, O ? ee.tickOff : ""].filter(Boolean).join(" "),
            style: { left: k.offset * N, width: k.days * N },
            title: (Q = s[k.key]) != null ? Q : k.key
          },
          k.days * N >= 16 ? k.label : ""
        );
      })))), /* @__PURE__ */ n.createElement("div", { className: ee.body, style: { minHeight: or } }, /* @__PURE__ */ n.createElement("div", { className: ee.overlay, style: { left: m, width: h }, "aria-hidden": "true" }, E.map((k) => /* @__PURE__ */ n.createElement("span", { key: k.offset, className: k.holiday ? ee.holiday : ee.weekend, style: { left: k.offset * N, width: k.days * N } })), j >= 0 && j < g && /* @__PURE__ */ n.createElement("span", { className: ee.today, style: { left: j * N + N / 2 }, title: "오늘" })), e.map((k) => {
        var z, W, ce, Xe;
        const O = !!k.start && !!k.end && k.start <= k.end, Q = x && x.id === k.id ? x : null, J = O && Q && Q.delta !== 0 ? Jn(k.start, k.end, Q.mode, Q.delta) : O ? { start: k.start, end: k.end } : null, se = J ? (wt(J.start) - $) * N : 0, L = J ? ca(J.start, J.end) * N : 0, Z = Math.max(0, Math.min(100, (z = k.progress) != null ? z : 0)), R = u != null && u === k.id, F = T(k), V = !F && c && J ? _ == null ? void 0 : _(k) : void 0;
        return /* @__PURE__ */ n.createElement(
          "div",
          {
            key: k.id,
            className: [ee.row, R ? ee.sel : "", k.dim ? ee.dim : ""].filter(Boolean).join(" "),
            style: { height: or }
          },
          /* @__PURE__ */ n.createElement(
            "div",
            {
              className: ee.label,
              style: { width: m },
              title: k.name,
              onClick: () => i == null ? void 0 : i(k)
            },
            /* @__PURE__ */ n.createElement("span", { className: ee.labelText }, k.label),
            k.marked && /* @__PURE__ */ n.createElement("span", { className: ee.dot, title: "저장 대기", "aria-label": "저장 대기" }),
            k.warn && /* @__PURE__ */ n.createElement("span", { className: ee.warn, title: k.warn, "aria-label": k.warn }, "⚠"),
            k.error && /* @__PURE__ */ n.createElement("span", { className: ee.err, title: k.error, "aria-label": k.error }, "!")
          ),
          /* @__PURE__ */ n.createElement("div", { className: ee.track, style: { width: h }, onClick: () => !Q && (i == null ? void 0 : i(k)) }, J ? /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(
            "div",
            {
              className: [ee.bar, k.summary ? ee.summary : "", k.late ? ee.late : "", F ? ee.can : "", Q ? ee.dragging : ""].filter(Boolean).join(" "),
              style: { left: se, width: Math.max(L, 2) },
              role: "button",
              tabIndex: 0,
              "aria-label": `${(W = k.name) != null ? W : ""} ${J.start} ~ ${J.end}${k.progress != null ? ` ${Z}%` : ""}${k.late ? " 지연" : ""}${V ? ` 잠김: ${V}` : ""}`,
              "aria-describedby": F ? w.current : void 0,
              title: `${J.start} ~ ${J.end}${k.progress != null ? ` · ${Z}%` : ""}${k.late ? " · 지연" : ""}${F ? `
끌어 옮기기·양 끝 조절
${lr}` : ""}${V ? `
잠김: ${V}` : ""}`,
              onPointerDown: (Re) => I(Re, k, "move"),
              onPointerMove: q,
              onPointerUp: () => X(k),
              onPointerCancel: Y,
              onClick: (Re) => Re.stopPropagation(),
              onKeyDown: (Re) => K(Re, k)
            },
            k.progress != null && /* @__PURE__ */ n.createElement("span", { className: ee.fill, style: { width: `${Z}%` } }),
            F && /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: `${ee.handle} ${ee.hL}`, onPointerDown: (Re) => I(Re, k, "start") }), /* @__PURE__ */ n.createElement("span", { className: `${ee.handle} ${ee.hR}`, onPointerDown: (Re) => I(Re, k, "end") }))
          ), k.markDate && k.markDate >= t && k.markDate <= a && /* @__PURE__ */ n.createElement("span", { className: ee.mark, style: { left: (wt(k.markDate) - $ + 1) * N - 1 }, title: (ce = k.markLabel) != null ? ce : k.markDate }), k.barText && /* @__PURE__ */ n.createElement("span", { className: ee.barText, style: { left: se + Math.max(L, 2) + 4 } }, k.barText)) : /* @__PURE__ */ n.createElement("span", { className: ee.empty }, (Xe = k.emptyText) != null ? Xe : "기간 없음"))
        );
      })))
    )
  );
}
const BE = "_board_192fl_3", LE = "_col_192fl_15", jE = "_over_192fl_23", RE = "_head_192fl_25", IE = "_title_192fl_33", OE = "_count_192fl_34", PE = "_hint_192fl_43", XE = "_list_192fl_45", zE = "_empty_192fl_54", FE = "_card_192fl_56", HE = "_sel_192fl_68", WE = "_dragging_192fl_69", KE = "_hasErr_192fl_70", UE = "_dot_192fl_71", GE = "_err_192fl_72", Te = {
  board: BE,
  col: LE,
  over: jE,
  head: RE,
  title: IE,
  count: OE,
  hint: PE,
  list: XE,
  empty: zE,
  card: FE,
  sel: HE,
  dragging: WE,
  hasErr: KE,
  dot: UE,
  err: GE
}, Zn = "application/x-axerp-kanban";
function uk({
  columns: e,
  cards: t,
  cardKey: a,
  columnOf: r,
  renderCard: s,
  cardLabel: o,
  onMove: l,
  onCardClick: c,
  selectedKey: i,
  marked: u,
  error: m,
  lockedReason: f,
  emptyText: _ = "카드가 없습니다",
  moveHint: p,
  className: y = "",
  style: d,
  "aria-label": b
}) {
  const w = Gt("axe-kb"), [N, g] = A(null), [$, h] = A(null), v = new Map(t.map((T) => [String(a(T)), T])), E = B(null), x = B(null);
  G(() => {
    var q, X;
    const T = x.current;
    if (!T) return;
    if (Date.now() > T.until) {
      x.current = null;
      return;
    }
    const I = Array.from((X = (q = E.current) == null ? void 0 : q.querySelectorAll("[data-kanban-key]")) != null ? X : []).find((Y) => Y.dataset.kanbanKey === T.key);
    I && document.activeElement !== I && I.focus(), x.current = null;
  });
  const C = (T, I) => {
    T.preventDefault(), g(null), h(null);
    const q = T.dataTransfer.getData(Zn), X = v.get(q);
    X && r(X) !== I && (l == null || l(X, I));
  }, M = (T, I) => {
    if (T.key === "Enter" || T.key === " ") {
      T.preventDefault(), c == null || c(I);
      return;
    }
    if (!l || !T.altKey || T.key !== "ArrowLeft" && T.key !== "ArrowRight" || f != null && f(I)) return;
    T.preventDefault();
    const q = e.findIndex((Y) => Y.key === r(I)), X = q + (T.key === "ArrowLeft" ? -1 : 1);
    q >= 0 && X >= 0 && X < e.length && (x.current = { key: String(a(I)), until: Date.now() + 1500 }, l(I, e[X].key));
  };
  return /* @__PURE__ */ n.createElement("div", { ref: E, className: [Te.board, y].filter(Boolean).join(" "), style: d, role: "region", "aria-label": b != null ? b : "보드" }, e.map((T) => {
    const I = t.filter((q) => r(q) === T.key);
    return /* @__PURE__ */ n.createElement(
      "section",
      {
        key: T.key,
        className: [Te.col, N === T.key ? Te.over : ""].filter(Boolean).join(" "),
        "aria-label": typeof T.title == "string" ? T.title : void 0,
        onDragOver: l ? (q) => {
          q.dataTransfer.types.includes(Zn) && (q.preventDefault(), g(T.key));
        } : void 0,
        onDragLeave: l ? (q) => {
          q.currentTarget.contains(q.relatedTarget) || g((X) => X === T.key ? null : X);
        } : void 0,
        onDrop: l ? (q) => C(q, T.key) : void 0
      },
      /* @__PURE__ */ n.createElement("header", { className: Te.head }, /* @__PURE__ */ n.createElement("span", { className: Te.title }, T.title), /* @__PURE__ */ n.createElement("span", { className: Te.count }, I.length), T.hint && /* @__PURE__ */ n.createElement("span", { className: Te.hint }, T.hint)),
      /* @__PURE__ */ n.createElement("div", { className: Te.list }, I.length === 0 && /* @__PURE__ */ n.createElement("p", { className: Te.empty }, _), I.map((q) => {
        const X = a(q), Y = f == null ? void 0 : f(q), K = m == null ? void 0 : m(q), j = !!l && !Y, ne = Y != null ? Y : j ? p != null ? p : "끌어 다른 열로 옮길 수 있습니다 (Alt+←→)" : void 0;
        return /* @__PURE__ */ n.createElement(
          "article",
          {
            key: X,
            className: [Te.card, i === X ? Te.sel : "", $ === X ? Te.dragging : "", K ? Te.hasErr : ""].filter(Boolean).join(" "),
            tabIndex: 0,
            "data-kanban-key": String(X),
            role: "button",
            "aria-label": o == null ? void 0 : o(q),
            "aria-keyshortcuts": j ? "Alt+ArrowLeft Alt+ArrowRight" : void 0,
            title: ne,
            "aria-describedby": ne ? `${w}-h-${String(X)}` : void 0,
            draggable: j,
            onDragStart: j ? (ae) => {
              ae.dataTransfer.setData(Zn, String(X)), ae.dataTransfer.effectAllowed = "move", h(X);
            } : void 0,
            onDragEnd: () => {
              h(null), g(null);
            },
            onClick: () => c == null ? void 0 : c(q),
            onKeyDown: (ae) => M(ae, q)
          },
          ne && /* @__PURE__ */ n.createElement(Sr, { id: `${w}-h-${String(X)}` }, ne),
          (u == null ? void 0 : u(q)) && /* @__PURE__ */ n.createElement("span", { className: Te.dot, title: "저장 대기", "aria-label": "저장 대기" }),
          s(q),
          K && /* @__PURE__ */ n.createElement("p", { className: Te.err, role: "alert" }, K)
        );
      }))
    );
  }));
}
const YE = "_list_1aqum_2", VE = "_empty_1aqum_3", QE = "_item_1aqum_5", JE = "_row_block_1aqum_6", ZE = "_row_warn_1aqum_7", eh = "_head_1aqum_9", th = "_mark_1aqum_16", nh = "_msg_1aqum_17", ah = "_count_1aqum_18", rh = "_aside_1aqum_19", sh = "_caret_1aqum_20", oh = "_block_1aqum_22", lh = "_warn_1aqum_23", ch = "_info_1aqum_24", ih = "_body_1aqum_29", uh = "_actions_1aqum_30", qe = {
  list: YE,
  empty: VE,
  item: QE,
  row_block: JE,
  row_warn: ZE,
  head: eh,
  mark: th,
  msg: nh,
  count: ah,
  aside: rh,
  caret: sh,
  block: oh,
  warn: lh,
  info: ch,
  body: ih,
  actions: uh
}, mh = { block: "■", warn: "▲", info: "●" }, dh = { block: "차단", warn: "경고", info: "정보" };
function mk({ items: e, empty: t = "점검할 항목이 없습니다", openTones: a = ["block"], className: r = "" }) {
  const [s, o] = A({}), [l, c] = A(e);
  return l !== e && (c(e), o({})), e.length ? /* @__PURE__ */ n.createElement("ul", { className: `${qe.list} ${r}` }, e.map((i) => {
    var _;
    const u = !!i.detail || !!i.actions, m = u && ((_ = s[i.key]) != null ? _ : a.includes(i.tone)), f = /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: `${qe.mark} ${qe[i.tone]}`, "aria-label": dh[i.tone], role: "img" }, mh[i.tone]), /* @__PURE__ */ n.createElement("span", { className: qe.msg }, i.message), !!i.count && /* @__PURE__ */ n.createElement("span", { className: `${qe.count} ${qe[i.tone]}` }, i.count.toLocaleString("ko-KR"), "건"), i.aside != null && /* @__PURE__ */ n.createElement("span", { className: qe.aside }, i.aside), u && /* @__PURE__ */ n.createElement("span", { className: qe.caret, "aria-hidden": "true" }, m ? "▾" : "▸"));
    return /* @__PURE__ */ n.createElement("li", { key: i.key, className: `${qe.item} ${qe[`row_${i.tone}`]}` }, u ? /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: qe.head,
        "aria-expanded": m,
        onClick: () => o((p) => ({ ...p, [i.key]: !m }))
      },
      f
    ) : /* @__PURE__ */ n.createElement("div", { className: qe.head }, f), m && /* @__PURE__ */ n.createElement("div", { className: qe.body }, i.detail, i.actions && /* @__PURE__ */ n.createElement("div", { className: qe.actions }, i.actions)));
  })) : /* @__PURE__ */ n.createElement("p", { className: `${qe.empty} ${r}` }, t);
}
function fh(e, t) {
  const a = Math.max(1, Math.floor(t) || 1), r = Math.min(a, Math.max(1, Math.floor(e) || 1)), s = (o, l) => Array.from({ length: l - o + 1 }, (c, i) => o + i);
  return a <= 10 ? s(1, a) : r <= 5 ? [...s(1, 7), "…", a] : r >= a - 4 ? [1, "…", ...s(a - 6, a)] : [1, "…", ...s(r - 2, r + 2), "…", a];
}
function _h(e, t) {
  const a = parseInt(e.replace(/[^\d]/g, ""), 10);
  return Number.isFinite(a) ? Math.min(Math.max(1, t), Math.max(1, a)) : null;
}
function dk(e) {
  return e === "page" ? "쪽 합계" : "전체 합계";
}
function fk(e, t) {
  return Math.max(1, Math.ceil(Math.max(0, e) / Math.max(1, t)));
}
const ph = "_nav_1r2z8_1", yh = "_list_1r2z8_3", bh = "_btn_1r2z8_4", Eh = "_cur_1r2z8_13", hh = "_gap_1r2z8_15", gh = "_total_1r2z8_16", vh = "_jump_1r2z8_17", kh = "_go_1r2z8_20", wh = "_size_1r2z8_22", Nh = "_more_1r2z8_24", $h = "_moreBtn_1r2z8_25", xh = "_moreN_1r2z8_29", ge = {
  nav: ph,
  list: yh,
  btn: bh,
  cur: Eh,
  gap: hh,
  total: gh,
  jump: vh,
  in: "_in_1r2z8_18",
  go: kh,
  size: wh,
  more: Nh,
  moreBtn: $h,
  moreN: xh
};
function _k({ page: e, pageCount: t, onPageChange: a, jump: r = !1, pageSizes: s, pageSize: o, onPageSizeChange: l, total: c, className: i = "" }) {
  const u = Math.max(1, t), m = Math.min(u, Math.max(1, e)), [f, _] = A(String(m));
  G(() => _(String(m)), [m]);
  const p = (d) => {
    d !== m && d >= 1 && d <= u && a(d);
  }, y = () => {
    const d = _h(f, u);
    if (d === null) {
      _(String(m));
      return;
    }
    _(String(d)), p(d);
  };
  return /* @__PURE__ */ n.createElement("nav", { className: [ge.nav, i].filter(Boolean).join(" "), "aria-label": "쪽 이동" }, c !== void 0 && /* @__PURE__ */ n.createElement("span", { className: ge.total }, "총 ", c.toLocaleString("ko-KR"), "건"), /* @__PURE__ */ n.createElement("ol", { className: ge.list }, /* @__PURE__ */ n.createElement("li", null, /* @__PURE__ */ n.createElement("button", { type: "button", className: ge.btn, onClick: () => p(1), disabled: m === 1, "aria-label": "첫 쪽" }, "«")), /* @__PURE__ */ n.createElement("li", null, /* @__PURE__ */ n.createElement("button", { type: "button", className: ge.btn, onClick: () => p(m - 1), disabled: m === 1, "aria-label": "이전 쪽" }, "‹")), fh(m, u).map((d, b) => d === "…" ? /* @__PURE__ */ n.createElement("li", { key: `e${b}`, className: ge.gap, "aria-hidden": "true" }, "…") : /* @__PURE__ */ n.createElement("li", { key: d }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: [ge.btn, d === m ? ge.cur : ""].filter(Boolean).join(" "),
      onClick: () => p(d),
      "aria-current": d === m ? "page" : void 0,
      "aria-label": `${d}쪽`
    },
    d
  ))), /* @__PURE__ */ n.createElement("li", null, /* @__PURE__ */ n.createElement("button", { type: "button", className: ge.btn, onClick: () => p(m + 1), disabled: m === u, "aria-label": "다음 쪽" }, "›")), /* @__PURE__ */ n.createElement("li", null, /* @__PURE__ */ n.createElement("button", { type: "button", className: ge.btn, onClick: () => p(u), disabled: m === u, "aria-label": "마지막 쪽" }, "»"))), /* @__PURE__ */ n.createElement("span", { className: ge.total }, "전체 ", u, "쪽"), r && /* @__PURE__ */ n.createElement("span", { className: ge.jump }, /* @__PURE__ */ n.createElement(
    "input",
    {
      className: ge.in,
      inputMode: "numeric",
      value: f,
      "aria-label": "이동할 쪽 번호",
      onChange: (d) => _(d.target.value.replace(/[^\d]/g, "")),
      onKeyDown: (d) => {
        d.key === "Enter" && (d.preventDefault(), y());
      }
    }
  ), /* @__PURE__ */ n.createElement("button", { type: "button", className: ge.go, onClick: y }, "이동")), s && o !== void 0 && l && /* @__PURE__ */ n.createElement("label", { className: ge.size }, "쪽당", /* @__PURE__ */ n.createElement("select", { value: o, onChange: (d) => l(Number(d.target.value)) }, s.map((d) => /* @__PURE__ */ n.createElement("option", { key: d, value: d }, d, "건")))));
}
function pk({ shown: e, total: t, onMore: a, busy: r = !1, className: s = "" }) {
  return e >= t ? null : /* @__PURE__ */ n.createElement("div", { className: [ge.more, s].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("button", { type: "button", className: ge.moreBtn, onClick: a, disabled: r, "aria-busy": r }, "더보기 ", /* @__PURE__ */ n.createElement("span", { className: ge.moreN }, "(", e.toLocaleString("ko-KR"), "/", t.toLocaleString("ko-KR"), ")")));
}
const Dh = "_ol_fbatg_1", Ah = "_li_fbatg_2", Ch = "_done_fbatg_5", Sh = "_now_fbatg_5", Mh = "_item_fbatg_6", Th = "_dot_fbatg_12", qh = "_label_fbatg_19", Bh = "_opt_fbatg_21", Lh = "_sr_fbatg_22", lt = {
  ol: Dh,
  li: Ah,
  done: Ch,
  now: Sh,
  item: Mh,
  dot: Th,
  label: qh,
  opt: Bh,
  sr: Lh
};
function yk({ steps: e, current: t, onStepClick: a, className: r = "" }) {
  return /* @__PURE__ */ n.createElement("ol", { className: [lt.ol, r].filter(Boolean).join(" "), "aria-label": `${e.length}단계 중 ${Math.min(t + 1, e.length)}단계` }, e.map((s, o) => {
    const l = o < t ? "done" : o === t ? "now" : "todo", c = /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: lt.dot, "aria-hidden": "true" }, l === "done" ? "✓" : o + 1), /* @__PURE__ */ n.createElement("span", { className: lt.label }, s.label, s.optional && /* @__PURE__ */ n.createElement("span", { className: lt.opt }, " (선택)"), l === "done" && /* @__PURE__ */ n.createElement("span", { className: lt.sr }, " 완료"))), i = !!a && o <= t;
    return /* @__PURE__ */ n.createElement("li", { key: s.key, className: [lt.li, lt[l]].join(" "), "aria-current": l === "now" ? "step" : void 0 }, i ? /* @__PURE__ */ n.createElement("button", { type: "button", className: lt.item, onClick: () => a(o, s) }, c) : /* @__PURE__ */ n.createElement("span", { className: lt.item }, c));
  }));
}
const jh = "_root_7y5bc_5", Rh = "_block_7y5bc_6", Ih = "_svg_7y5bc_7", Oh = "_sm_7y5bc_8", Ph = "_md_7y5bc_9", Xh = "_lg_7y5bc_10", zh = "_track_7y5bc_11", Fh = "_bar_7y5bc_12", Hh = "_spin_7y5bc_13", Wh = "_txt_7y5bc_15", gt = {
  root: jh,
  "axe-sp-in": "_axe-sp-in_7y5bc_1",
  block: Rh,
  svg: Ih,
  sm: Oh,
  md: Ph,
  lg: Xh,
  track: zh,
  bar: Fh,
  spin: Hh,
  "axe-sp-rot": "_axe-sp-rot_7y5bc_1",
  txt: Wh,
  "axe-sp-blink": "_axe-sp-blink_7y5bc_1"
};
function bk({ size: e = "md", value: t, label: a = "불러오는 중", delay: r = 300, block: s = !1, className: o = "" }) {
  const l = typeof t == "number", c = l ? Math.min(100, Math.max(0, t)) : 0, i = 15.9155;
  return /* @__PURE__ */ n.createElement(
    "span",
    {
      className: [gt.root, s ? gt.block : "", o].filter(Boolean).join(" "),
      style: { "--sp-delay": `${r}ms` },
      role: "status",
      "aria-live": "polite",
      "aria-busy": "true"
    },
    /* @__PURE__ */ n.createElement("svg", { className: [gt.svg, gt[e], l ? "" : gt.spin].filter(Boolean).join(" "), viewBox: "0 0 36 36", "aria-hidden": "true", focusable: "false" }, /* @__PURE__ */ n.createElement("circle", { className: gt.track, cx: "18", cy: "18", r: i, fill: "none" }), /* @__PURE__ */ n.createElement(
      "circle",
      {
        className: gt.bar,
        cx: "18",
        cy: "18",
        r: i,
        fill: "none",
        strokeDasharray: l ? `${c} ${100 - c}` : "25 75",
        transform: "rotate(-90 18 18)"
      }
    )),
    /* @__PURE__ */ n.createElement("span", { className: gt.txt }, a, l ? ` ${Math.round(c)}%` : "")
  );
}
const Kh = "_group_xpsei_1", Uh = "_legend_xpsei_2", Gh = "_req_xpsei_3", Yh = "_opts_xpsei_4", Vh = "_inline_xpsei_5", Qh = "_all_xpsei_6", Jh = "_opt_xpsei_4", Zh = "_dis_xpsei_11", eg = "_radio_xpsei_12", tg = "_check_xpsei_12", ng = "_text_xpsei_14", ag = "_hint_xpsei_15", rg = "_err_xpsei_16", _e = {
  group: Kh,
  legend: Uh,
  req: Gh,
  opts: Yh,
  inline: Vh,
  all: Qh,
  opt: Jh,
  dis: Zh,
  radio: eg,
  check: tg,
  text: ng,
  hint: ag,
  err: rg
};
function Ur({ legend: e, required: t }) {
  return /* @__PURE__ */ n.createElement("legend", { className: _e.legend }, e, t && /* @__PURE__ */ n.createElement("span", { className: _e.req }, " (필수)"));
}
function Ek({ name: e, legend: t, options: a, value: r, onChange: s, required: o, disabled: l, error: c, inline: i = !1, className: u = "" }) {
  const m = Gt("axe-rg-err");
  return /* @__PURE__ */ n.createElement(
    "fieldset",
    {
      className: [_e.group, u].filter(Boolean).join(" "),
      disabled: l,
      "aria-describedby": c ? m : void 0,
      "aria-invalid": c ? !0 : void 0
    },
    /* @__PURE__ */ n.createElement(Ur, { legend: t, required: o }),
    /* @__PURE__ */ n.createElement("div", { className: [_e.opts, i ? _e.inline : ""].filter(Boolean).join(" "), role: "radiogroup" }, a.map((f) => /* @__PURE__ */ n.createElement("label", { key: f.value, className: [_e.opt, f.disabled ? _e.dis : ""].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(
      "input",
      {
        type: "radio",
        className: _e.radio,
        name: e,
        value: f.value,
        checked: r === f.value,
        disabled: f.disabled,
        required: o,
        onChange: () => s(f.value)
      }
    ), /* @__PURE__ */ n.createElement("span", { className: _e.text }, f.label, f.hint && /* @__PURE__ */ n.createElement("span", { className: _e.hint }, f.hint))))),
    c && /* @__PURE__ */ n.createElement("p", { id: m, className: _e.err }, c)
  );
}
function cr({ checked: e, indeterminate: t = !1, onChange: a, disabled: r, children: s, className: o = "" }) {
  return /* @__PURE__ */ n.createElement("label", { className: [_e.opt, r ? _e.dis : "", o].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(
    "input",
    {
      type: "checkbox",
      className: _e.check,
      checked: e,
      disabled: r,
      ref: (l) => {
        l && (l.indeterminate = t && !e);
      },
      onChange: (l) => a(l.target.checked)
    }
  ), s !== void 0 && /* @__PURE__ */ n.createElement("span", { className: _e.text }, s));
}
function hk({ legend: e, options: t, value: a, onChange: r, required: s, disabled: o, error: l, inline: c = !1, selectAll: i, className: u = "" }) {
  const m = Gt("axe-cg-err"), f = t.filter((d) => !d.disabled).map((d) => d.value), _ = f.length > 0 && f.every((d) => a.includes(d)), p = f.some((d) => a.includes(d)), y = (d, b) => r(b ? [...a, d] : a.filter((w) => w !== d));
  return /* @__PURE__ */ n.createElement(
    "fieldset",
    {
      className: [_e.group, u].filter(Boolean).join(" "),
      disabled: o,
      "aria-describedby": l ? m : void 0,
      "aria-invalid": l ? !0 : void 0
    },
    /* @__PURE__ */ n.createElement(Ur, { legend: e, required: s }),
    i && /* @__PURE__ */ n.createElement("div", { className: _e.all }, /* @__PURE__ */ n.createElement(
      cr,
      {
        checked: _,
        indeterminate: p && !_,
        onChange: (d) => r(d ? Array.from(/* @__PURE__ */ new Set([...a, ...f])) : a.filter((b) => !f.includes(b)))
      },
      i
    )),
    /* @__PURE__ */ n.createElement("div", { className: [_e.opts, c ? _e.inline : ""].filter(Boolean).join(" ") }, t.map((d) => /* @__PURE__ */ n.createElement(cr, { key: d.value, checked: a.includes(d.value), disabled: d.disabled, onChange: (b) => y(d.value, b) }, d.label, d.hint && /* @__PURE__ */ n.createElement("span", { className: _e.hint }, d.hint)))),
    l && /* @__PURE__ */ n.createElement("p", { id: m, className: _e.err }, l)
  );
}
const sg = "_list_13vw7_1", og = "_tag_13vw7_2", lg = "_main_13vw7_3", cg = "_x_13vw7_6", ig = "_t_muted_13vw7_10", ug = "_t_accent_13vw7_11", mg = "_t_ok_13vw7_12", dg = "_t_warn_13vw7_13", fg = "_t_danger_13vw7_14", _g = "_sel_13vw7_16", Ct = {
  list: sg,
  tag: og,
  main: lg,
  x: cg,
  t_muted: ig,
  t_accent: ug,
  t_ok: mg,
  t_warn: dg,
  t_danger: fg,
  sel: _g
};
function gk({ children: e, tone: t = "muted", selected: a, onClick: r, onRemove: s, removeLabel: o, disabled: l, className: c = "" }) {
  const i = [Ct.tag, Ct[`t_${t}`], a ? Ct.sel : "", c].filter(Boolean).join(" "), u = o != null ? o : typeof e == "string" ? `${e} 삭제` : "태그 삭제";
  return /* @__PURE__ */ n.createElement("span", { className: i }, r ? /* @__PURE__ */ n.createElement("button", { type: "button", className: Ct.main, onClick: r, disabled: l, "aria-pressed": a }, a && /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true" }, "✓ "), e) : /* @__PURE__ */ n.createElement("span", { className: Ct.main }, e), s && /* @__PURE__ */ n.createElement("button", { type: "button", className: Ct.x, onClick: s, disabled: l, "aria-label": u }, "✕"));
}
function vk({ label: e, children: t, className: a = "" }) {
  return /* @__PURE__ */ n.createElement("ul", { className: [Ct.list, a].filter(Boolean).join(" "), "aria-label": e }, (Array.isArray(t) ? t : [t]).filter(Boolean).map((r, s) => /* @__PURE__ */ n.createElement("li", { key: s }, r)));
}
const pg = "_acc_1lmty_1", yg = "_item_1lmty_2", bg = "_h_1lmty_3", Eg = "_btn_1lmty_4", hg = "_title_1lmty_8", gg = "_meta_1lmty_9", vg = "_chev_1lmty_10", kg = "_open_1lmty_11", wg = "_body_1lmty_12", ct = {
  acc: pg,
  item: yg,
  h: bg,
  btn: Eg,
  title: hg,
  meta: gg,
  chev: vg,
  open: kg,
  body: wg
};
function kk({ items: e, single: t = !1, defaultOpen: a = [], openKeys: r, onOpenChange: s, headingLevel: o = 3, className: l = "" }) {
  const [c, i] = A(a), u = r != null ? r : c, m = Gt("axe-acc"), f = `h${o}`, _ = (p) => {
    const y = u.includes(p) ? u.filter((d) => d !== p) : t ? [p] : [...u, p];
    r === void 0 && i(y), s == null || s(y);
  };
  return /* @__PURE__ */ n.createElement("div", { className: [ct.acc, l].filter(Boolean).join(" ") }, e.map((p) => {
    const y = u.includes(p.key), d = `${m}-b-${p.key}`, b = `${m}-p-${p.key}`;
    return /* @__PURE__ */ n.createElement("div", { key: p.key, className: [ct.item, y ? ct.open : ""].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(f, { className: ct.h }, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        id: d,
        className: ct.btn,
        "aria-expanded": y,
        "aria-controls": b,
        disabled: p.disabled,
        onClick: () => _(p.key)
      },
      /* @__PURE__ */ n.createElement("span", { className: ct.title }, p.title),
      p.meta && /* @__PURE__ */ n.createElement("span", { className: ct.meta }, p.meta),
      /* @__PURE__ */ n.createElement("span", { className: ct.chev, "aria-hidden": "true" }, "▾")
    )), /* @__PURE__ */ n.createElement("div", { id: b, role: "region", "aria-labelledby": d, hidden: !y, className: ct.body }, p.content));
  }));
}
const Ng = "_stack_1u83j_2", $g = "_toast_1u83j_3", xg = "_t_danger_1u83j_9", Dg = "_ico_1u83j_10", Ag = "_t_ok_1u83j_11", Cg = "_msg_1u83j_12", Sg = "_act_1u83j_13", Mg = "_x_1u83j_15", St = {
  stack: Ng,
  toast: $g,
  "axe-toast-in": "_axe-toast-in_1u83j_1",
  t_danger: xg,
  ico: Dg,
  t_ok: Ag,
  msg: Cg,
  act: Sg,
  x: Mg
}, Gr = qn(null);
let Tg = 0;
function wk() {
  const e = Tn(Gr);
  if (!e) throw new Error("useAXErpToast 는 AXErpToastProvider 안에서만 쓴다");
  return e;
}
function qg({ item: e, onClose: t }) {
  var l, c;
  const [a, r] = A(!1), s = (l = e.duration) != null ? l : e.action ? 8e3 : 4e3;
  G(() => {
    if (a || s === 0) return;
    const i = window.setTimeout(t, s);
    return () => window.clearTimeout(i);
  }, [a, s, t, e.message]);
  const o = (c = e.tone) != null ? c : "info";
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [St.toast, St[`t_${o}`]].join(" "),
      role: o === "danger" ? "alert" : void 0,
      onMouseEnter: () => r(!0),
      onMouseLeave: () => r(!1),
      onFocus: () => r(!0),
      onBlur: () => r(!1)
    },
    /* @__PURE__ */ n.createElement("span", { className: St.ico, "aria-hidden": "true" }, o === "ok" ? "✓" : o === "danger" ? "▲" : "ⓘ"),
    /* @__PURE__ */ n.createElement("span", { className: St.msg }, e.message),
    e.action && /* @__PURE__ */ n.createElement("button", { type: "button", className: St.act, onClick: () => {
      e.action.onAction(), t();
    } }, e.action.label),
    /* @__PURE__ */ n.createElement("button", { type: "button", className: St.x, onClick: t, "aria-label": "알림 닫기" }, "✕")
  );
}
function Nk({ children: e }) {
  const [t, a] = A([]), r = B(t);
  r.current = t;
  const s = oe((c) => a((i) => i.filter((u) => u.id !== c)), []), o = oe((c) => {
    const i = typeof c == "string" ? { message: c } : c, u = r.current.find((f) => f.message === i.message);
    if (u)
      return a((f) => f.map((_) => _.id === u.id ? { ..._, ...i } : _)), u.id;
    const m = ++Tg;
    return a((f) => [...f, { ...i, id: m }].slice(-3)), m;
  }, []), l = we(() => ({ toast: o, dismiss: s }), [o, s]);
  return /* @__PURE__ */ n.createElement(Gr.Provider, { value: l }, e, /* @__PURE__ */ n.createElement("div", { className: St.stack, role: "status", "aria-live": "polite", "aria-atomic": "false" }, t.map((c) => /* @__PURE__ */ n.createElement(qg, { key: c.id, item: c, onClose: () => s(c.id) }))));
}
const Bg = [
  {
    title: "공통",
    items: [
      { keys: ["?"], text: "단축키 도움말 열기 (입력 칸 밖에서)" },
      { keys: ["Tab", "Shift+Tab"], text: "다음·이전 입력 칸 / 버튼으로 이동" },
      { keys: ["Esc"], text: "열린 달력·메뉴·대화상자 닫기, 입력 중이던 값 취소" },
      { keys: ["Ctrl+Enter"], text: "저장 (저장 버튼 옆에 표기된 화면)" }
    ]
  },
  {
    title: "날짜 입력 칸",
    items: [
      { keys: ["숫자만"], text: "20260930 · 260930 · 0930 처럼 구분 기호 없이 입력" },
      { keys: ["↑", "↓"], text: "하루 뒤·앞 (월 입력은 한 달)" },
      { keys: ["PageUp", "PageDown"], text: "한 달 앞·뒤 (월 입력은 한 해)" },
      { keys: ["T"], text: "오늘" },
      { keys: ["F2", "F4", "Alt+↓"], text: "달력 열기" }
    ]
  },
  {
    title: "코드 입력 칸",
    items: [
      { keys: ["코드·명칭 입력"], text: "입력하는 동안 후보 표시" },
      { keys: ["↑", "↓"], text: "후보 선택" },
      { keys: ["Enter"], text: "선택한 후보 확정" },
      { keys: ["F2"], text: "전체 검색 창 열기" }
    ]
  },
  {
    title: "표 (행·칸 이동)",
    items: [
      { keys: ["←", "→", "↑", "↓"], text: "칸 이동" },
      { keys: ["Home", "End"], text: "줄의 처음·끝 칸" },
      { keys: ["Ctrl+Home", "Ctrl+End"], text: "표의 처음·끝 칸" },
      { keys: ["Enter", "Space"], text: "행 열기 (행 클릭이 되는 표)" }
    ]
  },
  {
    title: "달력 (달력에 포커스가 있을 때)",
    items: [
      { keys: ["T"], text: "오늘로" },
      { keys: ["N", "PageDown"], text: "다음 기간" },
      { keys: ["P", "PageUp"], text: "이전 기간" },
      { keys: ["M", "W", "D", "A"], text: "월 · 주 · 일 · 목록 보기" },
      { keys: ["C"], text: "일정 추가" }
    ]
  },
  {
    title: "간트 · 칸반 (막대·카드에 포커스)",
    items: [
      { keys: ["←", "→"], text: "간트: 막대 옮기기" },
      { keys: ["Shift+←", "Shift+→"], text: "간트: 끝 날짜 조절" },
      { keys: ["Alt+←", "Alt+→"], text: "간트: 시작 날짜 조절 / 칸반: 옆 열로 옮기기" },
      { keys: ["Enter"], text: "열기" }
    ]
  },
  {
    title: "메뉴",
    items: [
      { keys: ["↓"], text: "메뉴 열기 · 다음 항목" },
      { keys: ["↑", "Home", "End"], text: "이전 · 처음 · 마지막 항목" },
      { keys: ["Esc"], text: "닫고 버튼으로 돌아가기" }
    ]
  }
];
function Lg(e, t, a) {
  return a || t.ctrl || t.alt || t.meta ? !1 : e === "?";
}
const jg = "_grid_yplhe_1", Rg = "_group_yplhe_2", Ig = "_h_yplhe_3", Og = "_list_yplhe_4", Pg = "_row_yplhe_5", Xg = "_keys_yplhe_6", zg = "_text_yplhe_7", Fg = "_or_yplhe_8", Hg = "_kbd_yplhe_9", it = {
  grid: jg,
  group: Rg,
  h: Ig,
  list: Og,
  row: Pg,
  keys: Xg,
  text: zg,
  or: Fg,
  kbd: Hg
};
function Wg({ onClose: e, extra: t }) {
  const a = [...t != null ? t : [], ...Bg];
  return /* @__PURE__ */ n.createElement(On, { title: "단축키", onClose: e, closeOnEsc: !0, confirmDiscard: !1, wide: !0 }, /* @__PURE__ */ n.createElement("div", { className: it.grid }, a.map((r) => /* @__PURE__ */ n.createElement("section", { key: r.title, className: it.group }, /* @__PURE__ */ n.createElement("h3", { className: it.h }, r.title), /* @__PURE__ */ n.createElement("dl", { className: it.list }, r.items.map((s, o) => /* @__PURE__ */ n.createElement("div", { key: o, className: it.row }, /* @__PURE__ */ n.createElement("dt", { className: it.keys }, s.keys.map((l, c) => /* @__PURE__ */ n.createElement("span", { key: l }, c > 0 && /* @__PURE__ */ n.createElement("span", { className: it.or }, " 또는 "), /* @__PURE__ */ n.createElement("kbd", { className: it.kbd }, l)))), /* @__PURE__ */ n.createElement("dd", { className: it.text }, s.text))))))));
}
function Kg(e) {
  const t = e;
  return !t || typeof t.closest != "function" ? !1 : !!t.closest('input, textarea, select, [contenteditable="true"], [role="combobox"], [role="textbox"]');
}
function $k(e = {}) {
  const { enabled: t = !0, extra: a } = e, [r, s] = A(!1);
  return G(() => {
    if (!t) return;
    const o = (l) => {
      Lg(l.key, { ctrl: l.ctrlKey, alt: l.altKey, meta: l.metaKey }, Kg(l.target)) && (document.querySelector('[role="dialog"][aria-modal="true"]') || (l.preventDefault(), s(!0)));
    };
    return document.addEventListener("keydown", o), () => document.removeEventListener("keydown", o);
  }, [t]), { open: () => s(!0), dialog: r ? /* @__PURE__ */ n.createElement(Wg, { extra: a, onClose: () => s(!1) }) : null };
}
const ir = 30, Ug = BigInt(10);
function Kt(e) {
  let t = BigInt(1);
  for (let a = 0; a < e; a += 1) t = t * Ug;
  return t;
}
function dt(e, t = 0) {
  return { u: e, s: t };
}
const Yr = dt(BigInt(0));
function Vr(e, t) {
  if (e.s === t.s) return [e.u, t.u, e.s];
  const a = Math.max(e.s, t.s);
  return [e.u * Kt(a - e.s), t.u * Kt(a - t.s), a];
}
function _n(e, t) {
  const [a, r, s] = Vr(e, t);
  return dt(a + r, s);
}
function ga(e, t) {
  const [a, r, s] = Vr(e, t);
  return dt(a - r, s);
}
function nt(e, t) {
  return dt(e.u * t.u, e.s + t.s);
}
function Lt(e, t) {
  if (t.u === BigInt(0)) return null;
  const a = e.u * Kt(t.s + ir), r = t.u * Kt(e.s);
  return dt(a / r, ir);
}
function Qr(e) {
  return dt(-e.u, e.s);
}
function ft(e, t, a) {
  if (t >= e.s)
    return dt(e.u * Kt(t - e.s), t);
  const r = Kt(e.s - t), s = e.u < BigInt(0), o = s ? -e.u : e.u, l = o / r, c = o % r;
  let i;
  return c === BigInt(0) || a === "down" ? i = l : a === "up" ? i = l + BigInt(1) : i = c * BigInt(2) >= r ? l + BigInt(1) : l, dt(s ? -i : i, t);
}
function be(e) {
  const t = e.trim().replace(/,/g, "");
  if (!/^[+-]?(\d+(\.\d*)?|\.\d+)$/.test(t)) return null;
  const a = t.startsWith("-"), r = t.replace(/^[+-]/, ""), s = r.indexOf("."), o = s < 0 ? r : r.slice(0, s) + r.slice(s + 1), l = s < 0 ? 0 : r.length - s - 1, c = BigInt(o === "" ? "0" : o);
  return dt(a ? -c : c, l);
}
function va(e) {
  var a;
  const t = be(String(e));
  return t || ((a = be(e.toFixed(20))) != null ? a : Yr);
}
function Ue(e, t = e.s, a = !1) {
  const r = ft(e, Math.max(t, 0), "half"), s = r.u < BigInt(0), o = (s ? -r.u : r.u).toString().padStart(t + 1, "0"), l = o.length - t;
  let c = o.slice(0, l);
  const i = o.slice(l);
  return a && (c = c.replace(/\B(?=(\d{3})+(?!\d))/g, ",")), (s ? "-" : "") + c + (t > 0 ? "." + i : "");
}
function ia(e) {
  const t = /^(\d{4})-(\d{2})-(\d{2})$/.exec(e.trim());
  if (!t) return null;
  const a = Number(t[1]), r = Number(t[2]), s = Number(t[3]);
  return r < 1 || r > 12 || s < 1 || s > Le(a, r) ? null : { y: a, m: r, d: s };
}
function zt({ y: e, m: t, d: a }) {
  const r = Math.floor((14 - t) / 12), s = e + 4800 - r, o = t + 12 * r - 3;
  return a + Math.floor((153 * o + 2) / 5) + 365 * s + Math.floor(s / 4) - Math.floor(s / 100) + Math.floor(s / 400) - 32045;
}
function Jr(e, t) {
  const a = zt(e) + t + 32044, r = Math.floor((4 * a + 3) / 146097), s = a - Math.floor(146097 * r / 4), o = Math.floor((4 * s + 3) / 1461), l = s - Math.floor(1461 * o / 4), c = Math.floor((5 * l + 2) / 153);
  return {
    d: l - Math.floor((153 * c + 2) / 5) + 1,
    m: c + 3 - 12 * Math.floor(c / 10),
    y: 100 * r + o - 4800 + Math.floor(c / 10)
  };
}
function Zr(e, t, a = "exclude-first") {
  const r = zt(e) > zt(t), s = r ? t : e, o = r ? e : t, l = a === "include-first", c = zt(o) - zt(s) + (l ? 1 : 0), i = l ? Jr(o, 1) : o;
  let u = i.y - s.y, m = i.m - s.m, f = i.d - s.d;
  if (f < 0) {
    m -= 1;
    const _ = i.m === 1 ? 12 : i.m - 1, p = i.m === 1 ? i.y - 1 : i.y;
    f += Le(p, _);
  }
  return m < 0 && (u -= 1, m += 12), { days: c, y: u, m, d: f, swapped: r };
}
function Mn(e, t) {
  return Jr(e, t);
}
function ur(e, t) {
  const a = e.y * 12 + (e.m - 1) + t, r = Math.floor(a / 12), s = a % 12 + 1;
  return { y: r, m: s, d: Math.min(e.d, Le(r, s)) };
}
const Gg = ["월", "화", "수", "목", "금", "토", "일"];
function ua(e) {
  return Gg[zt(e) % 7];
}
function ze(e) {
  return `${e.y}-${String(e.m).padStart(2, "0")}-${String(e.d).padStart(2, "0")}`;
}
const an = [
  { code: "KRW", label: "원", per: 1, krw: "1" },
  { code: "JPY", label: "엔", per: 100, krw: "941.20" },
  { code: "USD", label: "달러", per: 1, krw: "1386.50" },
  { code: "EUR", label: "유로", per: 1, krw: "1501.30" },
  { code: "CNY", label: "위안", per: 1, krw: "190.40" },
  { code: "GBP", label: "파운드", per: 1, krw: "1752.80" }
], ea = {
  원: "KRW",
  엔: "JPY",
  달러: "USD",
  불: "USD",
  유로: "EUR",
  위안: "CNY",
  파운드: "GBP"
};
function mr(e) {
  var t;
  return (t = ea[e]) != null ? t : e in ea ? ea[e] : null;
}
function ma(e, t) {
  return e.find((a) => a.code === t);
}
function es(e) {
  return e.code === "KRW" ? "KRW 기준" : `${e.code} ${e.per} = ${e.krw}원`;
}
function ts(e, t, a, r) {
  const s = ma(e, a), o = ma(e, r);
  if (!s || !o) return null;
  const l = be(s.krw), c = be(o.krw), i = be(String(s.per)), u = be(String(o.per));
  if (!l || !c || !i || !u) return null;
  const m = Lt(nt(t, l), i);
  if (!m) return null;
  const f = Lt(nt(m, u), c);
  return f ? {
    value: ft(f, 2, "half"),
    notice: `${es(s)} · 참고용 환율`
  } : null;
}
function Yg(e, t) {
  let a = null;
  for (const s of e)
    if (s.value) {
      if (a === null) {
        a = s.sign === "-" ? Qr(s.value) : s.value;
        continue;
      }
      switch (s.sign) {
        case "+":
          a = _n(a, s.value);
          break;
        case "-":
          a = ga(a, s.value);
          break;
        case "*":
          a = nt(a, s.value);
          break;
        default: {
          const o = Lt(a, s.value);
          if (!o) return { ok: !1, error: "divide-by-zero" };
          a = o;
          break;
        }
      }
    }
  const r = a != null ? a : Yr;
  return { ok: !0, value: t ? ft(r, t.digits, t.mode) : r };
}
const dr = [
  { key: "+", label: "+", hot: "A" },
  { key: "-", label: "−", hot: "S" },
  { key: "*", label: "×", hot: "D" },
  { key: "/", label: "÷", hot: "F" }
];
function on() {
  return { sign: "+", text: "" };
}
function Vg(e) {
  const t = e.replace(/[^\d.-]/g, ""), a = t.startsWith("-"), r = t.replace(/-/g, ""), s = r.indexOf("."), o = s < 0 ? r : r.slice(0, s), l = s < 0 ? "" : "." + r.slice(s + 1).replace(/\./g, "");
  return (a ? "-" : "") + o.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + l;
}
function Qg(e) {
  return e.map((t) => ({ sign: t.sign, value: be(t.text) }));
}
function Jg(e) {
  const { lines: t, onLines: a, active: r, onActive: s, digits: o, onDigits: l, mode: c, onMode: i } = e, u = B([]), m = Math.min(r, t.length - 1);
  G(() => {
    var g;
    (g = u.current[m]) == null || g.focus();
  }, [m, t.length]);
  const f = Yg(Qg(t), { digits: o, mode: c }), _ = f.ok ? Ue(f.value, o, !0) : "0으로 나눌 수 없음", p = (g, $) => {
    a(t.map((h, v) => v === g ? { ...h, ...$ } : h));
  }, y = (g = t.length, $ = "") => {
    const h = [...t];
    h.splice(g, 0, { ...on(), text: $ }), a(h), s(g);
  }, d = (g) => {
    if (t.length === 1) {
      a([on()]);
      return;
    }
    a(t.filter(($, h) => h !== g)), s(Math.max(0, g - 1));
  }, b = () => {
    f.ok && y(t.length, Ue(f.value, o, !0));
  }, w = (g, $) => {
    const h = g.key, v = Zg(h);
    if (v && !(h === "-" && t[$].text === "")) {
      g.preventDefault(), p($, { sign: v });
      return;
    }
    if (h === "v" || h === "V") {
      g.preventDefault(), b();
      return;
    }
    h === "Enter" ? (g.preventDefault(), $ === t.length - 1 ? y() : s($ + 1)) : h === "ArrowDown" ? (g.preventDefault(), s(Math.min($ + 1, t.length - 1))) : h === "ArrowUp" ? (g.preventDefault(), s(Math.max($ - 1, 0))) : h === "Insert" ? (g.preventDefault(), y($ + 1)) : h === "Delete" && t[$].text === "" ? (g.preventDefault(), d($)) : h === "F4" && (g.preventDefault(), N());
  }, N = () => {
    a([on()]), s(0);
  };
  return /* @__PURE__ */ n.createElement("div", { className: "bical-general" }, /* @__PURE__ */ n.createElement("div", { className: "bical-side" }, /* @__PURE__ */ n.createElement("div", { className: "bical-keys" }, /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-key", onClick: () => y(m + 1) }, "행 추가 (Ins)"), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-key", onClick: () => d(m) }, "행 삭제 (Del)"), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-key", onClick: b }, "현재금액추가 (V)"), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-key", onClick: N }, "초기화 (F4)")), /* @__PURE__ */ n.createElement("div", { className: "bical-sub" }, "부호"), /* @__PURE__ */ n.createElement("div", { className: "bical-keys" }, dr.map((g) => {
    var $;
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: g.key,
        type: "button",
        className: "bical-key",
        "aria-pressed": (($ = t[m]) == null ? void 0 : $.sign) === g.key,
        onClick: () => p(m, { sign: g.key })
      },
      g.label,
      " (",
      g.hot,
      ")"
    );
  })), /* @__PURE__ */ n.createElement("div", { className: "bical-sub" }, "결과값 자리수"), /* @__PURE__ */ n.createElement("select", { "aria-label": "결과값 자리수", className: "bical-select", value: o, onChange: (g) => l(Number(g.target.value)) }, [0, 1, 2, 3, 4].map((g) => /* @__PURE__ */ n.createElement("option", { key: g, value: g }, g))), /* @__PURE__ */ n.createElement("div", { className: "bical-sub" }, "표기방법"), /* @__PURE__ */ n.createElement("select", { "aria-label": "표기방법", className: "bical-select", value: c, onChange: (g) => i(g.target.value) }, /* @__PURE__ */ n.createElement("option", { value: "half" }, "반올림"), /* @__PURE__ */ n.createElement("option", { value: "up" }, "올림"), /* @__PURE__ */ n.createElement("option", { value: "down" }, "버림"))), /* @__PURE__ */ n.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ n.createElement("div", { className: "bical-grid" }, t.map((g, $) => {
    var h;
    return /* @__PURE__ */ n.createElement("div", { key: $, className: `bical-line${$ === m ? " bical-line--active" : ""}` }, /* @__PURE__ */ n.createElement("span", { className: "bical-caret" }, $ === m ? "❯" : ""), /* @__PURE__ */ n.createElement("span", { className: "bical-sign" }, (h = dr.find((v) => v.key === g.sign)) == null ? void 0 : h.label), /* @__PURE__ */ n.createElement(
      "input",
      {
        ref: (v) => {
          u.current[$] = v;
        },
        value: g.text,
        inputMode: "decimal",
        "aria-label": `${$ + 1}번째 금액`,
        onFocus: () => s($),
        onChange: (v) => p($, { text: Vg(v.target.value) }),
        onKeyDown: (v) => w(v, $)
      }
    ));
  })), /* @__PURE__ */ n.createElement("div", { className: `bical-result${f.ok ? "" : " bical-error"}` }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, "결과값 · 좌→우 순차 계산(연산자 우선순위 없음)"), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, _))));
}
function Zg(e) {
  const t = e.toLowerCase();
  return t === "a" || e === "+" ? "+" : t === "s" || e === "-" ? "-" : t === "d" || e === "*" ? "*" : t === "f" || e === "/" ? "/" : null;
}
function ev(e) {
  const t = [];
  let a = 0;
  for (; a < e.length; ) {
    const r = e[a];
    if (r === " " || r === "	" || r === `
`)
      a += 1;
    else if (r >= "0" && r <= "9" || r === "." || r === ",") {
      let s = a;
      for (; s < e.length && (e[s] >= "0" && e[s] <= "9" || e[s] === "." || e[s] === ","); ) s += 1;
      const o = be(e.slice(a, s));
      if (!o) return null;
      t.push({ t: "num", v: o }), a = s;
    } else if (r === "+" || r === "-" || r === "*" || r === "/")
      t.push({ t: "op", v: r }), a += 1;
    else if (r === "(")
      t.push({ t: "(" }), a += 1;
    else if (r === ")")
      t.push({ t: ")" }), a += 1;
    else
      return null;
  }
  return t;
}
class tv {
  constructor(t) {
    this.tokens = t, this.at = 0;
  }
  parse() {
    const t = this.expr();
    return t.ok && this.at !== this.tokens.length ? { ok: !1, error: "syntax" } : t;
  }
  peek() {
    return this.tokens[this.at];
  }
  expr() {
    let t = this.term();
    if (!t.ok) return t;
    for (; ; ) {
      const a = this.peek();
      if (!a || a.t !== "op" || a.v !== "+" && a.v !== "-") return t;
      this.at += 1;
      const r = this.term();
      if (!r.ok) return r;
      t = { ok: !0, value: a.v === "+" ? _n(t.value, r.value) : ga(t.value, r.value) };
    }
  }
  term() {
    let t = this.unary();
    if (!t.ok) return t;
    for (; ; ) {
      const a = this.peek();
      if (!a || a.t !== "op" || a.v !== "*" && a.v !== "/") return t;
      this.at += 1;
      const r = this.unary();
      if (!r.ok) return r;
      if (a.v === "*")
        t = { ok: !0, value: nt(t.value, r.value) };
      else {
        const s = Lt(t.value, r.value);
        if (!s) return { ok: !1, error: "divide-by-zero" };
        t = { ok: !0, value: s };
      }
    }
  }
  unary() {
    const t = this.peek();
    if (t && t.t === "op" && (t.v === "+" || t.v === "-")) {
      this.at += 1;
      const a = this.unary();
      return a.ok ? { ok: !0, value: t.v === "-" ? Qr(a.value) : a.value } : a;
    }
    return this.primary();
  }
  primary() {
    const t = this.peek();
    if (!t) return { ok: !1, error: "syntax" };
    if (t.t === "num")
      return this.at += 1, { ok: !0, value: t.v };
    if (t.t === "(") {
      this.at += 1;
      const a = this.expr();
      if (!a.ok) return a;
      const r = this.peek();
      return !r || r.t !== ")" ? { ok: !1, error: "syntax" } : (this.at += 1, a);
    }
    return { ok: !1, error: "syntax" };
  }
}
function nv(e) {
  const t = ev(e);
  return !t || t.length === 0 ? { ok: !1, error: "syntax" } : new tv(t).parse();
}
const ln = [
  "산술식 — 1,200만 + 350만 × 2",
  "비율 — 3,000,000의 15%",
  "기간 — 2026-01-01부터 2026-03-31까지 며칠",
  "날짜 가감 — 2026-07-17부터 90일 후",
  "환율 — 150만엔을 원화로 (참고용 환율)"
], av = /(\d{4})\s*[.\-/년]\s*(\d{1,2})\s*[.\-/월]\s*(\d{1,2})\s*일?/g;
function rv(e, t) {
  return e.replace(/오늘/g, ze(t)).replace(/내일/g, ze(Mn(t, 1))).replace(/어제/g, ze(Mn(t, -1)));
}
function sv(e) {
  const t = [];
  for (const a of e.matchAll(av)) {
    const r = ia(`${a[1]}-${a[2].padStart(2, "0")}-${a[3].padStart(2, "0")}`);
    r && t.push(r);
  }
  return t;
}
const ov = /부터|까지|에서|일수|며칠|기간|차이|~/;
function lv(e, t) {
  if (t.length < 2 || !ov.test(e)) return null;
  const a = /초일\s*산입|양편넣기/.test(e), r = Zr(t[0], t[1], a ? "include-first" : "exclude-first"), s = a ? "초일산입 말일산입" : "초일불산입 말일산입";
  return {
    ok: !0,
    explain: `${ze(t[0])} ~ ${ze(t[1])} 기간(${s})` + (r.swapped ? " · 역순 입력" : ""),
    value: `${r.days}일 (${r.y}년 ${r.m}개월 ${r.d}일)`
  };
}
const cv = /(\d+)\s*(일|주|개월|달|년)\s*(후|뒤|이후|전|이전)/;
function iv(e, t) {
  if (t.length !== 1) return null;
  const a = cv.exec(e);
  if (!a) return null;
  const r = Number(a[1]), s = a[3] === "전" || a[3] === "이전", o = s ? -r : r, l = t[0];
  let c;
  return a[2] === "일" ? c = Mn(l, o) : a[2] === "주" ? c = Mn(l, o * 7) : a[2] === "년" ? c = ur(l, o * 12) : c = ur(l, o), {
    ok: !0,
    explain: `${ze(l)} 에서 ${r}${a[2]} ${s ? "전" : "후"}`,
    value: `${ze(c)} (${ua(c)})`
  };
}
function uv(e, t) {
  if (t.length === 0) return null;
  const a = /([\d,]+(?:\.\d+)?)\s*(억|천만|백만|십만|만|천)?\s*(엔|달러|불|유로|위안|파운드|원)/.exec(e);
  if (!a) return null;
  const r = a[2] ? ns(a[2]) : null, s = be(a[1]);
  if (!s) return null;
  const o = r ? nt(s, r) : s, l = mr(a[3]);
  if (!l) return null;
  const i = l !== "KRW" ? "KRW" : mr(mv(e));
  if (!i || i === l) return null;
  const u = ts(t, o, l, i);
  return u ? {
    ok: !0,
    explain: `${Ue(o, o.s, !0)} ${l} → ${i} · ${u.notice}`,
    value: `${Ue(u.value, 2, !0)} ${i}`
  } : null;
}
function mv(e) {
  const t = /(?:을|를|으로|로)\s*(엔|달러|불|유로|위안|파운드|원)/.exec(e);
  return t ? t[1] : "원";
}
const dv = {
  억: "100000000",
  천만: "10000000",
  백만: "1000000",
  십만: "100000",
  만: "10000",
  천: "1000",
  백: "100"
};
function ns(e) {
  var t;
  return (t = be(dv[e])) != null ? t : va(1);
}
const fv = /((?:[\d,]+(?:\.\d+)?\s*(?:억|천만|백만|십만|만|천|백)\s*)+(?:[\d,]+(?:\.\d+)?)?)/g, _v = /([\d,]+(?:\.\d+)?)\s*(억|천만|백만|십만|만|천|백)?/g;
function pv(e) {
  return e.replace(fv, (t) => {
    let a = be("0"), r = !1;
    for (const s of t.matchAll(_v)) {
      const o = be(s[1]);
      o && (r = !0, a = _n(a, s[2] ? nt(o, ns(s[2])) : o));
    }
    return r ? Ue(a, a.s) : t;
  });
}
const yv = /원화|원|엔|씩|개월|개|명|건/g;
function bv(e) {
  return pv(e).replace(/(\d),(?=\d)/g, "$1").replace(/[×xX]/g, "*").replace(/÷/g, "/").replace(/더하기|플러스/g, "+").replace(/빼기|마이너스/g, "-").replace(/곱하기/g, "*").replace(/나누기/g, "/").replace(yv, "").replace(/([\d.]+)\s*의\s*([\d.]+)\s*%/g, "($1*($2/100))").replace(/([\d.]+)\s*([+-])\s*([\d.]+)\s*%/g, "(($1)*(1$2$3/100))").trim();
}
const Ev = /[+＋]?\s*(부가세|소비세|消費税)\s*(?:([\d.]+)\s*%)?\s*(가산|포함|税込|税抜)?\s*$/;
function hv(e, t, a) {
  const r = be("1"), s = Ue(nt(t, va(100)), 0);
  if (a === "add")
    return {
      value: ft(nt(e, _n(r, t)), 0, "half"),
      explain: `消費税 ${s}% 가산(税抜 기준)`
    };
  const o = Lt(nt(e, t), _n(r, t));
  return {
    value: o ? ft(o, 0, "down") : e,
    explain: `消費税 ${s}% 역산(税込 기준 · 1円 미만 切捨て)`
  };
}
function gv(e, t) {
  var i;
  const a = e.trim();
  if (!a) return { ok: !1, supported: ln };
  const r = rv(a, t.today), s = sv(r), o = lv(r, s);
  if (o) return o;
  const l = iv(r, s);
  if (l) return l;
  const c = uv(r, (i = t.rates) != null ? i : []);
  return c || vv(r, t);
}
function vv(e, t) {
  var u, m;
  const a = Ev.exec(e), r = a ? e.slice(0, a.index) : e, s = bv(r);
  if (!s) return { ok: !1, supported: ln };
  const o = nv(s);
  if (!o.ok)
    return { ok: !1, supported: ln };
  if (!a)
    return { ok: !0, explain: s, value: fr(o.value), expr: s };
  const l = (m = (u = kv(a[2])) != null ? u : t.taxRate) != null ? m : null;
  if (!l)
    return {
      ok: !1,
      supported: ["소비세율을 아직 받지 못했습니다 — 세제개정 기준값을 불러오면 계산합니다", ...ln]
    };
  const c = a[3] === "가산" || a[3] === "税抜" ? "add" : "extract", i = hv(o.value, l, c);
  return {
    ok: !0,
    explain: `${s} · ${i.explain}`,
    value: fr(i.value),
    expr: s
  };
}
function kv(e) {
  var a;
  if (!e) return null;
  const t = be(e);
  return t && (a = Lt(t, va(100))) != null ? a : null;
}
function fr(e) {
  const t = ft(e, 2, "half"), a = ft(t, 0, "down");
  return ga(t, a).u === BigInt(0) ? Ue(t, 0, !0) : Ue(t, 2, !0);
}
const Ke = {
  area: {
    label: "넓이",
    base: "㎡",
    units: [
      { key: "m2", label: "㎡", factor: "1" },
      { key: "are", label: "아르", factor: "100" },
      { key: "ha", label: "헥타르", factor: "10000" },
      { key: "km2", label: "㎢", factor: "1000000" },
      { key: "pyeong", label: "평", factor: "3.305785" },
      { key: "ft2", label: "ft²", factor: "0.09290304" },
      { key: "yd2", label: "yd²", factor: "0.83612736" },
      { key: "acre", label: "에이커", factor: "4046.8564224" }
    ]
  },
  mass: {
    label: "중량·질량",
    base: "g",
    units: [
      { key: "mg", label: "mg", factor: "0.001" },
      { key: "g", label: "g", factor: "1" },
      { key: "kg", label: "kg", factor: "1000" },
      { key: "t", label: "t", factor: "1000000" },
      { key: "don", label: "돈", factor: "3.75" },
      { key: "geun", label: "근", factor: "600" },
      { key: "oz", label: "oz", factor: "28.349523125" },
      { key: "lb", label: "lb", factor: "453.59237" }
    ]
  },
  length: {
    label: "길이",
    base: "m",
    units: [
      { key: "mm", label: "mm", factor: "0.001" },
      { key: "cm", label: "cm", factor: "0.01" },
      { key: "m", label: "m", factor: "1" },
      { key: "km", label: "km", factor: "1000" },
      { key: "in", label: "in", factor: "0.0254" },
      { key: "ft", label: "ft", factor: "0.3048" },
      { key: "yd", label: "yd", factor: "0.9144" },
      { key: "mile", label: "mile", factor: "1609.344" },
      { key: "shaku", label: "자(尺)", factor: "0.30303" }
    ]
  }
};
function _r(e, t) {
  const a = Ke[e].units.find((s) => s.key === t);
  if (!a) return null;
  const r = be(a.factor);
  if (!r) throw new Error("단위 변환 정보를 불러오지 못했습니다");
  return r;
}
function wv(e, t, a, r, s = 4, o = "half") {
  const l = _r(e, t), c = _r(e, a);
  if (!l || !c) return null;
  const i = Lt(nt(r, l), c);
  return i ? ft(i, s, o) : null;
}
const Nv = [0, 1, 2, 3, 4, 6], $v = [
  { key: "text", label: "AI 텍스트계산" },
  { key: "general", label: "일반계산" },
  { key: "date", label: "날짜계산" },
  { key: "unit", label: "단위계산" },
  { key: "fx", label: "환율계산" }
];
function xv(e) {
  const { tab: t, onTab: a, seed: r, onClose: s, history: o, onHistory: l } = e, [c, i] = A(() => r == null ? [on()] : [{ sign: "+", text: Ue(qv(r), 0, !0) }]), [u, m] = A(0), [f, _] = A(0), [p, y] = A("half"), d = B(null);
  G(() => {
    const w = (N) => {
      N.key === "Escape" && (N.preventDefault(), s());
    };
    return document.addEventListener("keydown", w), () => document.removeEventListener("keydown", w);
  }, [s]), G(() => {
    var w, N;
    (N = (w = d.current) == null ? void 0 : w.querySelector("[data-autofocus]")) == null || N.focus();
  }, [t]);
  const b = (w) => {
    const N = [...c.filter((g) => g.text !== ""), { sign: "+", text: w }, on()];
    i(N), m(N.length - 1), a("general");
  };
  return /* @__PURE__ */ n.createElement("div", { className: "bical-overlay", role: "presentation" }, /* @__PURE__ */ n.createElement("div", { className: "bical-modal", role: "dialog", "aria-modal": "true", "aria-label": "계산기", ref: d }, /* @__PURE__ */ n.createElement("div", { className: "bical-head" }, /* @__PURE__ */ n.createElement("span", { className: "bical-title" }, "계산기"), /* @__PURE__ */ n.createElement("span", { className: "bical-hint" }, "장부에 쓰지 않습니다 — 복사·일반계산 추가로만 내보냅니다"), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-x", "aria-label": "닫기", onClick: s }, "✕")), /* @__PURE__ */ n.createElement("div", { className: "bical-tabs", role: "tablist" }, $v.map((w) => /* @__PURE__ */ n.createElement(
    "button",
    {
      key: w.key,
      type: "button",
      role: "tab",
      className: "bical-tab",
      "aria-selected": w.key === t,
      onClick: () => a(w.key)
    },
    w.label
  ))), /* @__PURE__ */ n.createElement("div", { className: "bical-body" }, t === "text" && /* @__PURE__ */ n.createElement(Cv, { history: o, onHistory: l, onPush: b }), t === "general" && /* @__PURE__ */ n.createElement(
    Jg,
    {
      lines: c,
      onLines: i,
      active: u,
      onActive: m,
      digits: f,
      onDigits: _,
      mode: p,
      onMode: y
    }
  ), t === "date" && /* @__PURE__ */ n.createElement(Sv, null), t === "unit" && /* @__PURE__ */ n.createElement(Mv, null), t === "fx" && /* @__PURE__ */ n.createElement(Tv, null)), /* @__PURE__ */ n.createElement("div", { className: "bical-foot" }, /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-btn", onClick: s }, "닫기"))));
}
const Dv = [
  "1,200만 + 350만 × 2",
  "3,000,000의 15%",
  "2026-01-01부터 2026-03-31까지 며칠",
  "2026-07-17부터 90일 후",
  "150만엔을 원화로",
  "오늘부터 10일 후"
], Av = 20;
function Cv({ history: e, onHistory: t, onPush: a }) {
  var y;
  const [r, s] = A(""), [o, l] = A(null), [c, i] = A(!1), [u, m] = A(!1), f = B(!1), _ = we(ka, []), p = (d) => {
    s(d), m(!1);
    const b = gv(d, { today: _, rates: an, taxRate: null });
    l(b), d.trim() && t([d, ...e.filter((w) => w !== d)].slice(0, Av));
  };
  return /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement(
    "textarea",
    {
      className: "bical-textarea",
      "aria-label": "계산할 문장",
      "data-autofocus": !0,
      value: r,
      placeholder: "문장으로 물어보세요 — Enter 계산 · Shift+Enter 줄바꿈",
      onChange: (d) => s(d.target.value),
      onCompositionStart: () => {
        f.current = !0;
      },
      onCompositionEnd: () => {
        f.current = !1;
      },
      onKeyDown: (d) => {
        d.key === "Enter" && !d.shiftKey && !f.current && !d.nativeEvent.isComposing && (d.preventDefault(), p(r));
      }
    }
  ), /* @__PURE__ */ n.createElement("div", { className: "bical-chips" }, Dv.map((d) => /* @__PURE__ */ n.createElement("button", { key: d, type: "button", className: "bical-chip", onClick: () => p(d) }, d))), o && (o.ok ? /* @__PURE__ */ n.createElement("div", { className: "bical-result" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, o.explain), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, o.value), /* @__PURE__ */ n.createElement("div", { className: "bical-chips" }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: "bical-btn",
      onClick: () => {
        var d;
        (d = navigator.clipboard) == null || d.writeText(o.value).then(
          () => m(!0),
          () => m(!1)
        );
      }
    },
    u ? "복사함" : "결과복사"
  ), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-btn", onClick: () => a(o.value) }, "일반계산에 추가"))) : /* @__PURE__ */ n.createElement("div", { className: "bical-result bical-notice" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, "읽지 못했습니다 — 지원하는 형식입니다"), /* @__PURE__ */ n.createElement("ul", { style: { margin: "4px 0 0", paddingLeft: 16 } }, ((y = o.supported) != null ? y : ln).map((d) => /* @__PURE__ */ n.createElement("li", { key: d }, d))))), e.length > 0 && /* @__PURE__ */ n.createElement("div", { className: "bical-log" }, /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => i((d) => !d) }, "기록 ", e.length, "건 ", c ? "접기" : "펼치기"), c && /* @__PURE__ */ n.createElement("ol", null, e.map((d) => /* @__PURE__ */ n.createElement("li", { key: d }, /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => p(d) }, d))))), /* @__PURE__ */ n.createElement("div", { className: "bical-sub", style: { marginTop: 8 } }, "기록은 이 세션에만 남고 저장하지 않습니다."));
}
function Sv() {
  const e = we(ka, []), [t, a] = A(ze(e)), [r, s] = A(ze(e)), [o, l] = A("exclude-first"), c = ia(t), i = ia(r), u = c && i ? Zr(c, i, o) : null;
  return /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "계산 방식"), /* @__PURE__ */ n.createElement("select", { "aria-label": "계산 방식", className: "bical-select", value: o, onChange: (m) => l(m.target.value) }, /* @__PURE__ */ n.createElement("option", { value: "exclude-first" }, "초일불산입 말일산입"), /* @__PURE__ */ n.createElement("option", { value: "include-first" }, "초일산입 말일산입"))), /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "기간"), /* @__PURE__ */ n.createElement("input", { "aria-label": "시작일", className: "bical-input", type: "date", "data-autofocus": !0, value: t, onChange: (m) => a(m.target.value) }), /* @__PURE__ */ n.createElement("span", null, "~"), /* @__PURE__ */ n.createElement("input", { "aria-label": "종료일", className: "bical-input", type: "date", value: r, onChange: (m) => s(m.target.value) })), u ? /* @__PURE__ */ n.createElement("div", { className: "bical-result" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, ze(c), "(", ua(c), ") ~ ", ze(i), "(", ua(i), ")", u.swapped ? " · 역순 입력" : ""), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, u.days.toLocaleString(), "일"), /* @__PURE__ */ n.createElement("div", { className: "bical-sub" }, "차이(년, 월, 일) — ", u.y, "년 ", u.m, "개월 ", u.d, "일")) : /* @__PURE__ */ n.createElement("div", { className: "bical-result bical-notice" }, "날짜를 두 개 모두 입력하세요."));
}
function Mv() {
  const [e, t] = A("area"), [a, r] = A(Ke.area.units[0].key), [s, o] = A(Ke.area.units[4].key), [l, c] = A(""), [i, u] = A(4), [m, f] = A("half"), _ = (d) => {
    t(d), r(Ke[d].units[0].key), o(Ke[d].units[1].key), c("");
  }, p = be(l), y = p ? wv(e, a, s, p, i, m) : null;
  return /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "분류"), /* @__PURE__ */ n.createElement("select", { "aria-label": "분류", className: "bical-select", value: e, onChange: (d) => _(d.target.value) }, Object.keys(Ke).map((d) => /* @__PURE__ */ n.createElement("option", { key: d, value: d }, Ke[d].label))), /* @__PURE__ */ n.createElement("span", { className: "bical-sub" }, "기준 ", Ke[e].base)), /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "값"), /* @__PURE__ */ n.createElement(
    "input",
    {
      className: "bical-input bical-num",
      "aria-label": "값",
      "data-autofocus": !0,
      inputMode: "decimal",
      value: l,
      onChange: (d) => c(d.target.value.replace(/[^\d.-]/g, ""))
    }
  ), /* @__PURE__ */ n.createElement("select", { "aria-label": "변환 전 단위", className: "bical-select", value: a, onChange: (d) => r(d.target.value) }, Ke[e].units.map((d) => /* @__PURE__ */ n.createElement("option", { key: d.key, value: d.key }, d.label))), /* @__PURE__ */ n.createElement("span", null, "→"), /* @__PURE__ */ n.createElement("select", { "aria-label": "변환 후 단위", className: "bical-select", value: s, onChange: (d) => o(d.target.value) }, Ke[e].units.map((d) => /* @__PURE__ */ n.createElement("option", { key: d.key, value: d.key }, d.label)))), /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "자리수"), /* @__PURE__ */ n.createElement("select", { "aria-label": "자리수", className: "bical-select", value: i, onChange: (d) => u(Number(d.target.value)) }, Nv.map((d) => /* @__PURE__ */ n.createElement("option", { key: d, value: d }, d))), /* @__PURE__ */ n.createElement("select", { "aria-label": "표기 방법", className: "bical-select", value: m, onChange: (d) => f(d.target.value) }, /* @__PURE__ */ n.createElement("option", { value: "half" }, "반올림"), /* @__PURE__ */ n.createElement("option", { value: "up" }, "올림"), /* @__PURE__ */ n.createElement("option", { value: "down" }, "버림"))), /* @__PURE__ */ n.createElement("div", { className: "bical-result" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, pr(e, a), " → ", pr(e, s), " · 기준단위 1단계 환산"), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, y ? Ue(y, i, !0) : "—")));
}
function pr(e, t) {
  var a, r;
  return (r = (a = Ke[e].units.find((s) => s.key === t)) == null ? void 0 : a.label) != null ? r : t;
}
function Tv() {
  const e = we(ka, []), [t, a] = A(ze(e)), [r, s] = A("JPY"), [o, l] = A("KRW"), [c, i] = A(""), u = be(c), m = u ? ts(an, u, r, o) : null, f = ma(an, r);
  return /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "기준일자"), /* @__PURE__ */ n.createElement("input", { "aria-label": "기준일자", className: "bical-input", type: "date", value: t, onChange: (_) => a(_.target.value) })), /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "금액"), /* @__PURE__ */ n.createElement(
    "input",
    {
      className: "bical-input bical-num",
      "aria-label": "금액",
      "data-autofocus": !0,
      inputMode: "decimal",
      value: c,
      onChange: (_) => i(_.target.value.replace(/[^\d.-]/g, ""))
    }
  ), /* @__PURE__ */ n.createElement("select", { "aria-label": "변환 전 통화", className: "bical-select", value: r, onChange: (_) => s(_.target.value) }, an.map((_) => /* @__PURE__ */ n.createElement("option", { key: _.code, value: _.code }, _.code, " (", _.label, ")"))), /* @__PURE__ */ n.createElement("span", null, "→"), /* @__PURE__ */ n.createElement("select", { "aria-label": "변환 후 통화", className: "bical-select", value: o, onChange: (_) => l(_.target.value) }, an.map((_) => /* @__PURE__ */ n.createElement("option", { key: _.code, value: _.code }, _.code, " (", _.label, ")")))), /* @__PURE__ */ n.createElement("div", { className: "bical-result" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, f ? es(f) : ""), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, m ? Ue(m.value, 2, !0) : "—")), /* @__PURE__ */ n.createElement("div", { className: "bical-result bical-notice" }, /* @__PURE__ */ n.createElement("b", null, "참고용 환율입니다."), " 토·일·공휴일 데이터가 없고, 기준통화·전신환 구분(TTM/TTS/TTB)도 정해지지 않았습니다. 신고·장부 목적에 쓰지 마세요."));
}
function ka() {
  const e = /* @__PURE__ */ new Date();
  return { y: e.getFullYear(), m: e.getMonth() + 1, d: e.getDate() };
}
function qv(e) {
  var t;
  return ft((t = be(String(e))) != null ? t : be("0"), 0, "half");
}
const as = qn(null);
function xk({ children: e }) {
  const [t, a] = A(!1), [r, s] = A("text"), [o, l] = A(null), [c, i] = A([]), [u, m] = A(0), f = we(() => ({
    open: (_) => {
      var p, y;
      s((p = _ == null ? void 0 : _.tab) != null ? p : "text"), l((y = _ == null ? void 0 : _.seed) != null ? y : null), m((d) => d + 1), a(!0);
    },
    close: () => a(!1)
  }), []);
  return /* @__PURE__ */ n.createElement(as.Provider, { value: f }, e, t && /* @__PURE__ */ n.createElement(
    xv,
    {
      key: u,
      tab: r,
      onTab: s,
      seed: o,
      onClose: f.close,
      history: c,
      onHistory: i
    }
  ));
}
function Dk() {
  var e;
  return (e = Tn(as)) != null ? e : { open: () => {
  }, close: () => {
  } };
}
class Ak extends yr {
  constructor() {
    super(...arguments), this.rootRef = os(), this.resizeSensor = null;
  }
  componentDidMount() {
    this.rootRef.current && (this.resizeSensor = new kr(this.rootRef.current, this.props.onResize));
  }
  componentWillUnmount() {
    this.resizeSensor && (this.resizeSensor.detach(), this.resizeSensor = null);
  }
  render() {
    const { onResize: t, children: a, ...r } = this.props;
    return /* @__PURE__ */ n.createElement("div", { ref: this.rootRef, ...r }, a);
  }
}
export {
  tk as $,
  kk as A,
  P0 as B,
  xv as C,
  C0 as D,
  S0 as E,
  ik as F,
  Jv as G,
  Os as H,
  Tc as I,
  Uc as J,
  Qv as K,
  un as L,
  na as M,
  uk as N,
  U0 as O,
  G0 as P,
  _a as Q,
  pk as R,
  ek as S,
  nk as T,
  ak as U,
  E0 as V,
  On as W,
  h0 as X,
  Yf as Y,
  W0 as Z,
  k0 as _,
  oo as a,
  xr as a$,
  _s as a0,
  Rv as a1,
  z0 as a2,
  _k as a3,
  Vv as a4,
  Ov as a5,
  ck as a6,
  Q0 as a7,
  Z0 as a8,
  Iy as a9,
  vk as aA,
  O_ as aB,
  js as aC,
  Nk as aD,
  T0 as aE,
  jt as aF,
  r0 as aG,
  v0 as aH,
  Zv as aI,
  Sr as aJ,
  sk as aK,
  rk as aL,
  Ir as aM,
  Vf as aN,
  Bg as aO,
  qr as aP,
  Ut as aQ,
  Ak as aR,
  kr as aS,
  Qn as aT,
  Nr as aU,
  g0 as aV,
  $m as aW,
  G_ as aX,
  ra as aY,
  qi as aZ,
  Bi as a_,
  J0 as aa,
  K_ as ab,
  Y0 as ac,
  Ek as ad,
  M0 as ae,
  Yv as af,
  zv as ag,
  Gv as ah,
  P_ as ai,
  Wg as aj,
  Fv as ak,
  Wv as al,
  Hv as am,
  i0 as an,
  l0 as ao,
  o0 as ap,
  bk as aq,
  Kv as ar,
  K0 as as,
  Ha as at,
  yk as au,
  c0 as av,
  Uv as aw,
  H0 as ax,
  vr as ay,
  gk as az,
  Pv as b,
  j0 as b0,
  bp as b1,
  Il as b2,
  $0 as b3,
  Lg as b4,
  zl as b5,
  Gp as b6,
  so as b7,
  Iv as b8,
  Xl as b9,
  Br as bA,
  y0 as bB,
  ym as bC,
  f0 as bD,
  t0 as bE,
  e0 as bF,
  Xc as bG,
  n0 as bH,
  Kc as bI,
  Tr as bJ,
  B0 as bK,
  Dk as bL,
  N0 as bM,
  Qf as bN,
  q0 as bO,
  w0 as bP,
  A0 as bQ,
  D0 as bR,
  V0 as bS,
  s0 as bT,
  x0 as bU,
  $k as bV,
  Xv as bW,
  wk as bX,
  a0 as bY,
  Gt as bZ,
  mb as b_,
  wr as ba,
  fk as bb,
  fh as bc,
  _h as bd,
  Sn as be,
  Ot as bf,
  F_ as bg,
  en as bh,
  Fr as bi,
  H_ as bj,
  Fa as bk,
  _0 as bl,
  ei as bm,
  Gc as bn,
  Y_ as bo,
  Hr as bp,
  wp as bq,
  Pl as br,
  $r as bs,
  Ol as bt,
  So as bu,
  gp as bv,
  dk as bw,
  n1 as bx,
  Ft as by,
  Wr as bz,
  Gf as c,
  ok as d,
  mt as e,
  xk as f,
  b0 as g,
  Cr as h,
  hk as i,
  mk as j,
  cr as k,
  O0 as l,
  d0 as m,
  m0 as n,
  F0 as o,
  u0 as p,
  R0 as q,
  I0 as r,
  X0 as s,
  Ba as t,
  p0 as u,
  lk as v,
  zr as w,
  Rl as x,
  yp as y,
  L0 as z
};
